/**
 * A function to create a log object for the 'bookingsClientHistorySendEmail' event (evid: 213)
 *
 * Event description: send email to the customer http://prntscr.com/d54okn
 *
 * @param {bookingsClientHistorySendEmailParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} tabName - {info, history,payments}
 * @return {LogObject<bookingsClientHistorySendEmailParams>} LogObject<bookingsClientHistorySendEmailParams>
 */
export function bookingsClientHistorySendEmail(params) {
    return { evid: 213, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryTabOpened' event (evid: 215)
 *
 * Event description: -
 *
 * @param {bookingsClientHistoryTabOpenedParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} tabName - {info, history,payments}
 * @return {LogObject<bookingsClientHistoryTabOpenedParams>} LogObject<bookingsClientHistoryTabOpenedParams>
 */
export function bookingsClientHistoryTabOpened(params) {
    return { evid: 215, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClickOnCalendarSettings' event (evid: 328)
 *
 * Event description: entry point to the work hours from the calendar
 *
 * @param {bookingsClickOnCalendarSettingsParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {string} buttonMode - "extended", "collapsed"
 * @property {GUID} biToken - msid
 * @return {LogObject<bookingsClickOnCalendarSettingsParams>} LogObject<bookingsClickOnCalendarSettingsParams>
 */
export function bookingsClickOnCalendarSettings(params) {
    return { evid: 328, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffBeforeYouDeletePopup' event (evid: 184)
 *
 * Event description: opens when the user wants to delete an assigned staff- before you delete first reassign...
 *
 * @param {bookingsStaffBeforeYouDeletePopupParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @return {LogObject<bookingsStaffBeforeYouDeletePopupParams>} LogObject<bookingsStaffBeforeYouDeletePopupParams>
 */
export function bookingsStaffBeforeYouDeletePopup(params) {
    return { evid: 184, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryPersonalInfoEdit' event (evid: 210)
 *
 * Event description: sent when personal info (Client History) is changed successfully
 *
 * @param {bookingsClientHistoryPersonalInfoEditParams} params - The parameters for this event
 * @property {boolean} acquisitionChannelChanged - T=changed, F= not
 * @property {boolean} birthdayChanged - T=changed, F= not
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {boolean} cityChanged - T=changed, F= not
 * @property {boolean} emailChanged - T=changed, F= not
 * @property {boolean} firstNameChanged - T=changed, F= not
 * @property {boolean} lastNameChanged - T=changed, F= not
 * @property {GUID} biToken
 * @property {boolean} noteChanged - T=changed, F= not
 * @property {boolean} phoneChanged - T=changed, F= not
 * @property {string} section - {info, acquisition}
 * @property {boolean} zipChanged - T=changed, F= not
 * @return {LogObject<bookingsClientHistoryPersonalInfoEditParams>} LogObject<bookingsClientHistoryPersonalInfoEditParams>
 */
export function bookingsClientHistoryPersonalInfoEdit(params) {
    return { evid: 210, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsBookingsGroupSessionsNewParticipantClicked' event (evid: 248)
 *
 * Event description: When user clicks on a contact to add as a participant in the contacts list
 *
 * @param {bookingsClubsBookingsGroupSessionsNewParticipantClickedParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} msid - meta site id
 * @property {GUID} biToken
 * @return {LogObject<bookingsClubsBookingsGroupSessionsNewParticipantClickedParams>} LogObject<bookingsClubsBookingsGroupSessionsNewParticipantClickedParams>
 */
export function bookingsClubsBookingsGroupSessionsNewParticipantClicked(params) {
    return { evid: 248, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryPaymentsUpdateTransactionClick' event (evid: 214)
 *
 * Event description: update transaction click
 *
 * @param {bookingsClientHistoryPaymentsUpdateTransactionClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {boolean} isChecked - true=mark as fully paid
 * @property {string} location - {side_panel, contact_page}
 * @property {GUID} biToken
 * @property {GUID} transactionId - -
 * @return {LogObject<bookingsClientHistoryPaymentsUpdateTransactionClickParams>} LogObject<bookingsClientHistoryPaymentsUpdateTransactionClickParams>
 */
export function bookingsClientHistoryPaymentsUpdateTransactionClick(params) {
    return { evid: 214, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsGetStartedPopupOpened' event (evid: 421)
 *
 * Event description: -
 *
 * @param {bookingsGetStartedPopupOpenedParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @return {LogObject<bookingsGetStartedPopupOpenedParams>} LogObject<bookingsGetStartedPopupOpenedParams>
 */
export function bookingsGetStartedPopupOpened(params) {
    return { evid: 421, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentsOpenApplicationForm' event (evid: 191)
 *
 * Event description: application form is open, for stripe: http://prntscr.com/byox97
 *
 * @param {bookingsPaymentsOpenApplicationFormParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} paymentProvider - {stripe}
 * @return {LogObject<bookingsPaymentsOpenApplicationFormParams>} LogObject<bookingsPaymentsOpenApplicationFormParams>
 */
export function bookingsPaymentsOpenApplicationForm(params) {
    return { evid: 191, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditor6thButtonCreateNewServiceClick' event (evid: 310)
 *
 * Event description: This event is sent when the "Create first service" is clicked --> https://www.screencast.com/t/Zigj4bq6
 *
 * @param {bookingsEditor6thButtonCreateNewServiceClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {boolean} is_new - true if there are no services/no service was saved
 * @property {GUID} biToken - msid
 * @property {string} post_reg - post_reg
 * @return {LogObject<bookingsEditor6thButtonCreateNewServiceClickParams>} LogObject<bookingsEditor6thButtonCreateNewServiceClickParams>
 */
export function bookingsEditor6thButtonCreateNewServiceClick(params) {
    return { evid: 310, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryAppointmentHistorySaveNoteSuccess' event (evid: 212)
 *
 * Event description: save successfully note on Client History >  Appointment History >  add
 *
 * @param {bookingsClientHistoryAppointmentHistorySaveNoteSuccessParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {number} length - dont send!!
 * @property {GUID} biToken
 * @property {string} saveType - {new, edit}
 * @property {number} textLength - note's length - number of characters
 * @return {LogObject<bookingsClientHistoryAppointmentHistorySaveNoteSuccessParams>} LogObject<bookingsClientHistoryAppointmentHistorySaveNoteSuccessParams>
 */
export function bookingsClientHistoryAppointmentHistorySaveNoteSuccess(params) {
    return { evid: 212, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPackagesAddNewPackage' event (evid: 203)
 *
 * Event description: Add new package
 *
 * @param {bookingsPackagesAddNewPackageParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} referralInfo - {empty_state, packages_list}
 * @return {LogObject<bookingsPackagesAddNewPackageParams>} LogObject<bookingsPackagesAddNewPackageParams>
 */
export function bookingsPackagesAddNewPackage(params) {
    return { evid: 203, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneappDownloadLink' event (evid: 355)
 *
 * Event description: OneApp download link to install the app from a bookings source
 *
 * @param {bookingsOneappDownloadLinkParams} params - The parameters for this event
 * @property {string} bookingsPlatform - {new_bookings_platform}
 * @property {GUID} businessId - -
 * @property {string} location - {service_list_banner}
 * @property {GUID} biToken - -
 * @return {LogObject<bookingsOneappDownloadLinkParams>} LogObject<bookingsOneappDownloadLinkParams>
 */
export function bookingsOneappDownloadLink(params) {
    return { evid: 355, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsCheckInOutClicked' event (evid: 246)
 *
 * Event description: When user clicks on add to session button after choosing a participant.
 *
 * @param {bookingsClubsGroupSessionsCheckInOutClickedParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} msid - meta site id
 * @property {GUID} biToken
 * @property {string} value - check in / check out
 * @return {LogObject<bookingsClubsGroupSessionsCheckInOutClickedParams>} LogObject<bookingsClubsGroupSessionsCheckInOutClickedParams>
 */
export function bookingsClubsGroupSessionsCheckInOutClicked(params) {
    return { evid: 246, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsConnectCalendar' event (evid: 119)
 *
 * Event description: NOT ACTIVE - since there's no owner sync
 *
 * @param {bookingsConnectCalendarParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} referal_info - {calendar,calendar_pop}
 * @return {LogObject<bookingsConnectCalendarParams>} LogObject<bookingsConnectCalendarParams>
 */
export function bookingsConnectCalendar(params) {
    return { evid: 119, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsLeftNeviagation' event (evid: 129)
 *
 * Event description: left menu click
 *
 * @param {bookingsLeftNeviagationParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} referal_info - Not correct
 * @property {string} selection - {services, calendar, business info,I am stuck,preview,feedback,staff}
 * @return {LogObject<bookingsLeftNeviagationParams>} LogObject<bookingsLeftNeviagationParams>
 */
export function bookingsLeftNeviagation(params) {
    return { evid: 129, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffWorkingHoursChangesArenTSavedPopup' event (evid: 187)
 *
 * Event description: changes in the staff info won't be saved - error notification
 * http://prntscr.com/br1nub EVENT CANCELLED
 *
 * @param {bookingsStaffWorkingHoursChangesArenTSavedPopupParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @return {LogObject<bookingsStaffWorkingHoursChangesArenTSavedPopupParams>} LogObject<bookingsStaffWorkingHoursChangesArenTSavedPopupParams>
 */
export function bookingsStaffWorkingHoursChangesArenTSavedPopup(params) {
    return { evid: 187, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBusInfoSaveSuccess' event (evid: 102)
 *
 * Event description: send when a user finish filling business info details and save successfully
 *
 * @param {bookingsBusInfoSaveSuccessParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {boolean} business_hours_added - Did the user clicked to add an additional business hours
 * @property {number} businessHoursCounter - number of business hours sections chosen
 * @property {GUID} businessId
 * @property {number} cancellationLeadTime - cancellation_lead_time
 * @property {boolean} cancellation_policy_empty - -
 * @property {boolean} confirmation_email_empty - -
 * @property {number} leadTime - lead time hours amount
 * @property {string} location_choice - {on_going,address}
 * @property {GUID} biToken
 * @property {boolean} other_empty - -
 * @property {boolean} reminderEmailOn - TRUE\FALSE
 * @property {number} timeInterval - time interval
 * @return {LogObject<bookingsBusInfoSaveSuccessParams>} LogObject<bookingsBusInfoSaveSuccessParams>
 */
export function bookingsBusInfoSaveSuccess(params) {
    return { evid: 102, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientVmRequestOwner' event (evid: 221)
 *
 * Event description: when a service is saved in the business first funnel
 *
 * @param {bookingsClientVmRequestOwnerParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {number} duration - duration
 * @property {boolean} isVideo - true = the service offered online else false
 * @property {string} loaction - business_location / client's_place / custom_location /
 * @property {string} locationText - location_text
 * @property {GUID} biToken
 * @property {string} priceOptions - no_fee / custom / fix
 * @property {string} price_selection - if fixed - amount, if custom - text
 * @property {GUID} serviceId - service_id
 * @property {string} service_title - service_title
 * @property {string} structureId - structure_id
 * @property {string} type - class/course/appointment
 * @return {LogObject<bookingsClientVmRequestOwnerParams>} LogObject<bookingsClientVmRequestOwnerParams>
 */
export function bookingsClientVmRequestOwner(params) {
    return { evid: 221, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppChooseParticipantFromTheList' event (evid: 292)
 *
 * Event description: After choosing a time slot - choose a participant to add
 *
 * @param {bookingsOneAppChooseParticipantFromTheListParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} origin - {owner_flow,member_flow}
 * @property {GUID} service_id - service_id
 * @property {string} type - service type
 * @return {LogObject<bookingsOneAppChooseParticipantFromTheListParams>} LogObject<bookingsOneAppChooseParticipantFromTheListParams>
 */
export function bookingsOneAppChooseParticipantFromTheList(params) {
    return { evid: 292, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetMemberLoginToggle' event (evid: 229)
 *
 * Event description: app_set.member area. checkbox (instead of toggle) http://prntscr.com/de2t2n
 *
 * @param {bookingsAppSetMemberLoginToggleParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {boolean} isPreview
 * @property {GUID} biToken
 * @property {boolean} toggle - T= activated\enable, F=disable
 * @return {LogObject<bookingsAppSetMemberLoginToggleParams>} LogObject<bookingsAppSetMemberLoginToggleParams>
 */
export function bookingsAppSetMemberLoginToggle(params) {
    return { evid: 229, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsHelp' event (evid: 104)
 *
 * Event description: Help
 *
 * @param {bookingsHelpParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {string} location - {left menu, top right}
 * @property {GUID} biToken
 * @property {string} referal_info - {get_started,add_service,services_list, calendar, business_info,confirm_page,help_1,help_2}
 * @property {string} referral_info - -
 * @return {LogObject<bookingsHelpParams>} LogObject<bookingsHelpParams>
 */
export function bookingsHelp(params) {
    return { evid: 104, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsTimeZoneDiscrepancy' event (evid: 1014)
 *
 * Event description: This event is reported when there is a discrepancy between the business timezone and the user/uou timezone when calendar loads or when uou tries to book
 *
 * @param {bookingsTimeZoneDiscrepancyParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {string} contact_id - optional
 * @property {string} local_date_time - -
 * @property {GUID} biToken
 * @property {string} source - Server/BO
 * @property {string} timezone - timezone on which there was a discrepancy
 * @property {number} timestamp - epoch time
 * @return {LogObject<bookingsTimeZoneDiscrepancyParams>} LogObject<bookingsTimeZoneDiscrepancyParams>
 */
export function bookingsTimeZoneDiscrepancy(params) {
    return { evid: 1014, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppPackagesPopup' event (evid: 320)
 *
 * Event description: https://www.screencast.com/t/UuqhF8LKdd2e
 *
 * @param {bookingsOneAppPackagesPopupParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} referralInfo - {modify plan}
 * @return {LogObject<bookingsOneAppPackagesPopupParams>} LogObject<bookingsOneAppPackagesPopupParams>
 */
export function bookingsOneAppPackagesPopup(params) {
    return { evid: 320, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditor6thButtonClick' event (evid: 181)
 *
 * Event description: click on bookings 6th button in the editor
 *
 * @param {bookingsEditor6thButtonClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {string} category - irellevant
 * @property {string} editor_working_mode - i.e. preview
 * @property {GUID} esi - esi
 * @property {GUID} biToken
 * @property {string} post_reg - post_reg category
 * @property {string} state - {post_provision, marketing_state_add_now, marketing_state_get_started}
 * @property {number} ts - ts
 * @return {LogObject<bookingsEditor6thButtonClickParams>} LogObject<bookingsEditor6thButtonClickParams>
 */
export function bookingsEditor6thButtonClick(params) {
    return { evid: 181, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsClickSessionDetails' event (evid: 267)
 *
 * Event description: When user clicks to see the session details (purple header)
 *
 * @param {bookingsClubsGroupSessionsClickSessionDetailsParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business id
 * @property {GUID} msid - meta site id
 * @property {GUID} biToken
 * @return {LogObject<bookingsClubsGroupSessionsClickSessionDetailsParams>} LogObject<bookingsClubsGroupSessionsClickSessionDetailsParams>
 */
export function bookingsClubsGroupSessionsClickSessionDetails(params) {
    return { evid: 267, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesKeyboardClickOnViewAllServices' event (evid: 335)
 *
 * Event description: when clicking on the "view all" button (with the dots) in the keboard
 *
 * @param {bookingsServicesKeyboardClickOnViewAllServicesParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} service_id - service_id
 * @property {string} type - service type
 * @return {LogObject<bookingsServicesKeyboardClickOnViewAllServicesParams>} LogObject<bookingsServicesKeyboardClickOnViewAllServicesParams>
 */
export function bookingsServicesKeyboardClickOnViewAllServices(params) {
    return { evid: 335, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPackagesPackageSaveSuccess' event (evid: 206)
 *
 * Event description: sent when a user save a package successfully
 *
 * @param {bookingsPackagesPackageSaveSuccessParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {number} depositAmount - if not edited at all by the user= NULL. Multiplied by 10000
 * @property {boolean} descriptionEmpty - T=description empty , F= not empty
 * @property {GUID} biToken
 * @property {number} packagePrice - Multiplied by 10000
 * @property {number} packageValue - Multiplied by 10000
 * @property {string} paymentMethod - {online_only, offline_only,both}
 * @property {boolean} photoEmpty - T=photo empty , F= not empty
 * @property {boolean} promotionalTextEmpty - T=promotional_text empty , F= not empty
 * @property {number} quantity - quantity
 * @property {string} serviceId - service connected to package
 * @return {LogObject<bookingsPackagesPackageSaveSuccessParams>} LogObject<bookingsPackagesPackageSaveSuccessParams>
 */
export function bookingsPackagesPackageSaveSuccess(params) {
    return { evid: 206, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsClickManage' event (evid: 247)
 *
 * Event description: When a user clicks on manage in the bookings group session details page.
 *
 * @param {bookingsClubsGroupSessionsClickManageParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} msid - meta site id
 * @property {GUID} biToken
 * @return {LogObject<bookingsClubsGroupSessionsClickManageParams>} LogObject<bookingsClubsGroupSessionsClickManageParams>
 */
export function bookingsClubsGroupSessionsClickManage(params) {
    return { evid: 247, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryPaymentsUpdateTransaction' event (evid: 216)
 *
 * Event description: update transaction successfully
 *
 * @param {bookingsClientHistoryPaymentsUpdateTransactionParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {number} depositAmount - multiplied by 10000
 * @property {GUID} biToken
 * @property {string} paymentMethod - {cash,credit_card...}
 * @property {number} price - multiplied by 10000
 * @property {GUID} serviceId - service of the payments
 * @property {GUID} staffId - staff member providing the service
 * @property {GUID} transactionId - -
 * @return {LogObject<bookingsClientHistoryPaymentsUpdateTransactionParams>} LogObject<bookingsClientHistoryPaymentsUpdateTransactionParams>
 */
export function bookingsClientHistoryPaymentsUpdateTransaction(params) {
    return { evid: 216, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarExportClick' event (evid: 368)
 *
 * Event description: Clicking on the button that opens the dropdown list. https://zpl.io/2pAev7j
 *
 * @param {bookingsCalendarExportClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform - Null if old platform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @return {LogObject<bookingsCalendarExportClickParams>} LogObject<bookingsCalendarExportClickParams>
 */
export function bookingsCalendarExportClick(params) {
    return { evid: 368, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditor6thButtonManageBookingsClick' event (evid: 183)
 *
 * Event description: when the users clicks on bookings 6th button AFTER provision a popup opens - this event is sent when the "manage bookings" is clicked --> opens BO NOT SENT
 *
 * @param {bookingsEditor6thButtonManageBookingsClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @return {LogObject<bookingsEditor6thButtonManageBookingsClickParams>} LogObject<bookingsEditor6thButtonManageBookingsClickParams>
 */
export function bookingsEditor6thButtonManageBookingsClick(params) {
    return { evid: 183, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicePageCourseConfirmChangeInVcLink' event (evid: 465)
 *
 * Event description: Sent when a user tries to edit VC link of a course
 *
 * @param {bookingsServicePageCourseConfirmChangeInVcLinkParams} params - The parameters for this event
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {boolean} notifyChecked - if the user chose to notify booked uou
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsServicePageCourseConfirmChangeInVcLinkParams>} LogObject<bookingsServicePageCourseConfirmChangeInVcLinkParams>
 */
export function bookingsServicePageCourseConfirmChangeInVcLink(params) {
    return { evid: 465, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsNotUsedConnectPaymentProviderNotAvailableOnPreviewPopup' event (evid: 563)
 *
 * Event description: popup appears - http://prntscr.com/gbmeky
 *
 * @param {bookingsNotUsedConnectPaymentProviderNotAvailableOnPreviewPopupParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @return {LogObject<bookingsNotUsedConnectPaymentProviderNotAvailableOnPreviewPopupParams>} LogObject<bookingsNotUsedConnectPaymentProviderNotAvailableOnPreviewPopupParams>
 */
export function bookingsNotUsedConnectPaymentProviderNotAvailableOnPreviewPopup(params) {
    return { evid: 563, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPackagesSavePackageClick' event (evid: 205)
 *
 * Event description: save package click
 *
 * @param {bookingsPackagesSavePackageClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {boolean} packageNameEmpty - T=package name empty , F= not empty
 * @property {boolean} priceEmpty - T=price empty , F= not empty
 * @property {boolean} sreviceEmpty - NOT SENT!
 * @property {boolean} serviceNameEmpty - T=service name empty , F= not empty
 * @return {LogObject<bookingsPackagesSavePackageClickParams>} LogObject<bookingsPackagesSavePackageClickParams>
 */
export function bookingsPackagesSavePackageClick(params) {
    return { evid: 205, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryPagination' event (evid: 217)
 *
 * Event description: Pagination
 *
 * @param {bookingsClientHistoryPaginationParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {boolean} isSearch - Pagination cased from Pagination?
 * @property {GUID} biToken
 * @property {string} next - from this record the next page will start loading -NOT SENT
 * @property {string} pageName - {Appointment-history, Customer-list, Payment-closed transaction}
 * @property {number} pageSize - -
 * @return {LogObject<bookingsClientHistoryPaginationParams>} LogObject<bookingsClientHistoryPaginationParams>
 */
export function bookingsClientHistoryPagination(params) {
    return { evid: 217, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClickOnEditCalendarSettings' event (evid: 329)
 *
 * Event description: entry point to edit availability and staff hours
 *
 * @param {bookingsClickOnEditCalendarSettingsParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {string} calendarEditType - "availability", "staff"
 * @property {GUID} biToken - msid
 * @return {LogObject<bookingsClickOnEditCalendarSettingsParams>} LogObject<bookingsClickOnEditCalendarSettingsParams>
 */
export function bookingsClickOnEditCalendarSettings(params) {
    return { evid: 329, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsMeTabCheckInDoneClicked' event (evid: 254)
 *
 * Event description: When user click on done button after check in
 *
 * @param {bookingsClubsMeTabCheckInDoneClickedParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} msid - meta site id
 * @property {GUID} biToken
 * @return {LogObject<bookingsClubsMeTabCheckInDoneClickedParams>} LogObject<bookingsClubsMeTabCheckInDoneClickedParams>
 */
export function bookingsClubsMeTabCheckInDoneClicked(params) {
    return { evid: 254, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCreateWaiverClick' event (evid: 632)
 *
 * Event description: Click on "create waiver" in the manage participants page
 *
 * @param {bookingsCreateWaiverClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform - -
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} serviceId - -
 * @property {string} sessionId - -
 * @return {LogObject<bookingsCreateWaiverClickParams>} LogObject<bookingsCreateWaiverClickParams>
 */
export function bookingsCreateWaiverClick(params) {
    return { evid: 632, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppAddBookingClickDummyButton' event (evid: 223)
 *
 * Event description: add bookings (plus click)- currently unavailable
 *
 * @param {bookingsOneAppAddBookingClickDummyButtonParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @return {LogObject<bookingsOneAppAddBookingClickDummyButtonParams>} LogObject<bookingsOneAppAddBookingClickDummyButtonParams>
 */
export function bookingsOneAppAddBookingClickDummyButton(params) {
    return { evid: 223, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsVideoTutorialsLoadVideoOffer' event (evid: 645)
 *
 * Event description: View of a dealer component
 *
 * @param {bookingsVideoTutorialsLoadVideoOfferParams} params - The parameters for this event
 * @property {string} bookingsPlatform - _
 * @property {GUID} businessId - _
 * @property {string} jsonData - json
 * @property {string} locationOnPage - {main,accordion_first,accordion_second,accordion_third}
 * @property {GUID} biToken
 * @property {string} pageName - service_page
 * @property {string} serviceId - --
 * @property {string} videoId - the suggested video id
 * @return {LogObject<bookingsVideoTutorialsLoadVideoOfferParams>} LogObject<bookingsVideoTutorialsLoadVideoOfferParams>
 */
export function bookingsVideoTutorialsLoadVideoOffer(params) {
    return { evid: 645, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppManageAppointmentClick' event (evid: 304)
 *
 * Event description: http://prntscr.com/dcret7
 *
 * @param {bookingsOneAppManageAppointmentClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} type - appointment type - {individual,groups}
 * @return {LogObject<bookingsOneAppManageAppointmentClickParams>} LogObject<bookingsOneAppManageAppointmentClickParams>
 */
export function bookingsOneAppManageAppointmentClick(params) {
    return { evid: 304, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryAddNewCustomer' event (evid: 200)
 *
 * Event description: Add new customer
 *
 * @param {bookingsClientHistoryAddNewCustomerParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {string} location - {empty state, customer list, empty_state_top_right}
 * @property {GUID} biToken
 * @return {LogObject<bookingsClientHistoryAddNewCustomerParams>} LogObject<bookingsClientHistoryAddNewCustomerParams>
 */
export function bookingsClientHistoryAddNewCustomer(params) {
    return { evid: 200, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistorySort' event (evid: 209)
 *
 * Event description: sort on  Client History > Customer List http://prntscr.com/d53ijc
 *
 * @param {bookingsClientHistorySortParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {string} direction - {Desc, Asc}
 * @property {GUID} biToken
 * @property {string} referralInfo - {payments, customers_list}
 * @property {string} sortBy - {name,last_appointment,next_appointment, appointment_date_open_trans, appointment_date_closed_trans, staff_member_closed_trans,staff_member_open_trans }
 * @return {LogObject<bookingsClientHistorySortParams>} LogObject<bookingsClientHistorySortParams>
 */
export function bookingsClientHistorySort(params) {
    return { evid: 209, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClickOnAddToWaitlistFromEmptyState' event (evid: 352)
 *
 * Event description: Click on "Add to Waitlist" from the waiting list empty state
 *
 * @param {bookingsClickOnAddToWaitlistFromEmptyStateParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} origin - session card/member card
 * @property {string} serviceId - -
 * @property {string} triggerBy - Owner/Member
 * @property {string} value - Add/Remove
 * @return {LogObject<bookingsClickOnAddToWaitlistFromEmptyStateParams>} LogObject<bookingsClickOnAddToWaitlistFromEmptyStateParams>
 */
export function bookingsClickOnAddToWaitlistFromEmptyState(params) {
    return { evid: 352, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetMemberLoginDetailsClick' event (evid: 230)
 *
 * Event description: http://prntscr.com/de2sxd
 *
 * @param {bookingsAppSetMemberLoginDetailsClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {boolean} isPreview - T/F
 * @property {GUID} biToken
 * @return {LogObject<bookingsAppSetMemberLoginDetailsClickParams>} LogObject<bookingsAppSetMemberLoginDetailsClickParams>
 */
export function bookingsAppSetMemberLoginDetailsClick(params) {
    return { evid: 230, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryAppointmentHistoryAddNoteClick' event (evid: 211)
 *
 * Event description: click on Client History >  Appointment History >  add note http://prntscr.com/d5487g
 *
 * @param {bookingsClientHistoryAppointmentHistoryAddNoteClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @return {LogObject<bookingsClientHistoryAppointmentHistoryAddNoteClickParams>} LogObject<bookingsClientHistoryAppointmentHistoryAddNoteClickParams>
 */
export function bookingsClientHistoryAppointmentHistoryAddNoteClick(params) {
    return { evid: 211, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsSelfCheckInNameClicked' event (evid: 260)
 *
 * Event description: When user clicks on a name in the name search list.
 *
 * @param {bookingsClubsGroupSessionsSelfCheckInNameClickedParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} msid - meta site id
 * @property {GUID} biToken
 * @property {DateTime} time_to_session - time to session  that appear on screen
 * @return {LogObject<bookingsClubsGroupSessionsSelfCheckInNameClickedParams>} LogObject<bookingsClubsGroupSessionsSelfCheckInNameClickedParams>
 */
export function bookingsClubsGroupSessionsSelfCheckInNameClicked(params) {
    return { evid: 260, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsSelfCheckInTurnOnClicked' event (evid: 258)
 *
 * Event description: When user clicks on turn on in the self check in screen
 *
 * @param {bookingsClubsGroupSessionsSelfCheckInTurnOnClickedParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} msid - meta site id
 * @property {GUID} biToken
 * @return {LogObject<bookingsClubsGroupSessionsSelfCheckInTurnOnClickedParams>} LogObject<bookingsClubsGroupSessionsSelfCheckInTurnOnClickedParams>
 */
export function bookingsClubsGroupSessionsSelfCheckInTurnOnClicked(params) {
    return { evid: 258, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsSelfCheckInClicked' event (evid: 257)
 *
 * Event description: When user clicks on self checkin in the group session screen
 *
 * @param {bookingsClubsGroupSessionsSelfCheckInClickedParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} msid - meta site id
 * @property {GUID} biToken
 * @return {LogObject<bookingsClubsGroupSessionsSelfCheckInClickedParams>} LogObject<bookingsClubsGroupSessionsSelfCheckInClickedParams>
 */
export function bookingsClubsGroupSessionsSelfCheckInClicked(params) {
    return { evid: 257, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSaveBusinessInfo' event (evid: 139)
 *
 * Event description: save business info click
 *
 * @param {bookingsSaveBusinessInfoParams} params - The parameters for this event
 * @property {boolean} appt_unit_empty - -
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {boolean} business_name_empty - -
 * @property {boolean} cancellation_policy_empty
 * @property {boolean} city_empty - -
 * @property {boolean} email_empty - -
 * @property {string} errorReason - if null- success
 * @property {string} location_choice - {on_going, address}
 * @property {GUID} biToken
 * @property {boolean} other_empty - -
 * @property {boolean} phone_empty - -
 * @property {string} section - {business_details,business_hours, scheduling_policies_confirmation_email}
 * @property {boolean} street_empty - -
 * @property {boolean} zip_empty - -
 * @return {LogObject<bookingsSaveBusinessInfoParams>} LogObject<bookingsSaveBusinessInfoParams>
 */
export function bookingsSaveBusinessInfo(params) {
    return { evid: 139, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarPickDate' event (evid: 220)
 *
 * Event description: http://prntscr.com/dcfq20
 *
 * @param {bookingsCalendarPickDateParams} params - The parameters for this event
 * @property {string} bookingsPlatform - new_bookings_server
 * @property {GUID} businessId
 * @property {DateTime} endTime
 * @property {string} filterName - []
 * @property {GUID} biToken
 * @property {string} pageName - page name. example bookings list
 * @property {string} period
 * @property {boolean} preDefinedPeriod
 * @property {DateTime} startTime
 * @return {LogObject<bookingsCalendarPickDateParams>} LogObject<bookingsCalendarPickDateParams>
 */
export function bookingsCalendarPickDate(params) {
    return { evid: 220, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAddWidgetClick' event (evid: 207)
 *
 * Event description: bookings > add_widget     http://prntscr.com/d492w3
 *
 * @param {bookingsAddWidgetClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {boolean} isPreview
 * @property {GUID} biToken
 * @return {LogObject<bookingsAddWidgetClickParams>} LogObject<bookingsAddWidgetClickParams>
 */
export function bookingsAddWidgetClick(params) {
    return { evid: 207, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryImportCustomersClick' event (evid: 201)
 *
 * Event description: import customers click
 *
 * @param {bookingsClientHistoryImportCustomersClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {string} location - {empty state, customer list}
 * @property {GUID} biToken
 * @return {LogObject<bookingsClientHistoryImportCustomersClickParams>} LogObject<bookingsClientHistoryImportCustomersClickParams>
 */
export function bookingsClientHistoryImportCustomersClick(params) {
    return { evid: 201, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMemberAppViewFitBanner' event (evid: 497)
 *
 * Event description: Owner viewed Fit banner on one of the member apps
 *
 * @param {bookingsMemberAppViewFitBannerParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @return {LogObject<bookingsMemberAppViewFitBannerParams>} LogObject<bookingsMemberAppViewFitBannerParams>
 */
export function bookingsMemberAppViewFitBanner(params) {
    return { evid: 497, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistorySaveCustomerSuccess' event (evid: 199)
 *
 * Event description: sent when a user save a customer successfully
 *
 * @param {bookingsClientHistorySaveCustomerSuccessParams} params - The parameters for this event
 * @property {string} acquisitionChannel - {friend,site,fb..}
 * @property {boolean} birthdayFilled - T=filled, F= empty
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {boolean} cityFilled - T=filled, F= empty
 * @property {number} filesAttached - 0=NULL
 * @property {GUID} biToken
 * @property {boolean} noteAdded - T= yes, F- no( empty)
 * @property {string} saveType - Always NEW! No need to filter
 * @property {boolean} streetFilled - T=filled, F= empty
 * @property {boolean} zipFilled - T=filled, F= empty
 * @return {LogObject<bookingsClientHistorySaveCustomerSuccessParams>} LogObject<bookingsClientHistorySaveCustomerSuccessParams>
 */
export function bookingsClientHistorySaveCustomerSuccess(params) {
    return { evid: 199, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarStaffFilterClick' event (evid: 420)
 *
 * Event description: http://prntscr.com/ggwtev
 *
 * @param {bookingsCalendarStaffFilterClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @return {LogObject<bookingsCalendarStaffFilterClickParams>} LogObject<bookingsCalendarStaffFilterClickParams>
 */
export function bookingsCalendarStaffFilterClick(params) {
    return { evid: 420, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditPanelTabPosition' event (evid: 178)
 *
 * Event description: -
 *
 * @param {bookingsEditPanelTabPositionParams} params - The parameters for this event
 * @property {string} appName - -
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {boolean} isOpened - TRUE for expend, FALSE for collapse
 * @property {GUID} biToken
 * @property {string} panelName - {private_service_list...}
 * @property {string} selection - {private_first.group_first}
 * @return {LogObject<bookingsEditPanelTabPositionParams>} LogObject<bookingsEditPanelTabPositionParams>
 */
export function bookingsEditPanelTabPosition(params) {
    return { evid: 178, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormLocationSettingsModalTouchField' event (evid: 631)
 *
 * Event description: This event describes touch of fields in the location settings modal.
 *
 * @param {bookingsServiceFormLocationSettingsModalTouchFieldParams} params - The parameters for this event
 * @property {string} bookingsPlatform - -
 * @property {GUID} businessId - -
 * @property {string} fieldName - {type/choose_business_locations/describe}
 * @property {GUID} biToken - msid
 * @property {string} type - {ind, class, course}
 * @return {LogObject<bookingsServiceFormLocationSettingsModalTouchFieldParams>} LogObject<bookingsServiceFormLocationSettingsModalTouchFieldParams>
 */
export function bookingsServiceFormLocationSettingsModalTouchField(params) {
    return { evid: 631, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppClickCompleteYourBookingMembershipFlow' event (evid: 309)
 *
 * Event description: bookings-->one app--> Click "Complete your Booking" (membership flow)
 *
 * @param {bookingsOneAppClickCompleteYourBookingMembershipFlowParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} serviceId - serviceId
 * @property {string} type - service type - {individual, groups}
 * @return {LogObject<bookingsOneAppClickCompleteYourBookingMembershipFlowParams>} LogObject<bookingsOneAppClickCompleteYourBookingMembershipFlowParams>
 */
export function bookingsOneAppClickCompleteYourBookingMembershipFlow(params) {
    return { evid: 309, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsViewAppointmentFromContactsInbox' event (evid: 312)
 *
 * Event description: click on "view appointment" from contacts inbox
 *
 * @param {bookingsViewAppointmentFromContactsInboxParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} serviceId - service_id
 * @property {string} type - service type
 * @property {GUID} customer_id - -
 * @return {LogObject<bookingsViewAppointmentFromContactsInboxParams>} LogObject<bookingsViewAppointmentFromContactsInboxParams>
 */
export function bookingsViewAppointmentFromContactsInbox(params) {
    return { evid: 312, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppChooseATimeSlot' event (evid: 291)
 *
 * Event description: After choosing a service from the list - choose a time slot
 *
 * @param {bookingsOneAppChooseATimeSlotParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} origin - {owner_flow,member_flow}
 * @property {GUID} service_id - service_id
 * @property {string} type - service type
 * @return {LogObject<bookingsOneAppChooseATimeSlotParams>} LogObject<bookingsOneAppChooseATimeSlotParams>
 */
export function bookingsOneAppChooseATimeSlot(params) {
    return { evid: 291, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistorySaveCustomerClick' event (evid: 198)
 *
 * Event description: save cusomer click
 *
 * @param {bookingsClientHistorySaveCustomerClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {boolean} emailFilled - T=filled, F= empty
 * @property {boolean} firstNameFilled - T=filled, F= empty
 * @property {boolean} lastNameFilled - T=filled, F= empty
 * @property {GUID} biToken
 * @property {boolean} phoneFilled - T=filled, F= empty
 * @return {LogObject<bookingsClientHistorySaveCustomerClickParams>} LogObject<bookingsClientHistorySaveCustomerClickParams>
 */
export function bookingsClientHistorySaveCustomerClick(params) {
    return { evid: 198, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppGroupSessionSeeAllParticipantsClick' event (evid: 305)
 *
 * Event description: http://prntscr.com/dcrjl0
 *
 * @param {bookingsOneAppGroupSessionSeeAllParticipantsClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @return {LogObject<bookingsOneAppGroupSessionSeeAllParticipantsClickParams>} LogObject<bookingsOneAppGroupSessionSeeAllParticipantsClickParams>
 */
export function bookingsOneAppGroupSessionSeeAllParticipantsClick(params) {
    return { evid: 305, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBusinessNotificationsEditCllck' event (evid: 384)
 *
 * Event description: Click on business notifications edit CTA in bookings settings
 * https://zpl.io/a79A8RK
 *
 * @param {bookingsBusinessNotificationsEditCllckParams} params - The parameters for this event
 * @property {string} bookingsPlatform - new_bookings_platform
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} type - business_notifications
 * @return {LogObject<bookingsBusinessNotificationsEditCllckParams>} LogObject<bookingsBusinessNotificationsEditCllckParams>
 */
export function bookingsBusinessNotificationsEditCllck(params) {
    return { evid: 384, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsGroupsServiceNotificationUndo' event (evid: 413)
 *
 * Event description: http://prntscr.com/fc074a
 *
 * @param {bookingsGroupsServiceNotificationUndoParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} service_id - -
 * @return {LogObject<bookingsGroupsServiceNotificationUndoParams>} LogObject<bookingsGroupsServiceNotificationUndoParams>
 */
export function bookingsGroupsServiceNotificationUndo(params) {
    return { evid: 413, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesKeyboardClickOnBookIt' event (evid: 337)
 *
 * Event description: when clicking on the "book Now" button in the chat after sending the service to the user
 *
 * @param {bookingsServicesKeyboardClickOnBookItParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} service_id - service_id
 * @property {string} type - service type
 * @return {LogObject<bookingsServicesKeyboardClickOnBookItParams>} LogObject<bookingsServicesKeyboardClickOnBookItParams>
 */
export function bookingsServicesKeyboardClickOnBookIt(params) {
    return { evid: 337, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppChooseAServiceFromTheList' event (evid: 290)
 *
 * Event description: After clicking to add a session - choose from current options
 *
 * @param {bookingsOneAppChooseAServiceFromTheListParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} origin - {owner_flow,member_flow}
 * @property {GUID} service_id - service_id
 * @property {string} type - service type
 * @return {LogObject<bookingsOneAppChooseAServiceFromTheListParams>} LogObject<bookingsOneAppChooseAServiceFromTheListParams>
 */
export function bookingsOneAppChooseAServiceFromTheList(params) {
    return { evid: 290, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppPackagesPopupClick' event (evid: 321)
 *
 * Event description: https://www.screencast.com/t/UuqhF8LKdd2e
 *
 * @param {bookingsOneAppPackagesPopupClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} referralInfo - {modify plan}
 * @property {string} selection - {no thanks, notify}
 * @return {LogObject<bookingsOneAppPackagesPopupClickParams>} LogObject<bookingsOneAppPackagesPopupClickParams>
 */
export function bookingsOneAppPackagesPopupClick(params) {
    return { evid: 321, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentsReturnFromApplicationForm' event (evid: 192)
 *
 * Event description: return from application formto bookings , for stripe: http://prntscr.com/byox97
 *
 * @param {bookingsPaymentsReturnFromApplicationFormParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} paymentProvider - {stripe}
 * @property {boolean} success - T=connected, F=not connected
 * @return {LogObject<bookingsPaymentsReturnFromApplicationFormParams>} LogObject<bookingsPaymentsReturnFromApplicationFormParams>
 */
export function bookingsPaymentsReturnFromApplicationForm(params) {
    return { evid: 192, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppParticipantClick' event (evid: 303)
 *
 * Event description: http://prntscr.com/dcrg9g
 *
 * @param {bookingsOneAppParticipantClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} origin - {view all list, appointment page}
 * @return {LogObject<bookingsOneAppParticipantClickParams>} LogObject<bookingsOneAppParticipantClickParams>
 */
export function bookingsOneAppParticipantClick(params) {
    return { evid: 303, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryCustomerClick' event (evid: 231)
 *
 * Event description: cusomer click (on customer list)- http://prntscr.com/dtw0ez
 *
 * @param {bookingsClientHistoryCustomerClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @return {LogObject<bookingsClientHistoryCustomerClickParams>} LogObject<bookingsClientHistoryCustomerClickParams>
 */
export function bookingsClientHistoryCustomerClick(params) {
    return { evid: 231, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetServiceOrMultiService' event (evid: 318)
 *
 * Event description: settings - select a single service to display or multiple services
 *
 * @param {bookingsAppSetServiceOrMultiServiceParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {boolean} isPreview - -
 * @property {GUID} biToken - -
 * @property {string} referralInfo - {service_list, widget}
 * @property {string} selection - {single_service, multi_services}
 * @return {LogObject<bookingsAppSetServiceOrMultiServiceParams>} LogObject<bookingsAppSetServiceOrMultiServiceParams>
 */
export function bookingsAppSetServiceOrMultiService(params) {
    return { evid: 318, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsWelcomePopupVideoLoad' event (evid: 252)
 *
 * Event description: http://prntscr.com/p9cfs4
 *
 * @param {bookingsWelcomePopupVideoLoadParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} video_name - {fitness_video}
 * @return {LogObject<bookingsWelcomePopupVideoLoadParams>} LogObject<bookingsWelcomePopupVideoLoadParams>
 */
export function bookingsWelcomePopupVideoLoad(params) {
    return { evid: 252, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPremiumRibbonAppears' event (evid: 237)
 *
 * Event description: http://prntscr.com/fc074a
 *
 * @param {bookingsPremiumRibbonAppearsParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} premiumStatus - {free, non_bookings_premium}
 * @property {string} referralInfo - {group,payment}
 * @return {LogObject<bookingsPremiumRibbonAppearsParams>} LogObject<bookingsPremiumRibbonAppearsParams>
 */
export function bookingsPremiumRibbonAppears(params) {
    return { evid: 237, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsContactPanelQuickActionsScheduleASession' event (evid: 311)
 *
 * Event description: click on "schedule a session" from the contact panel quick actions - opens the Bookings calendar
 *
 * @param {bookingsContactPanelQuickActionsScheduleASessionParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {GUID} customer_id - -
 * @return {LogObject<bookingsContactPanelQuickActionsScheduleASessionParams>} LogObject<bookingsContactPanelQuickActionsScheduleASessionParams>
 */
export function bookingsContactPanelQuickActionsScheduleASession(params) {
    return { evid: 311, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClientHistoryCustomerListSearch' event (evid: 208)
 *
 * Event description: search on  Client History > Customer List http://prntscr.com/d53ggr
 *
 * @param {bookingsClientHistoryCustomerListSearchParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} searchBy - {name,email,phone}
 * @return {LogObject<bookingsClientHistoryCustomerListSearchParams>} LogObject<bookingsClientHistoryCustomerListSearchParams>
 */
export function bookingsClientHistoryCustomerListSearch(params) {
    return { evid: 208, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppAppointmentPageVisitorActions' event (evid: 302)
 *
 * Event description: http://prntscr.com/dcrh8z
 *
 * @param {bookingsOneAppAppointmentPageVisitorActionsParams} params - The parameters for this event
 * @property {string} action - {message, call}
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @return {LogObject<bookingsOneAppAppointmentPageVisitorActionsParams>} LogObject<bookingsOneAppAppointmentPageVisitorActionsParams>
 */
export function bookingsOneAppAppointmentPageVisitorActions(params) {
    return { evid: 302, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentSettingsClickAcceptPayment' event (evid: 397)
 *
 * Event description: User clicked accept payment link from payment settings in service form
 *
 * @param {bookingsPaymentSettingsClickAcceptPaymentParams} params - The parameters for this event
 * @property {string} bookingsPlatform - []
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @return {LogObject<bookingsPaymentSettingsClickAcceptPaymentParams>} LogObject<bookingsPaymentSettingsClickAcceptPaymentParams>
 */
export function bookingsPaymentSettingsClickAcceptPayment(params) {
    return { evid: 397, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppSendBroadcastMessageToParticipantsInAClass' event (evid: 342)
 *
 * Event description: After typing the message, clicking on "send". https://www.screencast.com/t/Knk8jrxX
 *
 * @param {bookingsOneAppSendBroadcastMessageToParticipantsInAClassParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {number} messageLength - num characters in message
 * @property {GUID} biToken - msid
 * @property {number} numParticipants - how many participants will receive the message
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsOneAppSendBroadcastMessageToParticipantsInAClassParams>} LogObject<bookingsOneAppSendBroadcastMessageToParticipantsInAClassParams>
 */
export function bookingsOneAppSendBroadcastMessageToParticipantsInAClass(params) {
    return { evid: 342, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsSelfCheckInCancelClicked' event (evid: 259)
 *
 * Event description: When user clicks on cancel in the self check in screen
 *
 * @param {bookingsClubsGroupSessionsSelfCheckInCancelClickedParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} msid - meta site id
 * @property {GUID} biToken
 * @return {LogObject<bookingsClubsGroupSessionsSelfCheckInCancelClickedParams>} LogObject<bookingsClubsGroupSessionsSelfCheckInCancelClickedParams>
 */
export function bookingsClubsGroupSessionsSelfCheckInCancelClicked(params) {
    return { evid: 259, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffClickOnDeleteIcon' event (evid: 331)
 *
 * Event description: when the user clicks on the garbage can icon in the staff page. https://screencast.com/t/YBsumDwswGes
 *
 * @param {bookingsStaffClickOnDeleteIconParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} referal_info - -
 * @property {string} staffid - -
 * @return {LogObject<bookingsStaffClickOnDeleteIconParams>} LogObject<bookingsStaffClickOnDeleteIconParams>
 */
export function bookingsStaffClickOnDeleteIcon(params) {
    return { evid: 331, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesRenameStaffSucess' event (evid: 219)
 *
 * Event description: http://prntscr.com/ddj218
 *
 * @param {bookingsServicesRenameStaffSucessParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} type - {private,group}
 * @return {LogObject<bookingsServicesRenameStaffSucessParams>} LogObject<bookingsServicesRenameStaffSucessParams>
 */
export function bookingsServicesRenameStaffSucess(params) {
    return { evid: 219, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPackagesCreateServiceFirstPopupOpen' event (evid: 204)
 *
 * Event description: create service first popup. open  http://prntscr.com/d44vpb
 *
 * @param {bookingsPackagesCreateServiceFirstPopupOpenParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @return {LogObject<bookingsPackagesCreateServiceFirstPopupOpenParams>} LogObject<bookingsPackagesCreateServiceFirstPopupOpenParams>
 */
export function bookingsPackagesCreateServiceFirstPopupOpen(params) {
    return { evid: 204, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppFullCalendarViewClick' event (evid: 288)
 *
 * Event description: Click on the button to access the full calendar
 *
 * @param {bookingsOneAppFullCalendarViewClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} referral_info - {one_app_service_list, one_app_quick_action}
 * @return {LogObject<bookingsOneAppFullCalendarViewClickParams>} LogObject<bookingsOneAppFullCalendarViewClickParams>
 */
export function bookingsOneAppFullCalendarViewClick(params) {
    return { evid: 288, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppContinueBroadcast100People' event (evid: 343)
 *
 * Event description: Click on "continue" after choosing to send a broadcast to > 100 people. https://www.screencast.com/t/8AVcH3GYL0
 *
 * @param {bookingsOneAppContinueBroadcast100PeopleParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {number} numParticipants - how many participants will receive the message
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsOneAppContinueBroadcast100PeopleParams>} LogObject<bookingsOneAppContinueBroadcast100PeopleParams>
 */
export function bookingsOneAppContinueBroadcast100People(params) {
    return { evid: 343, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsNavigationClick' event (evid: 313)
 *
 * Event description: click on "back to inbox" from the calendar
 *
 * @param {bookingsSettingsNavigationClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} selection - {calendar, services}
 * @property {GUID} customer_id - -
 * @return {LogObject<bookingsSettingsNavigationClickParams>} LogObject<bookingsSettingsNavigationClickParams>
 */
export function bookingsSettingsNavigationClick(params) {
    return { evid: 313, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffChangeStaffMemberWorkingHourRadioButton' event (evid: 186)
 *
 * Event description: change selection in the staff working hour radio button
 * http://prntscr.com/bom4r9
 *
 * @param {bookingsStaffChangeStaffMemberWorkingHourRadioButtonParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} biToken
 * @property {string} selection - { same (defult, set (staff hours)}
 * @return {LogObject<bookingsStaffChangeStaffMemberWorkingHourRadioButtonParams>} LogObject<bookingsStaffChangeStaffMemberWorkingHourRadioButtonParams>
 */
export function bookingsStaffChangeStaffMemberWorkingHourRadioButton(params) {
    return { evid: 186, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSaveCustomVcLinkOapNotifyParticipants' event (evid: 473)
 *
 * Event description: sent after the users choose whether to notify participants on change of VC link to session - One App Only!
 *
 * @param {bookingsSaveCustomVcLinkOapNotifyParticipantsParams} params - The parameters for this event
 * @property {string} action_type - {edit/restore}
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken
 * @property {boolean} notifyChecked - notify participants
 * @return {LogObject<bookingsSaveCustomVcLinkOapNotifyParticipantsParams>} LogObject<bookingsSaveCustomVcLinkOapNotifyParticipantsParams>
 */
export function bookingsSaveCustomVcLinkOapNotifyParticipants(params) {
    return { evid: 473, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsNewParticipantSaveClicked' event (evid: 249)
 *
 * Event description: When user clicks on save after filling details of new participant.
 *
 * @param {bookingsClubsGroupSessionsNewParticipantSaveClickedParams} params - The parameters for this event
 * @property {string} bookingsPlatform
 * @property {GUID} businessId
 * @property {GUID} msid - meta site id
 * @property {GUID} biToken
 * @return {LogObject<bookingsClubsGroupSessionsNewParticipantSaveClickedParams>} LogObject<bookingsClubsGroupSessionsNewParticipantSaveClickedParams>
 */
export function bookingsClubsGroupSessionsNewParticipantSaveClicked(params) {
    return { evid: 249, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRestoreDefaultVcLinkNotExists' event (evid: 474)
 *
 * Event description: sent when a user tries to restore the default vc link for a session but it does not exists
 *
 * @param {bookingsRestoreDefaultVcLinkNotExistsParams} params - The parameters for this event
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {boolean} notifyChecked - notify participants
 * @property {string} selection - {cancel/agree}
 * @return {LogObject<bookingsRestoreDefaultVcLinkNotExistsParams>} LogObject<bookingsRestoreDefaultVcLinkNotExistsParams>
 */
export function bookingsRestoreDefaultVcLinkNotExists(params) {
    return { evid: 474, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarChangeTimezoneClick' event (evid: 363)
 *
 * Event description: click on change time zone in calendar
 *
 * @param {bookingsCalendarChangeTimezoneClickParams} params - The parameters for this event
 * @property {string} bookingsPlatform - Null if old platform
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @return {LogObject<bookingsCalendarChangeTimezoneClickParams>} LogObject<bookingsCalendarChangeTimezoneClickParams>
 */
export function bookingsCalendarChangeTimezoneClick(params) {
    return { evid: 363, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppClassPageViewFormResponsesPageLoaded' event (evid: 1025)
 *
 * Event description: when the page of booking form responses is loaded
 *
 * @param {bookingsOwnerMobileAppClassPageViewFormResponsesPageLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} emptyState - True if there are no responses at all and False if there are
 * @property {number} numParticipants - num participants in this session
 * @property {number} numResponses - how many responses are in this page
 * @property {GUID} sessionId - -
 * @return {LogObject<bookingsOwnerMobileAppClassPageViewFormResponsesPageLoadedParams>} LogObject<bookingsOwnerMobileAppClassPageViewFormResponsesPageLoadedParams>
 */
export function bookingsOwnerMobileAppClassPageViewFormResponsesPageLoaded(params) {
    return { evid: 1025, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServicePageSkipClassBookingFormCheckbox' event (evid: 1027)
 *
 * Event description: when the user clicks on the checkbox-
 *
 * @param {bookingsCatalogServicePageSkipClassBookingFormCheckboxParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} instanceId - -
 * @property {GUID} biToken - -
 * @property {GUID} uuid - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} clickType - check / un-check
 * @property {boolean} wasCheck - True\False
 * @property {boolean} isNewService - True if yes, False if not
 * @property {string} formType - custom/default
 * @property {string} serviceId - will be available only for exsiting services, in new services it will be null and 	is_new_service will be true
 * @return {LogObject<bookingsCatalogServicePageSkipClassBookingFormCheckboxParams>} LogObject<bookingsCatalogServicePageSkipClassBookingFormCheckboxParams>
 */
export function bookingsCatalogServicePageSkipClassBookingFormCheckbox(params) {
    return { evid: 1027, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceListReorder' event (evid: 1029)
 *
 * Event description: When a user reorder categories in the service list (valid from when the service list moved to be based on cairo)
 *
 * @param {bookingsCatalogServiceListReorderParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - service_type
 * @property {string} categoryId - relevant for fields action names - dropdown_category, edit, save_edit, cancel_deit, delete, approve_delete
 * @property {GUID} biToken - msid
 * @property {string} categoryName - category_name
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} properties - for action open modal - {referral_info: table / more actions, num_of_cetegories, num_of_services} / for action drag  {item: category / service, source_category, source_position, target_category, target_position}, for action edit, save edit, cancel edit, delete, approve delete, dropdown category {category_id}
 * @property {string} actionName - options: open modal, cancel modal, dropdown category, drag, edit, save edit, cancel edit, delete, approve delete, save order, add new category, approve add new category
 * @property {number} position - the category position among the categories (1= the top category)
 * @property {GUID} msid - msid
 * @property {string} serviceId - relevant for fields action names - dropdown_category, edit, save_edit, cancel_deit, delete, approve_delete
 * @return {LogObject<bookingsCatalogServiceListReorderParams>} LogObject<bookingsCatalogServiceListReorderParams>
 */
export function bookingsCatalogServiceListReorder(params) {
    return { evid: 1029, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceSaveSuccess' event (evid: 103)
 *
 * Event description: sent when a user save a service successfully
 *
 * @param {bookingsServiceSaveSuccessParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} price_text_empty - price_text_empty
 * @property {number} businessHoursCounter - business_hours_counter
 * @property {number} weeklyFrequency - service every X weeks
 * @property {string} videoInfo - Null=not installed. If do - "enabled" / "disabled"
 * @property {boolean} additionalParticipant - additional_participant
 * @property {GUID} biToken - msid
 * @property {string} paymentMethod - {OFFLINE/ONLINE/ALL}
 * @property {number} price - Multiplied by 10000
 * @property {string} connected_plans - null if none. M for membership, P for package, B for both
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} participants - participants
 * @property {boolean} minute_empty - minute_empty
 * @property {number} staffSelected - staff_selected
 * @property {number} additionalParticipantMax - additional_participant_max
 * @property {string} plan_type - "Priced as": {single_session / membership}
 * @property {string} save_type - {create_new, save_changes}
 * @property {number} depositAmount - deposit_amount
 * @property {boolean} is_member - TRUE only if membership pricing is chosen AND  a connected plan is chosen as well
 * @property {boolean} service_description_empty - service_description_empty
 * @property {string} price_selection - price_selection
 * @property {boolean} photo_empty - photo_empty
 * @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
 * @property {string} currency - currency
 * @property {string} category - category
 * @property {boolean} infoEveryAdditionalParticipant - info_every_additional_participant
 * @property {string} type - service type: {INDIVIDUAL/GROUP/COURSE}
 * @property {string} location_choice - location_choice
 * @property {string} service_id - service_id
 * @property {boolean} tagLineFilled - http://prntscr.com/f541qa
 * @property {number} timeBuffer - time_buffer
 * @property {GUID} clubId - oneapp
 * @property {boolean} hour_empty - hour_empty
 * @return {LogObject<bookingsServiceSaveSuccessParams>} LogObject<bookingsServiceSaveSuccessParams>
 */
export function bookingsServiceSaveSuccess(params) {
    return { evid: 103, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppManageParticipantsMotoClicks' event (evid: 1030)
 *
 * Event description: when the user clicks on "enter card info manually"  in the manage participants (MOTO) and also all the clicks that comes after -  ("go to checkout" and "Done")
 *
 * @param {bookingsOwnerMobileAppManageParticipantsMotoClicksParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - Class / course / appointmn=ent
 * @property {GUID} biToken - -
 * @property {boolean} isPaymentConnected - True if yes and False if not
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} paymentType - is it "pay in person"? is it "online"? or is it "both""
 * @property {string} origin - Owner / uou
 * @property {string} sessionId - -
 * @property {string} buttonName - enter_card/ go_to_checkout / done
 * @property {string} pageName - manage_participant_modal / collect payment / success
 * @property {GUID} serviceId - -
 * @return {LogObject<bookingsOwnerMobileAppManageParticipantsMotoClicksParams>} LogObject<bookingsOwnerMobileAppManageParticipantsMotoClicksParams>
 */
export function bookingsOwnerMobileAppManageParticipantsMotoClicks(params) {
    return { evid: 1030, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppCancelAppointmentIntent' event (evid: 1031)
 *
 * Event description: when user click on "cancel session" before it actually canceled.
 * only for owner app. or from action sheet, or from session page
 *
 * @param {bookingsOwnerMobileAppCancelAppointmentIntentParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - appointment
 * @property {GUID} visitorId - -
 * @property {GUID} biToken - -
 * @property {number} price - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} paymentType - how the user pay ? pay in person/ online /membership (pricing plans) / not_paid
 * @property {boolean} isOwner - -
 * @property {string} origin - action_sheet / session_page
 * @property {GUID} sessionId - -
 * @property {string} contactId - -
 * @property {string} serviceId - -
 * @return {LogObject<bookingsOwnerMobileAppCancelAppointmentIntentParams>} LogObject<bookingsOwnerMobileAppCancelAppointmentIntentParams>
 */
export function bookingsOwnerMobileAppCancelAppointmentIntent(params) {
    return { evid: 1031, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'copyOfBookingsOwnerMobileAppRemoveParticipantIntent' event (evid: 1032)
 *
 * Event description: when user click on "remove from session" before it actually canceled.
 * only for owner app. or from action sheet, or from session page
 *
 * @param {copyOfBookingsOwnerMobileAppRemoveParticipantIntentParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - appointment
 * @property {GUID} visitorId - -
 * @property {GUID} biToken - -
 * @property {number} price - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} paymentType - how the user pay ? pay in person/ online /membership (pricing plans) / not_paid
 * @property {boolean} isOwner - -
 * @property {GUID} sessionId - -
 * @property {string} contactId - -
 * @property {string} serviceId - -
 * @return {LogObject<copyOfBookingsOwnerMobileAppRemoveParticipantIntentParams>} LogObject<copyOfBookingsOwnerMobileAppRemoveParticipantIntentParams>
 */
export function copyOfBookingsOwnerMobileAppRemoveParticipantIntent(params) {
    return { evid: 1032, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppRemoveParticipantPage' event (evid: 1033)
 *
 * Event description: when the user decides if to mark as refunded or not and send mail or not
 *
 * @param {bookingsOwnerMobileAppRemoveParticipantPageParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - appoitment/class/course
 * @property {GUID} visitorId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} paymentType - how the user pay ? pay in person/ online /membership (pricing plans) / not_paid
 * @property {boolean} markAsRefund - True/False
 * @property {GUID} sessionId - -
 * @property {string} contactId - -
 * @property {boolean} sendMail - True / False
 * @property {string} serviceId - -
 * @return {LogObject<bookingsOwnerMobileAppRemoveParticipantPageParams>} LogObject<bookingsOwnerMobileAppRemoveParticipantPageParams>
 */
export function bookingsOwnerMobileAppRemoveParticipantPage(params) {
    return { evid: 1033, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'copyOfBookingsOwnerMobileAppRefundDecision' event (evid: 1034)
 *
 * Event description: when the user remove the participant and now decide if to mark as refund or continue without refind
 *
 * @param {copyOfBookingsOwnerMobileAppRefundDecisionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - appoitment/class/course
 * @property {GUID} visitorId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} paymentType - how the user pay ? pay in person/ online /membership (pricing plans) / not_paid
 * @property {GUID} sessionId - -
 * @property {string} contactId - -
 * @property {string} buttonName - Mark as refund/ continuew wothout refund/ x button
 * @property {boolean} refundConfirmed - True/ False
 * @property {string} serviceId - -
 * @return {LogObject<copyOfBookingsOwnerMobileAppRefundDecisionParams>} LogObject<copyOfBookingsOwnerMobileAppRefundDecisionParams>
 */
export function copyOfBookingsOwnerMobileAppRefundDecision(params) {
    return { evid: 1034, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarExternalCalendarsProposeToSyncModalLoadClick' event (evid: 1035)
 *
 * Event description: when propose to sync modal loaded or clicked - the modal open when a staff member accept the sync invitation. different actions by 'action' field
 *
 * @param {bookingsCalendarExternalCalendarsProposeToSyncModalLoadClickParams} params - The parameters for this event
 * @property {GUID} businessId - --
 * @property {GUID} biToken - --
 * @property {GUID} staffId - --
 * @property {string} bookingsPlatform - --
 * @property {string} action - load / sync / learn_more / close
 * @return {LogObject<bookingsCalendarExternalCalendarsProposeToSyncModalLoadClickParams>} LogObject<bookingsCalendarExternalCalendarsProposeToSyncModalLoadClickParams>
 */
export function bookingsCalendarExternalCalendarsProposeToSyncModalLoadClick(params) {
    return { evid: 1035, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarExternalCalendarsSyncModalLoad' event (evid: 1036)
 *
 * Event description: when the external calendar sync modal opened - from all entry points (referral_info)
 *
 * @param {bookingsCalendarExternalCalendarsSyncModalLoadParams} params - The parameters for this event
 * @property {GUID} businessId - --
 * @property {string} referralInfo - more actions / suggestions / deep link / propose to sync modal
 * @property {GUID} biToken - --
 * @property {GUID} staffId - --
 * @property {string} bookingsPlatform - --
 * @return {LogObject<bookingsCalendarExternalCalendarsSyncModalLoadParams>} LogObject<bookingsCalendarExternalCalendarsSyncModalLoadParams>
 */
export function bookingsCalendarExternalCalendarsSyncModalLoad(params) {
    return { evid: 1036, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPosClickOnStartNow' event (evid: 1037)
 *
 * Event description: When a user starts the flow of purchasing POS from the Bookings page
 *
 * @param {bookingsPosClickOnStartNowParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsPosClickOnStartNowParams>} LogObject<bookingsPosClickOnStartNowParams>
 */
export function bookingsPosClickOnStartNow(params) {
    return { evid: 1037, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarManageParticipantsRowActions' event (evid: 1038)
 *
 * Event description: Click on a row action in the manage participants / waitlist table {edit,remove...}
 *
 * @param {bookingsCalendarManageParticipantsRowActionsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} planGuid - plan id
 * @property {string} tab - manage participants / waitlist
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {number} rowNumber - row index
 * @property {number} participants - number of participants in table
 * @property {string} planName - If pricing plan was chosen = plan_name if not then null
 * @property {string} redeemTime - after_booked / during_book
 * @property {string} sessionId - session_id
 * @property {string} contactId - contact_id
 * @property {number} planId - If pricing plan was chosen = plan_id, if not then null
 * @property {string} serviceId - service_id
 * @property {string} action - edit / remove / more actions / view order / send message / Collect payment / Pay with credit card / Send payment request / Paid in person / Add to session / Remove from waitlist
 * @return {LogObject<bookingsCalendarManageParticipantsRowActionsParams>} LogObject<bookingsCalendarManageParticipantsRowActionsParams>
 */
export function bookingsCalendarManageParticipantsRowActions(params) {
    return { evid: 1038, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarManageParticipantsBulkActions' event (evid: 1039)
 *
 * Event description: bulk action in the manage participants / waitlist table {check-in, remove, remove from waitlist}
 *
 * @param {bookingsCalendarManageParticipantsBulkActionsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} tab - manage participants / waitlist
 * @property {GUID} biToken - msid
 * @property {number} selectedParticipants - number of selected participants
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingIds - list of selected booking ids
 * @property {string} sessionId - session_id
 * @property {string} serviceId - service_id
 * @property {string} action - check-in / remove / remove from waitlist
 * @property {number} totalParticipants - number of participants in table
 * @return {LogObject<bookingsCalendarManageParticipantsBulkActionsParams>} LogObject<bookingsCalendarManageParticipantsBulkActionsParams>
 */
export function bookingsCalendarManageParticipantsBulkActions(params) {
    return { evid: 1039, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppManageParticipantsPosClickOnLinkForInformation' event (evid: 1040)
 *
 * Event description: when the user clicks on pay with POS option and he doesn't have it on the app. and it sends him to an information link about POS.
 *
 * @param {bookingsOwnerMobileAppManageParticipantsPosClickOnLinkForInformationParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} serviceType - Class / course / appointmn=ent
 * @property {GUID} visitorId - of the member
 * @property {GUID} biToken - -
 * @property {boolean} isPaymentConnected - (payment method) True if yes and False if not
 * @property {string} bookingsPlatform - -
 * @property {string} paymentType - is it "pay in person"? is it "online"? or is it "both""
 * @property {string} origin - Owner / uou
 * @property {string} sessionId - -
 * @property {string} contactId - of the member
 * @property {string} buttonName - enter_card/ go_to_checkout / done
 * @property {GUID} serviceId - -
 * @return {LogObject<bookingsOwnerMobileAppManageParticipantsPosClickOnLinkForInformationParams>} LogObject<bookingsOwnerMobileAppManageParticipantsPosClickOnLinkForInformationParams>
 */
export function bookingsOwnerMobileAppManageParticipantsPosClickOnLinkForInformation(params) {
    return { evid: 1040, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppManageParticipantsParticiapantClickOnPosChargeWithCareReader' event (evid: 1041)
 *
 * Event description: when the user clicks on pay with POS option
 *
 * @param {bookingsOwnerMobileAppManageParticipantsParticiapantClickOnPosChargeWithCareReaderParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} serviceType - Class / course / appointmn=ent
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} biToken - -
 * @property {boolean} isPaymentConnected - (payment method) True if yes and False if not
 * @property {string} bookingsPlatform - -
 * @property {string} paymentType - is it "pay in person"? is it "online"? or is it "both""
 * @property {boolean} isPos - true if the user has POS
 * @property {string} origin - Owner / uou
 * @property {string} sessionId - -
 * @property {string} contactId - of the member
 * @property {string} buttonName - enter_card/ go_to_checkout / done
 * @property {GUID} serviceId - -
 * @return {LogObject<bookingsOwnerMobileAppManageParticipantsParticiapantClickOnPosChargeWithCareReaderParams>} LogObject<bookingsOwnerMobileAppManageParticipantsParticiapantClickOnPosChargeWithCareReaderParams>
 */
export function bookingsOwnerMobileAppManageParticipantsParticiapantClickOnPosChargeWithCareReader(params) {
    return { evid: 1041, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppManageParticipantParticipantMotoSuccessPageIsLoaded' event (evid: 1042)
 *
 * Event description: when the success page of paying with MOTO is loaded
 *
 * @param {bookingsOwnerMobileAppManageParticipantParticipantMotoSuccessPageIsLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} serviceType - Class / course / appointmn=ent
 * @property {GUID} visitorId - -
 * @property {GUID} biToken - -
 * @property {boolean} isPaymentConnected - (payment method) True if yes and False if not
 * @property {string} bookingsPlatform - -
 * @property {string} paymentType - is it "pay in person"? is it "online"? or is it "both""
 * @property {string} sessionId - -
 * @property {string} contactId - of the member
 * @property {GUID} serviceId - -
 * @return {LogObject<bookingsOwnerMobileAppManageParticipantParticipantMotoSuccessPageIsLoadedParams>} LogObject<bookingsOwnerMobileAppManageParticipantParticipantMotoSuccessPageIsLoadedParams>
 */
export function bookingsOwnerMobileAppManageParticipantParticipantMotoSuccessPageIsLoaded(params) {
    return { evid: 1042, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceListOrganizeServicesAddNewCategory' event (evid: 1043)
 *
 * Event description: service list > organize services when the user add a new category
 *
 * @param {bookingsCatalogServiceListOrganizeServicesAddNewCategoryParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} category_name - category_name
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} category_id - category_id
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<bookingsCatalogServiceListOrganizeServicesAddNewCategoryParams>} LogObject<bookingsCatalogServiceListOrganizeServicesAddNewCategoryParams>
 */
export function bookingsCatalogServiceListOrganizeServicesAddNewCategory(params) {
    return { evid: 1043, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceListOrganizeServicesRenameCategory' event (evid: 1044)
 *
 * Event description: service list > organize services > rename category
 *
 * @param {bookingsCatalogServiceListOrganizeServicesRenameCategoryParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} new_name - new_name
 * @property {string} old_name - old_name
 * @property {string} category_id - category_id
 * @return {LogObject<bookingsCatalogServiceListOrganizeServicesRenameCategoryParams>} LogObject<bookingsCatalogServiceListOrganizeServicesRenameCategoryParams>
 */
export function bookingsCatalogServiceListOrganizeServicesRenameCategory(params) {
    return { evid: 1044, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingCatalogServiceListOrganizeServicesReorder' event (evid: 1045)
 *
 * Event description: service list > organize services >  the user can drag services and change their order inside their category or move them to another category and change their order. or to reorder the categories order https://prnt.sc/6Oqi-i51Wmhc
 *
 * @param {bookingCatalogServiceListOrganizeServicesReorderParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} targetPosition - the position after the change - if service - from all services,  if category - from all categories
 * @property {GUID} biToken - msid
 * @property {string} serviceIdList - when is_bulk = true this field contain list of service ids
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isBulk - if the reorder action was bulk (means move number of services to a category) with few entities (possible since q4 22, from the service list)
 * @property {string} entity_type - service or category
 * @property {number} sourcePosition - the position before the change - if service - from all services,  if category - from all categories
 * @property {string} source_category_id - relevant to services reorder - the category id it was in before the change
 * @property {string} category_id - If the entity is category
 * @property {string} reorderType - for services - when the reorder is between 2 categories then 'between_categories' else in_category
 * @property {string} target_category_id - relevant to services reorder - the category id it was in after the change
 * @property {GUID} service_id - If the entity is service
 * @return {LogObject<bookingCatalogServiceListOrganizeServicesReorderParams>} LogObject<bookingCatalogServiceListOrganizeServicesReorderParams>
 */
export function bookingCatalogServiceListOrganizeServicesReorder(params) {
    return { evid: 1045, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceListMoreActionsLoadModalImportServicesList' event (evid: 1046)
 *
 * Event description: service list > more actions >import services list > load modal with user's services list (the second screen in the modal after the user uploaded services) https://prnt.sc/Shi9fjxXTMIb
 *
 * @param {bookingsCatalogServiceListMoreActionsLoadModalImportServicesListParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} numberOfCategories - number of categories in the uploaded service list
 * @property {boolean} success - true / false
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} errorReason - reason the upload failed
 * @property {number} numberOfServices - number of services in the uploaded service list
 * @return {LogObject<bookingsCatalogServiceListMoreActionsLoadModalImportServicesListParams>} LogObject<bookingsCatalogServiceListMoreActionsLoadModalImportServicesListParams>
 */
export function bookingsCatalogServiceListMoreActionsLoadModalImportServicesList(params) {
    return { evid: 1046, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'copyOfBookingsCatalogServiceListMoreActionsImportServicesListAction' event (evid: 1047)
 *
 * Event description: service list > more actions >import services list > modal with user's services list > click import https://prnt.sc/rU5EOaOh1xiH
 *
 * @param {copyOfBookingsCatalogServiceListMoreActionsImportServicesListActionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} numberOfCategories - number of categories in the uploaded service list
 * @property {boolean} success - true / false
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} servicesIds - json with all services id's that were uploaded
 * @property {string} categoryIds - json with all categories id's that were uploaded
 * @property {string} errorReason - reason the upload failed
 * @property {number} numberOfServices - number of services in the uploaded service list
 * @return {LogObject<copyOfBookingsCatalogServiceListMoreActionsImportServicesListActionParams>} LogObject<copyOfBookingsCatalogServiceListMoreActionsImportServicesListActionParams>
 */
export function copyOfBookingsCatalogServiceListMoreActionsImportServicesListAction(params) {
    return { evid: 1047, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceListModalLoad' event (evid: 1048)
 *
 * Event description: When a modal load from the service list
 *
 * @param {bookingsCatalogServiceListModalLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} numberOfEntities - number of entities (services or categories) in the modal
 * @property {string} name - the modal name
 * @property {boolean} success - did the modal load successfully. true / false
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} servicesIds - service ids in the modal
 * @property {string} refferalName - refferal_name
 * @property {string} categoryIds - category ids in the modal
 * @property {string} entityType - what entities the modal containservice / category
 * @property {string} delete_category_type - single category / multiple categories
 * @return {LogObject<bookingsCatalogServiceListModalLoadParams>} LogObject<bookingsCatalogServiceListModalLoadParams>
 */
export function bookingsCatalogServiceListModalLoad(params) {
    return { evid: 1048, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceListModalLoadClickInModal' event (evid: 1049)
 *
 * Event description: When a user clicks in a modal load from the service list
 *
 * @param {bookingsCatalogServiceListModalLoadClickInModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} numberOfEntities - number of entities (services or categories) in the modal
 * @property {string} name - the modal name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} servicesIds - service ids in the modal
 * @property {string} categoryIds - category ids in the modal
 * @property {boolean} notifyParticipants - relevant only for delete service modal did the user checked the notify participant
 * @property {string} clickName - the button the user clicked on
 * @property {string} entityType - what entities the modal containservice / category
 * @property {string} delete_category_type - single category / multiple categories
 * @property {boolean} is_delete_all_services - When deleting a category of services
 * @property {string} target_category_id - relevant only for move service to category modal - the category id the service is moved to
 * @return {LogObject<bookingsCatalogServiceListModalLoadClickInModalParams>} LogObject<bookingsCatalogServiceListModalLoadClickInModalParams>
 */
export function bookingsCatalogServiceListModalLoadClickInModal(params) {
    return { evid: 1049, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCategoryEdit' event (evid: 105)
 *
 * Event description: BUG-low priority https://jira.wixpress.com/browse/SCHED-1942?filter=-2
 *
 * @param {bookingsCategoryEditParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} categoryId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {save_service-new,service_list-edit}
 * @property {string} selection - {yes, no}
 * @return {LogObject<bookingsCategoryEditParams>} LogObject<bookingsCategoryEditParams>
 */
export function bookingsCategoryEdit(params) {
    return { evid: 105, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceListClickOnTable' event (evid: 1050)
 *
 * Event description: click on a CTA inside the service list table
 *
 * @param {bookingsCatalogServiceListClickOnTableParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - service_type
 * @property {string} columnName - column_name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} ctaName - cta_name
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsCatalogServiceListClickOnTableParams>} LogObject<bookingsCatalogServiceListClickOnTableParams>
 */
export function bookingsCatalogServiceListClickOnTable(params) {
    return { evid: 1050, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceFormPriceOptionsDialog' event (evid: 1053)
 *
 * Event description: dynamic pricing - clicking on cta in price option dialog
 *
 * @param {bookingsCatalogServiceFormPriceOptionsDialogParams} params - The parameters for this event
 * @property {GUID} businessId - business id
 * @property {boolean} accept_bookings_after_start - advanced settings // FALSE if toggle is off
 * @property {number} duration - the service duration in minutes
 * @property {string} structureId - structure_id
 * @property {string} locationText - location_text if exist
 * @property {string} connected_payment_methods - json of connected payment methods
 * @property {boolean} staffFilled - True = error raised
 * @property {boolean} success - True = save success, False = fail
 * @property {string} priceOptions - no_fee / custom / fix
 * @property {boolean} headerImageChanged - True = header photo changed (add/replace/reorder)
 * @property {boolean} galleryImageChanged - True = gallery images changed (add/replace/reorder)
 * @property {string} videoInfo - Null=not installed. for auto-save: "connection_intent"; If installed + regular save - "enabled" / "disabled"
 * @property {GUID} biToken - -
 * @property {string} serviceName - service_name
 * @property {string} bookingsPlatform - -
 * @property {string} form_source - default/form_id
 * @property {string} request_type - bookings approval {auto_approve, manually_approve}
 * @property {boolean} service_name_empty - True = error raised
 * @property {string} paymentType - {online, in person, online and in person, deposit}
 * @property {string} planType - {connection_intent, connect_success}
 * @property {boolean} headerImageEmpty - True = no header image
 * @property {string} serviceGalleryOrigin - if the origin is the service gallery then - start from scratch / template_id. else null
 * @property {boolean} is_visible - True = display on site
 * @property {number} numLocations - number of business locations the service is provided at
 * @property {string} element - name of box
 * @property {string} loaction - location
 * @property {string} save_type - {create_new, save_changes}
 * @property {string} saveOrigin - {save_click, auto_save,save_and_duplicate,schedule_session,edit_form, biz_first_funnel}
 * @property {boolean} service_description_empty - False = short description empty
 * @property {string} templateId - For biz_first - if the service was saved from a ready template
 * @property {string} price_selection - {fixed, varies, no charge}
 * @property {number} image_in_gallery_count - number of images in gallery
 * @property {boolean} photo_empty - True = no image
 * @property {boolean} accept_online_bookings - advanced settings // FALSE if this a "no book flow"
 * @property {boolean} duration_empty - custom duration, True = error raised
 * @property {string} cta - ‘save’/’back to dialog’/’edit prices’
 * @property {string} premiumStatus - {Website/Business/None}
 * @property {string} type - {single, multi}
 * @property {string} locationGuidList - list of business locations
 * @property {string} location_choice - {business, client, custom}
 * @property {string} service_id - service id
 * @property {boolean} isTimeBuffer - True = using time buffer
 * @property {boolean} price_empty - True = error raised
 * @property {string} priceDetails - if fixed - amount, if custom - text
 * @property {boolean} galleryImageEmpty - True = no gallery images
 * @property {boolean} photo_changed - True = main photo changed (add/replace/reorder)
 * @return {LogObject<bookingsCatalogServiceFormPriceOptionsDialogParams>} LogObject<bookingsCatalogServiceFormPriceOptionsDialogParams>
 */
export function bookingsCatalogServiceFormPriceOptionsDialog(params) {
    return { evid: 1053, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceFormPriceOptionsDialogLoad' event (evid: 1054)
 *
 * Event description: dynamic pricing -  price option dialog loaded
 *
 * @param {bookingsCatalogServiceFormPriceOptionsDialogLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business id
 * @property {boolean} accept_bookings_after_start - advanced settings // FALSE if toggle is off
 * @property {number} duration - the service duration in minutes
 * @property {string} structureId - structure_id
 * @property {string} locationText - location_text if exist
 * @property {string} connected_payment_methods - json of connected payment methods
 * @property {boolean} staffFilled - True = error raised
 * @property {boolean} success - True = save success, False = fail
 * @property {string} priceOptions - no_fee / custom / fix
 * @property {boolean} headerImageChanged - True = header photo changed (add/replace/reorder)
 * @property {boolean} galleryImageChanged - True = gallery images changed (add/replace/reorder)
 * @property {string} videoInfo - Null=not installed. for auto-save: "connection_intent"; If installed + regular save - "enabled" / "disabled"
 * @property {GUID} biToken - -
 * @property {string} serviceName - service_name
 * @property {string} bookingsPlatform - -
 * @property {string} form_source - default/form_id
 * @property {string} request_type - bookings approval {auto_approve, manually_approve}
 * @property {boolean} service_name_empty - True = error raised
 * @property {string} paymentType - {online, in person, online and in person, deposit}
 * @property {string} planType - {connection_intent, connect_success}
 * @property {boolean} headerImageEmpty - True = no header image
 * @property {string} serviceGalleryOrigin - if the origin is the service gallery then - start from scratch / template_id. else null
 * @property {boolean} is_visible - True = display on site
 * @property {number} numLocations - number of business locations the service is provided at
 * @property {string} loaction - location
 * @property {string} save_type - {create_new, save_changes}
 * @property {string} saveOrigin - {save_click, auto_save,save_and_duplicate,schedule_session,edit_form, biz_first_funnel}
 * @property {boolean} service_description_empty - False = short description empty
 * @property {string} templateId - For biz_first - if the service was saved from a ready template
 * @property {string} price_selection - {fixed, varies, no charge}
 * @property {number} image_in_gallery_count - number of images in gallery
 * @property {boolean} photo_empty - True = no image
 * @property {string} origin - e.g - manage price
 * @property {boolean} accept_online_bookings - advanced settings // FALSE if this a "no book flow"
 * @property {boolean} duration_empty - custom duration, True = error raised
 * @property {string} premiumStatus - {Website/Business/None}
 * @property {string} type - {single, multi}
 * @property {string} locationGuidList - list of business locations
 * @property {string} location_choice - {business, client, custom}
 * @property {string} service_id - service id
 * @property {boolean} isTimeBuffer - True = using time buffer
 * @property {boolean} price_empty - True = error raised
 * @property {string} priceDetails - if fixed - amount, if custom - text
 * @property {boolean} galleryImageEmpty - True = no gallery images
 * @property {boolean} photo_changed - True = main photo changed (add/replace/reorder)
 * @return {LogObject<bookingsCatalogServiceFormPriceOptionsDialogLoadParams>} LogObject<bookingsCatalogServiceFormPriceOptionsDialogLoadParams>
 */
export function bookingsCatalogServiceFormPriceOptionsDialogLoad(params) {
    return { evid: 1054, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogDynamicPricingSave' event (evid: 1055)
 *
 * Event description: when a service is saved - the unified form for all services type (service X)
 *
 * @param {bookingsCatalogDynamicPricingSaveParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} priceOptions - no_fee / custom / fix
 * @property {GUID} biToken - msid
 * @property {string} price_option_label - the headline of custom price option
 * @property {string} serviceName - service_name
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} numberOfOptions - from jason file
 * @property {string} price_type - staff/location/label
 * @property {string} paymentType - {online, in person, online and in person, deposit}
 * @property {boolean} is_from_warning_modal - True / False
 * @property {string} save_type - {create_new, save_changes}
 * @property {string} price_selection - {fixed, varies, no charge}
 * @property {string} service_id - service id
 * @property {string} dynamic_price_participants_json - label/amount
 * @return {LogObject<bookingsCatalogDynamicPricingSaveParams>} LogObject<bookingsCatalogDynamicPricingSaveParams>
 */
export function bookingsCatalogDynamicPricingSave(params) {
    return { evid: 1055, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAnywhereBookingsPageManager' event (evid: 1056)
 *
 * Event description: When user click on share in the Bookings Page links (Dayful).   This event is relevant also for the Owner App, please notice the origin field to distinguish between different entry points.
 *
 * @param {bookingsBookingsAnywhereBookingsPageManagerParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} origin - from where the user got to the page
 * @property {string} component - name of the component clicked, for example - more links to share > specific service calendar
 * @property {string} value - all of the values of the filters checked at the time of the click. in the owner app this is a list with the services ids that were shared.
 * @property {string} action - name of the element inside the component that was clicked
 * @return {LogObject<bookingsBookingsAnywhereBookingsPageManagerParams>} LogObject<bookingsBookingsAnywhereBookingsPageManagerParams>
 */
export function bookingsBookingsAnywhereBookingsPageManager(params) {
    return { evid: 1056, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAnywhereBookingsPageManagerShareYourServices' event (evid: 1057)
 *
 * Event description: Bookings > Bookings anywhere >Bookings Page Manager > Share Your Services. sent when the modal is load or when the user click on something in the modal. This event is relevant also for the Owner App, please notice the origin field to distinguish between different entry points.
 *
 * @param {bookingsBookingsAnywhereBookingsPageManagerShareYourServicesParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} origin - services list, bookings page,  quick actions (owner app),etc
 * @property {string} component - name of the component clicked, for example - Share via
 * @property {string} value - value. in the owner app this is a list with the services ids that were shared.
 * @property {string} action - name of the element inside the component that was clicked - for example Twitter
 * @return {LogObject<bookingsBookingsAnywhereBookingsPageManagerShareYourServicesParams>} LogObject<bookingsBookingsAnywhereBookingsPageManagerShareYourServicesParams>
 */
export function bookingsBookingsAnywhereBookingsPageManagerShareYourServices(params) {
    return { evid: 1057, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAnywhereBookingsPageManagerMoreActionsClick' event (evid: 1058)
 *
 * Event description: Bookings Page Manager on Dayful
 *
 * @param {bookingsBookingsAnywhereBookingsPageManagerMoreActionsClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} action - name of the element inside the component that was clicked, for example - View Live
 * @return {LogObject<bookingsBookingsAnywhereBookingsPageManagerMoreActionsClickParams>} LogObject<bookingsBookingsAnywhereBookingsPageManagerMoreActionsClickParams>
 */
export function bookingsBookingsAnywhereBookingsPageManagerMoreActionsClick(params) {
    return { evid: 1058, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAnywhereBookingsPageManagerBookingsBookingsAnywhereBookingsPageManagerEditUrlPopup' event (evid: 1059)
 *
 * Event description: Bookings > Bookings anywhere >Bookings Page Manager > Edit URL Popup
 *
 * @param {bookingsBookingsAnywhereBookingsPageManagerBookingsBookingsAnywhereBookingsPageManagerEditUrlPopupParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} action - name of the element inside the component that was clicked, for example - Cancel
 * @return {LogObject<bookingsBookingsAnywhereBookingsPageManagerBookingsBookingsAnywhereBookingsPageManagerEditUrlPopupParams>} LogObject<bookingsBookingsAnywhereBookingsPageManagerBookingsBookingsAnywhereBookingsPageManagerEditUrlPopupParams>
 */
export function bookingsBookingsAnywhereBookingsPageManagerBookingsBookingsAnywhereBookingsPageManagerEditUrlPopup(params) {
    return { evid: 1059, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPhoto' event (evid: 106)
 *
 * Event description: sent when a photo is added\edited in the services pages or in the new staff member page
 *
 * @param {bookingsPhotoParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {new,replace,delete}
 * @property {string} type - {ind,groups.staff}
 * @property {string} serviceId - -
 * @property {GUID} bi_token - msid
 * @return {LogObject<bookingsPhotoParams>} LogObject<bookingsPhotoParams>
 */
export function bookingsPhoto(params) {
    return { evid: 106, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAnywhereWidgetModalBookingsSettings' event (evid: 1060)
 *
 * Event description: Copy of Bookings > Bookings anywhere > Widget Modal > Bookings settings
 *
 * @param {bookingsBookingsAnywhereWidgetModalBookingsSettingsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} component - widget type
 * @property {string} value - service ids/ all
 * @property {string} action - service type/ Null id all
 * @return {LogObject<bookingsBookingsAnywhereWidgetModalBookingsSettingsParams>} LogObject<bookingsBookingsAnywhereWidgetModalBookingsSettingsParams>
 */
export function bookingsBookingsAnywhereWidgetModalBookingsSettings(params) {
    return { evid: 1060, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarDynamicPricingMoreActionsPopUp' event (evid: 1061)
 *
 * Event description: When adding participants there are more actions pop up (wait list for example)
 *
 * @param {bookingsCalendarDynamicPricingMoreActionsPopUpParams} params - The parameters for this event
 * @property {GUID} businessId - .
 * @property {boolean} isSaveAndAddAnother - T if used the click "Save and add another one"
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingId - booking_id
 * @property {string} price_type - staff/location/label
 * @property {boolean} notifyParticipants - true/false
 * @property {string} save_type - {new, edit}
 * @property {string} price_selection - adult/kid/ etc
 * @property {string} payment_actions - paid/mark as not paid
 * @property {string} origin - OneApp/Desktop/OneApp_waiting_list, waitlist
 * @property {GUID} contactId - contact_id
 * @property {string} type - {course, group, class}
 * @property {GUID} msid - msid
 * @property {string} component - name of pop up
 * @property {GUID} value - contact_id
 * @return {LogObject<bookingsCalendarDynamicPricingMoreActionsPopUpParams>} LogObject<bookingsCalendarDynamicPricingMoreActionsPopUpParams>
 */
export function bookingsCalendarDynamicPricingMoreActionsPopUp(params) {
    return { evid: 1061, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'iosBookingsFunnelUpgradeModalLoadClickOneapp' event (evid: 1062)
 *
 * Event description: when the user gets the upgrade(not leading to Upgrade- but to Desktop, due to IOS limitations) modal opened due to limitations (sync calendar, add staff member [in bookings anywhere], etc.) relevant only for OneApp IOS
 *
 * @param {iosBookingsFunnelUpgradeModalLoadClickOneappParams} params - The parameters for this event
 * @property {GUID} businessId - business id
 * @property {string} referralInfo - the page name where the modal is opened
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} action - load/ close_click/ GotIt_click
 * @property {string} trigger - the action that triggered the upgrade modal: sync calendar / save staff member / save service
 * @return {LogObject<iosBookingsFunnelUpgradeModalLoadClickOneappParams>} LogObject<iosBookingsFunnelUpgradeModalLoadClickOneappParams>
 */
export function iosBookingsFunnelUpgradeModalLoadClickOneapp(params) {
    return { evid: 1062, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'copyOfBookingsCalendarExternalCalendarError' event (evid: 1063)
 *
 * Event description: sync calendar request failed to sent by email
 *
 * @param {copyOfBookingsCalendarExternalCalendarErrorParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} errorMessage - error reason
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {string} pageName - providers / connection / export
 * @property {string} calendarType - iCal/Google/Microsoft
 * @property {string} trigger - what user action triggered the error
 * @return {LogObject<copyOfBookingsCalendarExternalCalendarErrorParams>} LogObject<copyOfBookingsCalendarExternalCalendarErrorParams>
 */
export function copyOfBookingsCalendarExternalCalendarError(params) {
    return { evid: 1063, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAnywhereServicesListShareYourServiceClick' event (evid: 1064)
 *
 * Event description: when a dayful user clicks on 'share service' on service list page
 *
 * @param {bookingsBookingsAnywhereServicesListShareYourServiceClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsBookingsAnywhereServicesListShareYourServiceClickParams>} LogObject<bookingsBookingsAnywhereServicesListShareYourServiceClickParams>
 */
export function bookingsBookingsAnywhereServicesListShareYourServiceClick(params) {
    return { evid: 1064, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileTooltip' event (evid: 1065)
 *
 * Event description: A generic event that is fired when a tooltip is displayed to the user
 *
 * @param {bookingsMobileTooltipParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} tooltip_name - 3_day_view /daily_view/long_touch_to_add_session
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - calendar_settings / calendar_daily
 * @return {LogObject<bookingsMobileTooltipParams>} LogObject<bookingsMobileTooltipParams>
 */
export function bookingsMobileTooltip(params) {
    return { evid: 1065, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarCoursePageCheckIn' event (evid: 1066)
 *
 * Event description: click on check-in on the calendar course page, in the owner app.
 *
 * @param {bookingsCalendarCoursePageCheckInParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} service_name - service_name
 * @property {string} origin - NOTE: class_session_page_owner = COURSE;  one_app_manage_attendance = CLASS;
 * @property {string} type - service type (course)
 * @property {string} serviceId - service_id
 * @property {string} action - the action that was made. for example: Check_In_click
 * @return {LogObject<bookingsCalendarCoursePageCheckInParams>} LogObject<bookingsCalendarCoursePageCheckInParams>
 */
export function bookingsCalendarCoursePageCheckIn(params) {
    return { evid: 1066, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarScheduleViewChooseSession' event (evid: 1067)
 *
 * Event description: when the user chooses a specific session of the course from the  course schedule view. This is a generic event for all clicks in this screen.
 *
 * @param {bookingsCalendarScheduleViewChooseSessionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} service_name - service_name
 * @property {string} origin - place where action took place( one_app_course_schedule_view )
 * @property {string} type - service type (course)
 * @property {string} serviceId - service_id
 * @property {string} value - session_id
 * @property {string} action - the action that was made. for example: choose_session_click
 * @return {LogObject<bookingsCalendarScheduleViewChooseSessionParams>} LogObject<bookingsCalendarScheduleViewChooseSessionParams>
 */
export function bookingsCalendarScheduleViewChooseSession(params) {
    return { evid: 1067, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsManageAttendanceUpdateAttendance' event (evid: 1068)
 *
 * Event description: When the user updates the attendance status of a member in course.  In the owner app. This is a generic event for all clicks in the Manage_Attendance screen( origin, value, action will be changed respectively)
 *
 * @param {bookingsManageAttendanceUpdateAttendanceParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - old or new server
 * @property {string} bookingId - -
 * @property {string} origin - NOTE: class_session_page_owner = COURSE;  one_app_manage_attendance = CLASS;
 * @property {string} sessionId - --
 * @property {string} contactId - contact_id
 * @property {string} type - service type (ind/class/course)
 * @property {GUID} msid - -
 * @property {string} serviceId - service_id
 * @property {string} value - participant_id
 * @property {string} action - Check_In_click, click_on_participant
 * @return {LogObject<bookingsManageAttendanceUpdateAttendanceParams>} LogObject<bookingsManageAttendanceUpdateAttendanceParams>
 */
export function bookingsManageAttendanceUpdateAttendance(params) {
    return { evid: 1068, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileAppsManageAttendanceSpecificParticipantModalClick' event (evid: 1069)
 *
 * Event description: Tap on a participant from the "manage attendance" page, and then this modal will open. This event will be sent with every click in the modal.
 *
 * @param {bookingsMobileAppsManageAttendanceSpecificParticipantModalClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - NOTE: class_session_page_owner = COURSE;  one_app_manage_attendance = CLASS;
 * @property {string} sessionId - --
 * @property {string} contactId - -
 * @property {GUID} participant_id - participant member Id
 * @property {string} type - service type (class, course, appointment)
 * @property {GUID} service_id - -
 * @property {string} action - Mark as No_Show / Mark as Check_In
 * @return {LogObject<bookingsMobileAppsManageAttendanceSpecificParticipantModalClickParams>} LogObject<bookingsMobileAppsManageAttendanceSpecificParticipantModalClickParams>
 */
export function bookingsMobileAppsManageAttendanceSpecificParticipantModalClick(params) {
    return { evid: 1069, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPreviewEditEmail' event (evid: 107)
 *
 * Event description: Edit confirmation email/click on "show me" to go to the automations page
 *
 * @param {bookingsPreviewEditEmailParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - {ind,groups}
 * @property {string} email_type - {confirmation,reminder,cancellation,automations}
 * @return {LogObject<bookingsPreviewEditEmailParams>} LogObject<bookingsPreviewEditEmailParams>
 */
export function bookingsPreviewEditEmail(params) {
    return { evid: 107, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarManageParticipantsManageModal' event (evid: 1070)
 *
 * Event description: click on the Manage modal in Manage participants screen
 *
 * @param {bookingsCalendarManageParticipantsManageModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} service_name - service_name
 * @property {string} origin - place where action took place(one_app_manage_patricipants_Manage_modal)
 * @property {string} type - service type (course, class, appointment)
 * @property {string} serviceId - service_id
 * @property {string} action - the action that was made: Manage_click
 * @return {LogObject<bookingsCalendarManageParticipantsManageModalParams>} LogObject<bookingsCalendarManageParticipantsManageModalParams>
 */
export function bookingsCalendarManageParticipantsManageModal(params) {
    return { evid: 1070, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceListAcceptUnacceptOnlineBookings' event (evid: 1071)
 *
 * Event description: when a user set a service to accept or not to accept online bookings from the service list
 *
 * @param {bookingsCatalogServiceListAcceptUnacceptOnlineBookingsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} serviceIdList - when is_bulk = true this field contain list of service ids
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isBulk - if the action was bulk with few entities (possible since q4 22, from the service list)
 * @property {string} actionName - to which state the user set the service - accept / unaccept
 * @property {string} type - service type
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsCatalogServiceListAcceptUnacceptOnlineBookingsParams>} LogObject<bookingsCatalogServiceListAcceptUnacceptOnlineBookingsParams>
 */
export function bookingsCatalogServiceListAcceptUnacceptOnlineBookings(params) {
    return { evid: 1071, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppsIntegrationsPageView' event (evid: 1073)
 *
 * Event description: page view of Book Button integration displays: Facebook, instagram etc
 *
 * @param {bookingsAppsIntegrationsPageViewParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} origin - where did the users come from
 * @property {string} component - name of the component clicked, for example - Bookings Channel
 * @property {string} email_type - {confirmation,reminder,cancellation,automations}
 * @return {LogObject<bookingsAppsIntegrationsPageViewParams>} LogObject<bookingsAppsIntegrationsPageViewParams>
 */
export function bookingsAppsIntegrationsPageView(params) {
    return { evid: 1073, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppsIntegrationsPageClicks' event (evid: 1074)
 *
 * Event description: clicks made on the page view of Book Button integration (connect/learn more/manage)
 *
 * @param {bookingsAppsIntegrationsPageClicksParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} origin - where did the users come from
 * @property {string} component - name of the component clicked, for example - Bookings Channel
 * @property {string} value - facebook/ instagram etc
 * @property {string} action - name of the element inside the component that was clicked, for example - connect/learn more/manage
 * @property {string} email_type - {confirmation,reminder,cancellation,automations}
 * @return {LogObject<bookingsAppsIntegrationsPageClicksParams>} LogObject<bookingsAppsIntegrationsPageClicksParams>
 */
export function bookingsAppsIntegrationsPageClicks(params) {
    return { evid: 1074, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsConnectModalLoaded' event (evid: 1075)
 *
 * Event description: the modal that was loaded after clicking connect/manage
 *
 * @param {bookingsBookingsAppsConnectModalLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} modal_type - manage/connect
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} origin - where did the users come from
 * @property {string} component - name of the component clicked, for example - Facebook
 * @return {LogObject<bookingsBookingsAppsConnectModalLoadedParams>} LogObject<bookingsBookingsAppsConnectModalLoadedParams>
 */
export function bookingsBookingsAppsConnectModalLoaded(params) {
    return { evid: 1075, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsConnectModalsClicksSrc16Evid1076' event (evid: 1076)
 *
 * Event description: click continue on modal
 *
 * @param {bookingsBookingsAppsConnectModalsClicksSrc16Evid1076Params} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} origin - where did the users come from
 * @property {string} component - component
 * @property {string} value - if selection of service - service id if service list/custom then null
 * @property {string} action - selection of landing page type
 * @return {LogObject<bookingsBookingsAppsConnectModalsClicksSrc16Evid1076Params>} LogObject<bookingsBookingsAppsConnectModalsClicksSrc16Evid1076Params>
 */
export function bookingsBookingsAppsConnectModalsClicksSrc16Evid1076(params) {
    return { evid: 1076, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsConnectModalsClicks' event (evid: 1077)
 *
 * Event description: clicks made on "connect" modal
 *
 * @param {bookingsBookingsAppsConnectModalsClicksParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} modal_type - manage/connect
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} origin - where did the users come from
 * @property {string} component - name of the component clicked, for example - Facebook
 * @property {string} value - alue of the selection  (selection of landing page - what did the user choose? selection of service - service id)
 * @property {string} action - name of the element inside the component that was clicked, for example - close/ cancel/ selection of service/ selection of landing page/ learn more/disconnect
 * @return {LogObject<bookingsBookingsAppsConnectModalsClicksParams>} LogObject<bookingsBookingsAppsConnectModalsClicksParams>
 */
export function bookingsBookingsAppsConnectModalsClicks(params) {
    return { evid: 1077, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsSuccessfulConnection' event (evid: 1078)
 *
 * Event description: This event fires when the connection ( between  Book button and FB/ Instagram etc) was made successfully
 *
 * @param {bookingsBookingsAppsSuccessfulConnectionParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} value - Facebook/instagram etc
 * @property {string} action - first_save/edit
 * @property {string} pageName - page name
 * @return {LogObject<bookingsBookingsAppsSuccessfulConnectionParams>} LogObject<bookingsBookingsAppsSuccessfulConnectionParams>
 */
export function bookingsBookingsAppsSuccessfulConnection(params) {
    return { evid: 1078, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsDisconnectModalClicks' event (evid: 1079)
 *
 * Event description: This event fires when the connection ( between  Book button and FB/ Instagram etc) was made successfully
 *
 * @param {bookingsBookingsAppsDisconnectModalClicksParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} origin - where did the users come from
 * @property {string} component - name of the component clicked, for example - facebook
 * @property {string} action - cancel/disconnect/close
 * @return {LogObject<bookingsBookingsAppsDisconnectModalClicksParams>} LogObject<bookingsBookingsAppsDisconnectModalClicksParams>
 */
export function bookingsBookingsAppsDisconnectModalClicks(params) {
    return { evid: 1079, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSelectBusinessDays' event (evid: 108)
 *
 * Event description: bookings > add_business_days in the groups page \ business info \  staff member page
 *
 * @param {bookingsSelectBusinessDaysParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} isChecked - T/F
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {business_info, group_service, staff}
 * @property {string} choice - NOT SENT- ignore
 * @return {LogObject<bookingsSelectBusinessDaysParams>} LogObject<bookingsSelectBusinessDaysParams>
 */
export function bookingsSelectBusinessDays(params) {
    return { evid: 108, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsModalError' event (evid: 1080)
 *
 * Event description: fires when an error happens during connection/manage of the integration
 *
 * @param {bookingsBookingsAppsModalErrorParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} modal_type - manage/connect
 * @property {string} url - url
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} errorReason - type of error
 * @property {string} component - name of the component clicked, for example - facebook
 * @return {LogObject<bookingsBookingsAppsModalErrorParams>} LogObject<bookingsBookingsAppsModalErrorParams>
 */
export function bookingsBookingsAppsModalError(params) {
    return { evid: 1080, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsNonPremiumError' event (evid: 1081)
 *
 * Event description: fires when a non-premium client opens the connect modal
 *
 * @param {bookingsBookingsAppsNonPremiumErrorParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} type - standard, error, warning, success, premium
 * @return {LogObject<bookingsBookingsAppsNonPremiumErrorParams>} LogObject<bookingsBookingsAppsNonPremiumErrorParams>
 */
export function bookingsBookingsAppsNonPremiumError(params) {
    return { evid: 1081, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsClickedOnNonPremiumError' event (evid: 1082)
 *
 * Event description: fires when the user clicks on the non-premium error bar
 *
 * @param {bookingsBookingsAppsClickedOnNonPremiumErrorParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} clickType - upgrade/cancel
 * @property {string} type - info, error, warning, success, premium
 * @property {string} action - upgrade/cancel
 * @return {LogObject<bookingsBookingsAppsClickedOnNonPremiumErrorParams>} LogObject<bookingsBookingsAppsClickedOnNonPremiumErrorParams>
 */
export function bookingsBookingsAppsClickedOnNonPremiumError(params) {
    return { evid: 1082, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsPublishYourSiteErrorLoad' event (evid: 1083)
 *
 * Event description: publish your site error load
 *
 * @param {bookingsBookingsAppsPublishYourSiteErrorLoadParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} modal_type - strip/popup
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} component - name of the component clicked, for example - Facebook
 * @return {LogObject<bookingsBookingsAppsPublishYourSiteErrorLoadParams>} LogObject<bookingsBookingsAppsPublishYourSiteErrorLoadParams>
 */
export function bookingsBookingsAppsPublishYourSiteErrorLoad(params) {
    return { evid: 1083, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsPublishYourSiteErrorClick' event (evid: 1084)
 *
 * Event description: publish your site error clicks
 *
 * @param {bookingsBookingsAppsPublishYourSiteErrorClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} modal_type - strip/popup
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} component - name of the component clicked, for example - Facebook
 * @property {string} action - close/publish
 * @return {LogObject<bookingsBookingsAppsPublishYourSiteErrorClickParams>} LogObject<bookingsBookingsAppsPublishYourSiteErrorClickParams>
 */
export function bookingsBookingsAppsPublishYourSiteErrorClick(params) {
    return { evid: 1084, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsRefreshThisPageModalLoad' event (evid: 1085)
 *
 * Event description: refresh this page modal load
 *
 * @param {bookingsBookingsAppsRefreshThisPageModalLoadParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} component - name of the component clicked before, for example - Facebook
 * @return {LogObject<bookingsBookingsAppsRefreshThisPageModalLoadParams>} LogObject<bookingsBookingsAppsRefreshThisPageModalLoadParams>
 */
export function bookingsBookingsAppsRefreshThisPageModalLoad(params) {
    return { evid: 1085, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsRefreshThisPageModalClick' event (evid: 1086)
 *
 * Event description: Bookings > Bookings Apps > refresh this page modal click
 *
 * @param {bookingsBookingsAppsRefreshThisPageModalClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} component - name of the component clicked, for example - Facebook
 * @property {string} action - close/refresh
 * @return {LogObject<bookingsBookingsAppsRefreshThisPageModalClickParams>} LogObject<bookingsBookingsAppsRefreshThisPageModalClickParams>
 */
export function bookingsBookingsAppsRefreshThisPageModalClick(params) {
    return { evid: 1086, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarSessionsModalOpen' event (evid: 1087)
 *
 * Event description: create / edit of staff availability. link to deck: https://docs.google.com/presentation/d/1IO-nWr956rYenl74U7DwV-bGd-wQCZU_u2JAfKvk_iE/edit?usp=sharing
 *
 * @param {bookingsCalendarSessionsModalOpenParams} params - The parameters for this event
 * @property {GUID} businessId - bookings instance_id
 * @property {string} modalType - create / edit
 * @property {GUID} scheduleOwnerId - if schedule_owner_type is 'resource' then <resource_id> else <service_id>
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} scheduleOwnerType - class / course / resource
 * @property {string} errorReason - if null- success
 * @property {string} referral - where it was opened from
 * @property {string} properties - json with all the data
 * @property {boolean} notifyChecked - TRUE if the user wishes to notify participants. Only when editing a session
 * @property {GUID} scheduleId - schedule_id
 * @property {string} sessionId - -
 * @property {boolean} isRepeat - boolean
 * @return {LogObject<bookingsCalendarSessionsModalOpenParams>} LogObject<bookingsCalendarSessionsModalOpenParams>
 */
export function bookingsCalendarSessionsModalOpen(params) {
    return { evid: 1087, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarSessionsModalSave' event (evid: 1088)
 *
 * Event description: create / edit of staff availability. link to deck: https://docs.google.com/presentation/d/1IO-nWr956rYenl74U7DwV-bGd-wQCZU_u2JAfKvk_iE/edit?usp=sharing
 *
 * @param {bookingsCalendarSessionsModalSaveParams} params - The parameters for this event
 * @property {GUID} businessId - bookings instance_id
 * @property {string} sessionIds - a list of all the sessions created in case of multiday creation
 * @property {string} modalType - create / edit
 * @property {boolean} success - T=sessions created
 * @property {GUID} scheduleOwnerId - if schedule_owner_type is 'resource' then <resource_id> else <service_id>
 * @property {GUID} biToken - msid
 * @property {string} noteMessagae - relevant only for Owner App. which note? if none then null. for example note_message: "past_time"
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} scheduleOwnerType - class / course / resource
 * @property {string} errorReason - if null- success
 * @property {string} timing - when the changes will take affect - now / later
 * @property {string} referral - where it was opened from
 * @property {string} properties - json with all the data
 * @property {boolean} notifyChecked - TRUE if the user wishes to notify participants. Only when editing a session
 * @property {GUID} scheduleId - schedule_id
 * @property {boolean} isRepeat - boolean
 * @return {LogObject<bookingsCalendarSessionsModalSaveParams>} LogObject<bookingsCalendarSessionsModalSaveParams>
 */
export function bookingsCalendarSessionsModalSave(params) {
    return { evid: 1088, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffAvailabilityResetDetouchToBusinessHours' event (evid: 1089)
 *
 * Event description: Reset / Detach staff availability hours to business hours. link to deck: https://docs.google.com/presentation/d/1IO-nWr956rYenl74U7DwV-bGd-wQCZU_u2JAfKvk_iE/edit?usp=sharing
 *
 * @param {bookingsStaffAvailabilityResetDetouchToBusinessHoursParams} params - The parameters for this event
 * @property {GUID} businessId - bookings instance_id
 * @property {string} eventType - load / click
 * @property {GUID} scheduleOwnerId - resource_id (staff_id)
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral - where it was opened from (staff page / roster)
 * @property {string} action - Reset / Detouch (typo)
 * @return {LogObject<bookingsStaffAvailabilityResetDetouchToBusinessHoursParams>} LogObject<bookingsStaffAvailabilityResetDetouchToBusinessHoursParams>
 */
export function bookingsStaffAvailabilityResetDetouchToBusinessHours(params) {
    return { evid: 1089, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsDuplicate' event (evid: 109)
 *
 * Event description: duplicate
 *
 * @param {bookingsDuplicateParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {category,service}
 * @property {string} type - {individual,groups}
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsDuplicateParams>} LogObject<bookingsDuplicateParams>
 */
export function bookingsDuplicate(params) {
    return { evid: 109, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarRemoveSessionsAvailability' event (evid: 1090)
 *
 * Event description: remove staff availability. link to deck: https://docs.google.com/presentation/d/1IO-nWr956rYenl74U7DwV-bGd-wQCZU_u2JAfKvk_iE/edit?usp=sharing
 *
 * @param {bookingsCalendarRemoveSessionsAvailabilityParams} params - The parameters for this event
 * @property {GUID} businessId - bookings instance_id
 * @property {GUID} scheduleOwnerId - if schedule_owner_type is 'resource' then <resource_id> else <service_id>
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} scheduleOwnerType - class / course / resource
 * @property {string} timing - now / later
 * @property {string} referral - where it was opened from (manage sessions / staff page / roster)
 * @property {string} properties - json with all the data
 * @property {boolean} notifyChecked - TRUE if the user wishes to notify participants. Only when editing a session
 * @property {GUID} scheduleId - schedule_id
 * @property {string} sessionId - -
 * @property {string} type - single session / all availability
 * @return {LogObject<bookingsCalendarRemoveSessionsAvailabilityParams>} LogObject<bookingsCalendarRemoveSessionsAvailabilityParams>
 */
export function bookingsCalendarRemoveSessionsAvailability(params) {
    return { evid: 1090, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffAvailabilityRosterClick' event (evid: 1091)
 *
 * Event description: generic event of click in availability roster page. link to deck: https://docs.google.com/presentation/d/1IO-nWr956rYenl74U7DwV-bGd-wQCZU_u2JAfKvk_iE/edit?usp=sharing
 *
 * @param {bookingsStaffAvailabilityRosterClickParams} params - The parameters for this event
 * @property {GUID} businessId - bookings instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} element - element clicked on
 * @property {string} properties - clicked session properties
 * @return {LogObject<bookingsStaffAvailabilityRosterClickParams>} LogObject<bookingsStaffAvailabilityRosterClickParams>
 */
export function bookingsStaffAvailabilityRosterClick(params) {
    return { evid: 1091, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffStaffMemberHoursClicks' event (evid: 1092)
 *
 * Event description: Currently relevant only for owner-app.
 * Fires when the user clicks on cta related to Staff Member Hours (3 dots = More actions / 'Manage'). The 'action' field will indicate which action was made.
 *
 * @param {bookingsStaffStaffMemberHoursClicksParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral - where it was opened from (manage sessions / staff page / roster)
 * @property {string} properties - details of the slot that was clicked
 * @property {string} action - more_actions_click/ manage_click
 * @return {LogObject<bookingsStaffStaffMemberHoursClicksParams>} LogObject<bookingsStaffStaffMemberHoursClicksParams>
 */
export function bookingsStaffStaffMemberHoursClicks(params) {
    return { evid: 1092, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffMoreActionsModalSrc16Evid1093' event (evid: 1093)
 *
 * Event description: Currently relevant only for owner-app.
 * Fires when the user clicks inside the 'Edit working Hours' modal (the modal opens after the click on 'Manage').
 * The action varies(Add Working Hours/ Reset to default hours/Remove all availability)
 *
 * @param {bookingsStaffMoreActionsModalSrc16Evid1093Params} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral - where the action was made. for example: staff_page
 * @property {string} action - Add Working Hours/ Reset to default hours/Remove all availability
 * @return {LogObject<bookingsStaffMoreActionsModalSrc16Evid1093Params>} LogObject<bookingsStaffMoreActionsModalSrc16Evid1093Params>
 */
export function bookingsStaffMoreActionsModalSrc16Evid1093(params) {
    return { evid: 1093, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffEditWorkingHoursModal' event (evid: 1094)
 *
 * Event description: Currently relevant only for owner-app.
 * Fires when the user clicks inside the 'More Actions ' modal (the modal opens after the click on the 3 dots).
 * The action varies(Edit Hours/ Remove hours)
 *
 * @param {bookingsStaffEditWorkingHoursModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral - where the action was made. for example: staff_page
 * @property {string} action - Edit Hours/ Remove hours
 * @return {LogObject<bookingsStaffEditWorkingHoursModalParams>} LogObject<bookingsStaffEditWorkingHoursModalParams>
 */
export function bookingsStaffEditWorkingHoursModal(params) {
    return { evid: 1094, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffFirstTimeEditManage' event (evid: 1095)
 *
 * Event description: Currently relevant only for owner-app.
 * After the user clicks on 'Manage' Working hours in the staff page for the first time during a specific visit - The 'Youre creating custom hours' toast will be shown. This event indicates which action was clicked there: Cancel/Continue
 *
 * @param {bookingsStaffFirstTimeEditManageParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral - where it was opened from (staff page )
 * @property {string} action - cancel/continue
 * @return {LogObject<bookingsStaffFirstTimeEditManageParams>} LogObject<bookingsStaffFirstTimeEditManageParams>
 */
export function bookingsStaffFirstTimeEditManage(params) {
    return { evid: 1095, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'copyOfBookingsBookingsAppsConnectADomainModalClick' event (evid: 1096)
 *
 * Event description: Bookings > Bookings Apps > refresh this page modal click
 *
 * @param {copyOfBookingsBookingsAppsConnectADomainModalClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} component - name of the component clicked, for example - Facebook
 * @property {string} action - close/connect/close
 * @return {LogObject<copyOfBookingsBookingsAppsConnectADomainModalClickParams>} LogObject<copyOfBookingsBookingsAppsConnectADomainModalClickParams>
 */
export function copyOfBookingsBookingsAppsConnectADomainModalClick(params) {
    return { evid: 1096, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarRecurringScheduleSummeryModalLoad' event (evid: 1097)
 *
 * Event description: Sent when schedule summery modal load
 *
 * @param {bookingsCalendarRecurringScheduleSummeryModalLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} staffNotAssignedConflict - jason of service_id with this conflict
 * @property {boolean} note_added - True if it filled and False if it's empty
 * @property {string} isOutsideWorkingHoursConflict - json of service ids with this conflict
 * @property {boolean} phoneFilled - T=filled
 * @property {boolean} staffFilled - T= selected
 * @property {boolean} success - T=appointment created
 * @property {string} endDate - timestamp of end time and date
 * @property {string} linkCreationStatus - {null/generated/exists}
 * @property {boolean} emailFilled - T=filled
 * @property {GUID} biToken - msid
 * @property {string} schedulingConflicts - jason of service_id with this conflict
 * @property {GUID} orderId - orderId
 * @property {string} noActivePlansConflict - jason of service_id with this conflict
 * @property {string} noteMessagae - indicates what message is  shown. Note type, in None then null
 * @property {string} staffId - staff_member_id (unique per site)
 * @property {string} bookingsPlatform - bookings platform
 * @property {number} recurringRepetition - repetition count
 * @property {string} bookingId - booking_id
 * @property {string} price_type - label/staff/location
 * @property {string} isAnotherSessionBookedConflict - json of service ids with this conflict
 * @property {GUID} staffUuid - the uuid of the chosen staff member
 * @property {string} paymentType - {paid_plan} or null
 * @property {string} errorReason - if null- success
 * @property {string} repeatUnit - null or if class: {never, weekly, every 2 weeks, every 3 weeks, every 4 weeks}
 * @property {string} recurringFrequency - if not recurring then null
 * @property {string} save_type - {create_appt, save_changes, create_and_add_more}
 * @property {boolean} isOwner - -
 * @property {GUID} locationGuid - location id - if chose business location
 * @property {boolean} paymentRequest - T if payment requested
 * @property {string} end_date_type - null or 'exists'
 * @property {boolean} notifyChecked - TRUE if the user wishes to notify participants. Only when editing a session
 * @property {string} pastSchedulingConflict - jason of service_id with this conflict
 * @property {string} origin - place where action started
 * @property {boolean} isWithConflict - True if it filled and False if it's empty
 * @property {string} sessionId - -
 * @property {string} contactId - contact_id of the client
 * @property {boolean} locationFilled - true if business location was filled
 * @property {boolean} isRecurring - t/f
 * @property {boolean} clientNameFilled - T=filled
 * @property {boolean} email_checked - T\F
 * @property {boolean} titleFilled - T/F
 * @property {string} staffNotAsisgnedConflict - jason of service_id with this conflict
 * @property {string} type - { appointment, group session, appointment_pending_approval,course_session,individualSession, one_app_blockSession, blockSession, course interval, group interval, appointment_pending_approval}
 * @property {boolean} isMultiLocation - True if this is service if more than one location
 * @property {string} startDate - timestamp of start time and date
 * @property {string} dynamic_price_participants_json - ‘label, amount, num_participants
 * @property {string} serviceId - service_id
 * @property {string} isStaffNotWorkingAtThisLocationConflict - json of service ids with this conflict
 * @return {LogObject<bookingsCalendarRecurringScheduleSummeryModalLoadParams>} LogObject<bookingsCalendarRecurringScheduleSummeryModalLoadParams>
 */
export function bookingsCalendarRecurringScheduleSummeryModalLoad(params) {
    return { evid: 1097, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarRecurringScheduleSummeryModalClicks' event (evid: 1098)
 *
 * Event description: Sent when the user interacts with schedule summery modal
 *
 * @param {bookingsCalendarRecurringScheduleSummeryModalClicksParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} note_added - True if it filled and False if it's empty
 * @property {boolean} phoneFilled - T=filled
 * @property {boolean} staffFilled - T= selected
 * @property {boolean} success - T=appointment created
 * @property {string} endDate - timestamp of end time and date
 * @property {string} linkCreationStatus - {null/generated/exists}
 * @property {boolean} emailFilled - T=filled
 * @property {GUID} biToken - msid
 * @property {GUID} orderId - orderId
 * @property {string} noteMessagae - indicates what message is  shown. Note type, in None then null
 * @property {string} staffId - staff_member_id (unique per site)
 * @property {string} bookingsPlatform - bookings platform
 * @property {number} recurringRepetition - repetition count
 * @property {string} bookingId - booking_id
 * @property {string} price_type - label/staff/location
 * @property {GUID} staffUuid - the uuid of the chosen staff member
 * @property {string} paymentType - {paid_plan} or null
 * @property {string} errorReason - if null- success
 * @property {string} repeatUnit - null or if class: {never, weekly, every 2 weeks, every 3 weeks, every 4 weeks}
 * @property {string} recurringFrequency - if not recurring then null
 * @property {string} save_type - {create_appt, save_changes, create_and_add_more}
 * @property {boolean} isOwner - -
 * @property {GUID} locationGuid - location id - if chose business location
 * @property {boolean} paymentRequest - T if payment requested
 * @property {string} end_date_type - null or 'exists'
 * @property {boolean} notifyChecked - TRUE if the user wishes to notify participants. Only when editing a session
 * @property {string} origin - place where action started
 * @property {boolean} isWithConflict - True if it filled and False if it's empty
 * @property {string} sessionId - -
 * @property {string} contactId - contact_id of the client
 * @property {boolean} locationFilled - true if business location was filled
 * @property {boolean} isRecurring - t/f
 * @property {boolean} clientNameFilled - T=filled
 * @property {boolean} email_checked - T\F
 * @property {boolean} titleFilled - T/F
 * @property {string} type - { appointment, group session, appointment_pending_approval,course_session,individualSession, one_app_blockSession, blockSession, course interval, group interval, appointment_pending_approval}
 * @property {boolean} isMultiLocation - True if this is service if more than one location
 * @property {string} startDate - timestamp of start time and date
 * @property {string} dynamic_price_participants_json - ‘label, amount, num_participants
 * @property {string} serviceId - service_id
 * @property {string} action - delete/close/go back/schedule/schedule_conflict
 * @return {LogObject<bookingsCalendarRecurringScheduleSummeryModalClicksParams>} LogObject<bookingsCalendarRecurringScheduleSummeryModalClicksParams>
 */
export function bookingsCalendarRecurringScheduleSummeryModalClicks(params) {
    return { evid: 1098, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppStaffEditBeforeSaving' event (evid: 1099)
 *
 * Event description: Currently relevant only for owner-app.
 * Fires when the user tries to edit stuff before saving.
 *
 * @param {bookingsOwnerAppStaffEditBeforeSavingParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} reason - edit_before_saving
 * @property {string} referral - staff_page
 * @property {string} trigger - edit_availability
 * @return {LogObject<bookingsOwnerAppStaffEditBeforeSavingParams>} LogObject<bookingsOwnerAppStaffEditBeforeSavingParams>
 */
export function bookingsOwnerAppStaffEditBeforeSaving(params) {
    return { evid: 1099, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsShowHide' event (evid: 110)
 *
 * Event description: show_hide
 *
 * @param {bookingsShowHideParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} serviceIdList - when is_bulk = true this field contain list of service ids
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isBulk - if the action was bulk with few entities (possible since q4 22, from the service list)
 * @property {string} referral_info - {additional_settings bus info,
 *  additional_settings groups,
 *  confirmation_mail,
 * category,
 *  service_list,
 *  service_availability_service_list,
 *  calendar_pending_approval_individual_session}
 * @property {string} service - {group, course, individual}
 * @property {boolean} isPendingApproval - T for pending approval service
 * @property {string} type - {hide,show}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsShowHideParams>} LogObject<bookingsShowHideParams>
 */
export function bookingsShowHide(params) {
    return { evid: 110, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppStaffSaveWithoutStaffName' event (evid: 1101)
 *
 * Event description: Currently relevant only for owner-app.
 * Fires when the user tries to save stuff availability with out staff name.
 *
 * @param {bookingsOwnerAppStaffSaveWithoutStaffNameParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} reason - missing_name
 * @property {string} referral - staff_page
 * @property {string} trigger - save_availability
 * @return {LogObject<bookingsOwnerAppStaffSaveWithoutStaffNameParams>} LogObject<bookingsOwnerAppStaffSaveWithoutStaffNameParams>
 */
export function bookingsOwnerAppStaffSaveWithoutStaffName(params) {
    return { evid: 1101, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppTechnicalProblem' event (evid: 1102)
 *
 * Event description: Relevant only for owner-app.
 * Fires when a 'Technical Problem' screen is presented to the user.
 *
 * @param {bookingsOwnerAppTechnicalProblemParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} info - the message presented on the screen
 * @property {string} referral - after what screen the problem occurred
 * @return {LogObject<bookingsOwnerAppTechnicalProblemParams>} LogObject<bookingsOwnerAppTechnicalProblemParams>
 */
export function bookingsOwnerAppTechnicalProblem(params) {
    return { evid: 1102, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsClick' event (evid: 1103)
 *
 * Event description: click on Bookings Apps page [Generic]
 *
 * @param {bookingsBookingsAppsClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - learn_more / explore
 * @return {LogObject<bookingsBookingsAppsClickParams>} LogObject<bookingsBookingsAppsClickParams>
 */
export function bookingsBookingsAppsClick(params) {
    return { evid: 1103, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogSetVcAsAFreeSite' event (evid: 1104)
 *
 * Event description: when a user start to set a vc account as a free site (can be done from the staff page or the service form) untill January 2023 it was possible as a free site, since then it's a premium feature, so the user gets an upgrade modal.
 *
 * @param {bookingsCatalogSetVcAsAFreeSiteParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - from where the user started to set the vc account (possible values - service_form / staff_page)
 * @return {LogObject<bookingsCatalogSetVcAsAFreeSiteParams>} LogObject<bookingsCatalogSetVcAsAFreeSiteParams>
 */
export function bookingsCatalogSetVcAsAFreeSite(params) {
    return { evid: 1104, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarCollectPaymentClick' event (evid: 1105)
 *
 * Event description: Currently relevant only for owner-app.
 * Fires when the user clicks on 'Collect Payment'
 *
 * @param {bookingsCalendarCollectPaymentClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} orderId - order_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {string} referral - from where the action was made. for example: appointment_session_page_owner, calendar_agenda
 * @property {string} sessionId - session_id
 * @property {GUID} serviceId - service_id
 * @return {LogObject<bookingsCalendarCollectPaymentClickParams>} LogObject<bookingsCalendarCollectPaymentClickParams>
 */
export function bookingsCalendarCollectPaymentClick(params) {
    return { evid: 1105, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppRedeemSessionClick' event (evid: 1106)
 *
 * Event description: Currently relevant only for owner-app.
 * Fires when the user clicks on 'Redeem Session' (from pricing plan).
 *
 * @param {bookingsOwnerAppRedeemSessionClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} paymentStatus - paid/not paid...
 * @property {GUID} biToken - msid
 * @property {string} orderId - order_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {string} referral - from where the action was made. for example: appointment_session_page_owner
 * @property {string} sessionId - session_id
 * @property {GUID} serviceId - service_id
 * @return {LogObject<bookingsOwnerAppRedeemSessionClickParams>} LogObject<bookingsOwnerAppRedeemSessionClickParams>
 */
export function bookingsOwnerAppRedeemSessionClick(params) {
    return { evid: 1106, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppChooseAPricingPlanToRedeem' event (evid: 1107)
 *
 * Event description: Currently relevant only for owner-app.
 * Fires when the user clicks on a specific  Pricing Plan to pay for the session. The modal of choosing a plan opens when the participant can pay for the session with more than 1 plan.
 *
 * @param {bookingsOwnerAppChooseAPricingPlanToRedeemParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} orderId - order_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {string} selectedPaymentId - id of the selected Pricing Plan
 * @property {string} paymentMethods - list of the available Pricing Plans Ids
 * @property {string} referral - from where the action was made. for example: appointment_session_page_owner
 * @property {string} sessionId - session_id
 * @property {string} selectedPaymentName - name of the selected Pricing Plan
 * @property {GUID} serviceId - service_id
 * @return {LogObject<bookingsOwnerAppChooseAPricingPlanToRedeemParams>} LogObject<bookingsOwnerAppChooseAPricingPlanToRedeemParams>
 */
export function bookingsOwnerAppChooseAPricingPlanToRedeem(params) {
    return { evid: 1107, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppRedeemSessionPricingPlanMenuIsOpen' event (evid: 1108)
 *
 * Event description: Currently relevant only for owner-app.
 * Fires after the user click on a Redeem Session and  Pricing Plan menu opens up.  The modal of choosing a plan opens when the participant can pay for the session with more than 1 plan.
 *
 * @param {bookingsOwnerAppRedeemSessionPricingPlanMenuIsOpenParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} paymentStatus - paid/not paid...
 * @property {GUID} biToken - msid
 * @property {string} orderId - order_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {string} paymentMethods - list of the available Pricing Plans Ids
 * @property {string} referral - from where the action was made. for example: appointment_session_page_owner
 * @property {string} sessionId - session_id
 * @property {GUID} serviceId - service_id
 * @return {LogObject<bookingsOwnerAppRedeemSessionPricingPlanMenuIsOpenParams>} LogObject<bookingsOwnerAppRedeemSessionPricingPlanMenuIsOpenParams>
 */
export function bookingsOwnerAppRedeemSessionPricingPlanMenuIsOpen(params) {
    return { evid: 1108, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppCollectPaymentMenuIsOpened' event (evid: 1109)
 *
 * Event description: Currently relevant only for owner-app.
 * Fires after the user click on  'Collect Payment' and a menu with the Payment options opens up.
 *
 * @param {bookingsOwnerAppCollectPaymentMenuIsOpenedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} paymentStatus - paid/not paid...
 * @property {GUID} biToken - msid
 * @property {string} orderId - order_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {string} paymentMethods - list of the available payment methods
 * @property {string} referral - from where the action was made. for example: appointment_session_page_owner, calendar_agenda
 * @property {string} sessionId - session_id
 * @property {GUID} serviceId - service_id
 * @return {LogObject<bookingsOwnerAppCollectPaymentMenuIsOpenedParams>} LogObject<bookingsOwnerAppCollectPaymentMenuIsOpenedParams>
 */
export function bookingsOwnerAppCollectPaymentMenuIsOpened(params) {
    return { evid: 1109, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetPageChange' event (evid: 111)
 *
 * Event description: screens_drop_down - app settings
 *
 * @param {bookingsAppSetPageChangeParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {services_list,calendar,booking_info,confirmation,thank_you,bookings_form}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSetPageChangeParams>} LogObject<bookingsAppSetPageChangeParams>
 */
export function bookingsAppSetPageChange(params) {
    return { evid: 111, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogClickOnDiwmPp' event (evid: 1110)
 *
 * Event description: When a user click on DIWM button (relevant for pricing plan)
 * on one of 3 entry points:
 * service form / membership form / packages form.
 *
 * @param {bookingsCatalogClickOnDiwmPpParams} params - The parameters for this event
 * @property {GUID} businessId - business id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} payment_options - with a plan/Per session or with a plan/null
 * @property {string} refferal_info - service_form / membership_form/packages_form
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsCatalogClickOnDiwmPpParams>} LogObject<bookingsCatalogClickOnDiwmPpParams>
 */
export function bookingsCatalogClickOnDiwmPp(params) {
    return { evid: 1110, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogDynamicPricingWarningModalLoad' event (evid: 1111)
 *
 * Event description: If 'Varied' price option was chosen and no price options are assigned then the warning modal is loaded
 *
 * @param {bookingsCatalogDynamicPricingWarningModalLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} serviceType - service_type
 * @property {string} paymentCategory - payment_category
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsCatalogDynamicPricingWarningModalLoadParams>} LogObject<bookingsCatalogDynamicPricingWarningModalLoadParams>
 */
export function bookingsCatalogDynamicPricingWarningModalLoad(params) {
    return { evid: 1111, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogDynamicPricingWarningModalClick' event (evid: 1112)
 *
 * Event description: Any click that the user do on the dynamic pricing warning modal
 *
 * @param {bookingsCatalogDynamicPricingWarningModalClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - Close / Save Anyways / Go Back
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsCatalogDynamicPricingWarningModalClickParams>} LogObject<bookingsCatalogDynamicPricingWarningModalClickParams>
 */
export function bookingsCatalogDynamicPricingWarningModalClick(params) {
    return { evid: 1112, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppSelectStaffSave' event (evid: 1113)
 *
 * Event description: Currently relevant only for owner-app. Generic event
 * fires when the user clicks on 'Save' after choosing staff(by checking the checkbox). please pay attention to the origin and referral fields.
 *
 * @param {bookingsOwnerAppSelectStaffSaveParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} numberOfSelectedStaff - number of staff selected
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id of the staff that was chosen(if multiple then a list of staff ids)
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral - From where the action was made  (for example:  roster_add_button)
 * @property {string} origin - choose_staff/ filter_by_staff
 * @return {LogObject<bookingsOwnerAppSelectStaffSaveParams>} LogObject<bookingsOwnerAppSelectStaffSaveParams>
 */
export function bookingsOwnerAppSelectStaffSave(params) {
    return { evid: 1113, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppEmptyStateClick' event (evid: 1114)
 *
 * Event description: Currently relevant only for owner-app.
 * Generic event fires when the user clicks on cta in empty state. for example: value = add_working_hours/ add_staff_member.
 *
 * @param {bookingsOwnerAppEmptyStateClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - where the empty state presented.for example: one_app_roster.
 * @property {string} value - cta tipe: add_working_hours/ add_staff_member
 * @return {LogObject<bookingsOwnerAppEmptyStateClickParams>} LogObject<bookingsOwnerAppEmptyStateClickParams>
 */
export function bookingsOwnerAppEmptyStateClick(params) {
    return { evid: 1114, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsBookingsPolicyClicks' event (evid: 1115)
 *
 * Event description: Page loaded in Backoffice (for each tab) , with the page name parameter
 *
 * @param {bookingsSettingsBookingsPolicyClicksParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} element - what was the subject of the click, for example limit early bookings
 * @property {string} origin - {editor,myaccount,ADI,OneApp}
 * @property {string} component - what area was the click happant at, for example: client booking rules
 * @property {string} value - Value - for toggles: on/off, for clicks on +/- then plus/minus
 * @property {string} action - what was clicked - toggle/days/hrs/min
 * @return {LogObject<bookingsSettingsBookingsPolicyClicksParams>} LogObject<bookingsSettingsBookingsPolicyClicksParams>
 */
export function bookingsSettingsBookingsPolicyClicks(params) {
    return { evid: 1115, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsCartPopupLoaded' event (evid: 1116)
 *
 * Event description: Page loaded in Backoffice (for each tab) , with the page name parameter
 *
 * @param {bookingsSettingsCartPopupLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isCartActive - true/false/null
 * @property {string} origin - where was the popup showed
 * @property {string} component - add cart/cart checkout
 * @return {LogObject<bookingsSettingsCartPopupLoadedParams>} LogObject<bookingsSettingsCartPopupLoadedParams>
 */
export function bookingsSettingsCartPopupLoaded(params) {
    return { evid: 1116, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsCartPopupClickes' event (evid: 1117)
 *
 * Event description: Page loaded in Backoffice (for each tab) , with the page name parameter
 *
 * @param {bookingsSettingsCartPopupClickesParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - {editor,myaccount,ADI,OneApp}
 * @property {string} component - add cart/cart checkout/cart added
 * @property {string} value - for toggles: on/off, save: t/f (by the toggle), else null
 * @property {string} action - toggle/cancel/install/save/done
 * @return {LogObject<bookingsSettingsCartPopupClickesParams>} LogObject<bookingsSettingsCartPopupClickesParams>
 */
export function bookingsSettingsCartPopupClickes(params) {
    return { evid: 1117, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsCartCartWasAddedPopup' event (evid: 1118)
 *
 * Event description: Page loaded in Backoffice (for each tab) , with the page name parameter
 *
 * @param {bookingsSettingsCartCartWasAddedPopupParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - where was the popup showed
 * @return {LogObject<bookingsSettingsCartCartWasAddedPopupParams>} LogObject<bookingsSettingsCartCartWasAddedPopupParams>
 */
export function bookingsSettingsCartCartWasAddedPopup(params) {
    return { evid: 1118, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffDeleteStaffClick' event (evid: 1119)
 *
 * Event description: When user click on delete Staff button
 *
 * @param {bookingsStaffDeleteStaffClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {funnel,staff_page)
 * @return {LogObject<bookingsStaffDeleteStaffClickParams>} LogObject<bookingsStaffDeleteStaffClickParams>
 */
export function bookingsStaffDeleteStaffClick(params) {
    return { evid: 1119, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetTabMenuClick' event (evid: 112)
 *
 * Event description: tab_menu_click- - app settings
 *
 * @param {bookingsAppSetTabMenuClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL=app settings, widget, widget_footer, widget_sidebar}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isEmptyState - T/F
 * @property {string} pagetype - {private/group}, NULL for widget, service_page
 * @property {string} page_name - NULL for widget
 * @property {string} selection - {manage,layout,design,text,support,upgrade,services}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSetTabMenuClickParams>} LogObject<bookingsAppSetTabMenuClickParams>
 */
export function bookingsAppSetTabMenuClick(params) {
    return { evid: 112, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'dayfulSendFeedbackForm' event (evid: 1120)
 *
 * Event description: When a user send a feedback form in dayful https://prnt.sc/CTMCuhifYWjg
 *
 * @param {dayfulSendFeedbackFormParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} feedbackType - the user select which feedback type he wants to send
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} feedbackText - what the user wrote in the tell us more field
 * @return {LogObject<dayfulSendFeedbackFormParams>} LogObject<dayfulSendFeedbackFormParams>
 */
export function dayfulSendFeedbackForm(params) {
    return { evid: 1120, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsDefaultHoursClick' event (evid: 1121)
 *
 * Event description: Click on the default hours page (Web and Mobile)
 *
 * @param {bookingsSettingsDefaultHoursClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} element - name of the element inside the component that was clicked
 * @property {string} properties - extra data
 * @property {string} origin - chat / IoD  / BO
 * @property {string} component - name of the component clicked
 * @return {LogObject<bookingsSettingsDefaultHoursClickParams>} LogObject<bookingsSettingsDefaultHoursClickParams>
 */
export function bookingsSettingsDefaultHoursClick(params) {
    return { evid: 1121, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceListClickGoToEditorToInstallPp' event (evid: 1122)
 *
 * Event description: when user clicks on the pimple of 'go to editor' when PP is not installed on editor
 *
 * @param {bookingsCatalogServiceListClickGoToEditorToInstallPpParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} uuid - uuid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @property {string} serviceId - service id
 * @property {DateTime} createdDate - created_date
 * @return {LogObject<bookingsCatalogServiceListClickGoToEditorToInstallPpParams>} LogObject<bookingsCatalogServiceListClickGoToEditorToInstallPpParams>
 */
export function bookingsCatalogServiceListClickGoToEditorToInstallPp(params) {
    return { evid: 1122, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogClickSaveServiceDynamicPricingWithFixPrice' event (evid: 1123)
 *
 * Event description: User click on 'save service' when 'varied prices' option was chosen (dynamic pricing), and no price options are assigned (fix price)
 *
 * @param {bookingsCatalogClickSaveServiceDynamicPricingWithFixPriceParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} serviceType - service_type
 * @property {string} paymentCategory - payment_category
 * @property {GUID} biToken - .
 * @property {string} bookingsPlatform - .
 * @property {GUID} msid - .
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsCatalogClickSaveServiceDynamicPricingWithFixPriceParams>} LogObject<bookingsCatalogClickSaveServiceDynamicPricingWithFixPriceParams>
 */
export function bookingsCatalogClickSaveServiceDynamicPricingWithFixPrice(params) {
    return { evid: 1123, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarBookWithoutAnOrderNotificationDisplayed' event (evid: 1125)
 *
 * Event description: A notification is displayed when a book is made but the order is yet to be confirmed.
 *
 * @param {bookingsCalendarBookWithoutAnOrderNotificationDisplayedParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - The page in which the notification was displayed. {appointment_mobile, appointment_popover_web, manage_participants_mobile, manage_participants_web}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {GUID} bookingId - Booking ID
 * @property {string} order_status - no_order/ creating_order
 * @property {string} sessionId - Session ID
 * @property {GUID} contactId - -
 * @property {string} serviceId - service id
 * @return {LogObject<bookingsCalendarBookWithoutAnOrderNotificationDisplayedParams>} LogObject<bookingsCalendarBookWithoutAnOrderNotificationDisplayedParams>
 */
export function bookingsCalendarBookWithoutAnOrderNotificationDisplayed(params) {
    return { evid: 1125, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppManageParticipantsClickOnBookWithoutOrderTooltip' event (evid: 1126)
 *
 * Event description: Bookings > Calendar > Book Without an Order > Click / Hover on Tooltip
 *
 * @param {bookingsOwnerMobileAppManageParticipantsClickOnBookWithoutOrderTooltipParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - The field in which the tooltip was hovered/clicked: {appointment_mobile, appointment_popover_web, manage_participants_mobile, manage_participants_web}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - Booking ID
 * @property {string} tabName - tabName=waitlist/booked
 * @property {string} order_status - no_order/ creating_order
 * @property {string} sessionId - -
 * @property {string} contactId - contact_id
 * @property {string} type - service type (currently only class)
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsOwnerMobileAppManageParticipantsClickOnBookWithoutOrderTooltipParams>} LogObject<bookingsOwnerMobileAppManageParticipantsClickOnBookWithoutOrderTooltipParams>
 */
export function bookingsOwnerMobileAppManageParticipantsClickOnBookWithoutOrderTooltip(params) {
    return { evid: 1126, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppManageParticipantsClickedOnBookWithoutAnOrderTooltip' event (evid: 1127)
 *
 * Event description: A notification is displayed when a book is made but the order is yet to be confirmed.
 *
 * @param {bookingsOwnerMobileAppManageParticipantsClickedOnBookWithoutAnOrderTooltipParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {GUID} bookingId - Booking ID
 * @property {string} tabName - Tab Name
 * @property {string} sessionId - Session ID
 * @property {GUID} contactId - -
 * @property {string} type - Service type (currently only class)
 * @property {string} serviceId - service id
 * @return {LogObject<bookingsOwnerMobileAppManageParticipantsClickedOnBookWithoutAnOrderTooltipParams>} LogObject<bookingsOwnerMobileAppManageParticipantsClickedOnBookWithoutAnOrderTooltipParams>
 */
export function bookingsOwnerMobileAppManageParticipantsClickedOnBookWithoutAnOrderTooltip(params) {
    return { evid: 1127, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCreatePaymentLinkFromApp' event (evid: 1128)
 *
 * Event description: Sent When a payment link is being created from the app
 *
 * @param {bookingsCreatePaymentLinkFromAppParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingId - booking_id
 * @property {GUID} invoiceId - invoice id
 * @property {string} contactId - contact_id
 * @property {string} pageName - manage_participants, appointment_pop_over, contact_panel, full_contact_view
 * @property {string} serviceId - service id
 * @return {LogObject<bookingsCreatePaymentLinkFromAppParams>} LogObject<bookingsCreatePaymentLinkFromAppParams>
 */
export function bookingsCreatePaymentLinkFromApp(params) {
    return { evid: 1128, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'pricingPlanPimpleOnServiceListLogic' event (evid: 1129)
 *
 * Event description: The event is created for AB test -
 * will be sent with the logic of Pricing Plan pimple on service list:
 * user open service list, when there is a service connected to plan and PP is not installed on Editor
 *
 * @param {pricingPlanPimpleOnServiceListLogicParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<pricingPlanPimpleOnServiceListLogicParams>} LogObject<pricingPlanPimpleOnServiceListLogicParams>
 */
export function pricingPlanPimpleOnServiceListLogic(params) {
    return { evid: 1129, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetChangeLayout' event (evid: 113)
 *
 * Event description: tab_menu_click- - app settings
 *
 * @param {bookingsAppSetChangeLayoutParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= app settings, widget}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pagetype - {private/group}  NULL for widget
 * @property {string} page_name - {services_list,calendar,booking_info,confirmation,thank_you}
 * @property {string} selection - {list,grid,classic}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSetChangeLayoutParams>} LogObject<bookingsAppSetChangeLayoutParams>
 */
export function bookingsAppSetChangeLayout(params) {
    return { evid: 113, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditorSettingsServiceListEditServiceAction' event (evid: 1130)
 *
 * Event description: Bookings --> Settings - Element changed (in ADI or Editor)
 *
 * @param {bookingsEditorSettingsServiceListEditServiceActionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} appName - {Widget/Calendar/List}
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} platformName - {ADI/Editor}
 * @property {string} value - t/g
 * @property {string} action - book button/explore plans
 * @return {LogObject<bookingsEditorSettingsServiceListEditServiceActionParams>} LogObject<bookingsEditorSettingsServiceListEditServiceActionParams>
 */
export function bookingsEditorSettingsServiceListEditServiceAction(params) {
    return { evid: 1130, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsPaymentRequestAutomationPopup' event (evid: 1131)
 *
 * Event description: Page loaded in Backoffice (for each tab) , with the page name parameter
 *
 * @param {bookingsSettingsPaymentRequestAutomationPopupParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_active - the value of toggle at the time of each action
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - {editor,myaccount,ADI,OneApp}
 * @property {string} action - Bookings > Settings > Payment Request Automation Popup
 * @return {LogObject<bookingsSettingsPaymentRequestAutomationPopupParams>} LogObject<bookingsSettingsPaymentRequestAutomationPopupParams>
 */
export function bookingsSettingsPaymentRequestAutomationPopup(params) {
    return { evid: 1131, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsPaymentRequestAutomationInitiatePopup' event (evid: 1132)
 *
 * Event description: Page loaded in Backoffice (for each tab) , with the page name parameter
 *
 * @param {bookingsSettingsPaymentRequestAutomationInitiatePopupParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - {editor,myaccount,ADI,OneApp}
 * @property {string} action - load/ cancel/ create automation/ exit
 * @return {LogObject<bookingsSettingsPaymentRequestAutomationInitiatePopupParams>} LogObject<bookingsSettingsPaymentRequestAutomationInitiatePopupParams>
 */
export function bookingsSettingsPaymentRequestAutomationInitiatePopup(params) {
    return { evid: 1132, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppManageParticipantsAddParticipantChooseParticipantClick' event (evid: 1137)
 *
 * Event description: Fires when the user clicks on a participant in the 'Add Participant' screen. Relevant only for the Owner App.
 *
 * @param {bookingsOwnerMobileAppManageParticipantsAddParticipantChooseParticipantClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} tabName - tabName=waitlist/booked
 * @property {string} paymentMethods - list of the available payment methods
 * @property {string} sessionId - session_id
 * @property {string} contactId - contact_id
 * @property {string} type - service type
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsOwnerMobileAppManageParticipantsAddParticipantChooseParticipantClickParams>} LogObject<bookingsOwnerMobileAppManageParticipantsAddParticipantChooseParticipantClickParams>
 */
export function bookingsOwnerMobileAppManageParticipantsAddParticipantChooseParticipantClick(params) {
    return { evid: 1137, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogExposureForNewPolicyUiTest' event (evid: 1138)
 *
 * Event description: This event is being sent once the user is exposed to Service Form or Bookings Settings page (a combination of event 277 with 'page_name' = 'bookings-settings' and event 239).
 *
 * The user is exposed to new UI only if 'readyForNewUi'  = TRUE.
 *
 * The field 'readyForNewUi' refers to the result of the rollout manager, whether the site was migrated to V2 and can get the new policy per service or not.
 *
 * @param {bookingsCatalogExposureForNewPolicyUiTestParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} uuid - uuid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} readyForNewUi - True - site was migrated to V2 and can get the new policy per service
 * @property {string} pageName - service_form / bookings_settings
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsCatalogExposureForNewPolicyUiTestParams>} LogObject<bookingsCatalogExposureForNewPolicyUiTestParams>
 */
export function bookingsCatalogExposureForNewPolicyUiTest(params) {
    return { evid: 1138, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCancel' event (evid: 114)
 *
 * Event description: Cancel
 *
 * @param {bookingsCancelParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} categoryId - -
 * @property {string} location - {up, bottom,null}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referal_info - {add_service,confirm_delete_service,appt_edit,appt_create,blocked_edit,blocked_delete service_wizard, one_app_edit_service, one_app_create_service, popup_service_with_paid_plan_intent,rwg_disconnect,rwg_consent, business notifications}
 * @property {string} service_id - -
 * @return {LogObject<bookingsCancelParams>} LogObject<bookingsCancelParams>
 */
export function bookingsCancel(params) {
    return { evid: 114, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogPolicyListClick' event (evid: 1141)
 *
 * Event description: any click on Policy list
 *
 * @param {bookingsCatalogPolicyListClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} viewMode - modal / page
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} policyId - policy id
 * @property {string} action_type - add_new / edit / delete / duplicate / manage_services / set_as_default / search / click_more / cancel-delete-modal / exit-delete-modal / cancel-connect-services / exit-connect-services / cancel-policy-form
 * @return {LogObject<bookingsCatalogPolicyListClickParams>} LogObject<bookingsCatalogPolicyListClickParams>
 */
export function bookingsCatalogPolicyListClick(params) {
    return { evid: 1141, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsBookingsPolicyChangeClient' event (evid: 1142)
 *
 * Event description: - The event is being sent on any change of booking policy.
 * - When changing the default policy, the event is generated twice: once for the old policy (with 'default' = false) and second for the new policy (with 'default' = true)
 *
 * @param {bookingsSettingsBookingsPolicyChangeClientParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} limitLateBookingPolicyEnabled - true, if a policy applies for limiting late bookings
 * @property {string} viewMode - modal / page (if the policy form was opened as a page or as a modal for example on service form)
 * @property {string} name - The name of the Booking Policy
 * @property {number} waitlistCapacity - Number of spots available in the waitlist
 * @property {number} latestRescheduleInMinutes - Minimum number of minutes before the start of the booked entity that a booking can be rescheduled
 * @property {number} maxParticipantsPerBooking - Maximum number of participants
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} limitEarlyBookingPolicyEnabled - true, if a policy applies for limiting early bookings,
 * @property {boolean} limitLatestCancellation - true, if there is a limit on the latest cancellation time
 * @property {boolean} customPolicyDescriptionEnabled - true, if a policy description should be displayed to the UoU, false, otherwise.
 * @property {boolean} bookingAfterStartPolicyEnabled - true, if booking is allowed after the start of the schedule
 * @property {boolean} participantsPolicyEnabled - true, if a policy with respect to the participants applies
 * @property {number} waitlistReservationTimeInMinutes - Amount of time a participant is given to book, once notified that a spot is available
 * @property {boolean} cancellationPolicyEnabled - true, if canceling a booked entity is allowed
 * @property {string} id - Unique ID that identifies the Booking Policy
 * @property {string} operation - created / updated /  deleted / default_changed
 * @property {string} customPolicyDescription - The description to be displayed to the UoU
 * @property {boolean} reschedulePolicyEnabled - true, if rescheduling a booked entity is allowed
 * @property {number} latestCancellationInMinutes - Minimum number of minutes before the start of the booked entity that a booking can be canceled
 * @property {boolean} default - true, if the Booking Policy is the default, false, otherwise
 * @property {number} latestBookingInMinutes - Minimum number of minutes before the start of the entity that a booking can be made
 * @property {boolean} waitlistPolicyEnabled - true, if the entity has a waitlist
 * @property {boolean} limitLatestReschedule - true, if there is a limit on the latest rescheduling time
 * @property {number} earliestBookingInMinutes - Maximum number of minutes before the start of the entity that a booking can be made
 * @property {DateTime} updatedDate - Timestamp indicating when the Booking Policy was last updated.
 * @property {DateTime} createdDate - Timestamp indicating when the Booking Policy was created.
 * @return {LogObject<bookingsSettingsBookingsPolicyChangeClientParams>} LogObject<bookingsSettingsBookingsPolicyChangeClientParams>
 */
export function bookingsSettingsBookingsPolicyChangeClient(params) {
    return { evid: 1142, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsV1ShutdownStrip' event (evid: 1143)
 *
 * Event description: Bookings > V1 shutdown > update request popup
 *
 * @param {bookingsV1ShutdownStripParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - page name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} visitor_id - -
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - -
 * @property {string} action - load/ update/ learn more click/ close click
 * @return {LogObject<bookingsV1ShutdownStripParams>} LogObject<bookingsV1ShutdownStripParams>
 */
export function bookingsV1ShutdownStrip(params) {
    return { evid: 1143, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsV1ShutdownFailedToBookAppExpired' event (evid: 1144)
 *
 * Event description: Bookings > V1 shutdown > update request popup
 *
 * @param {bookingsV1ShutdownFailedToBookAppExpiredParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - page name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {GUID} visitor_id - -
 * @property {boolean} is_owner - is_owner
 * @property {GUID} contactId - -
 * @property {string} action - load/ update click/ learn more click/ close click
 * @return {LogObject<bookingsV1ShutdownFailedToBookAppExpiredParams>} LogObject<bookingsV1ShutdownFailedToBookAppExpiredParams>
 */
export function bookingsV1ShutdownFailedToBookAppExpired(params) {
    return { evid: 1144, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogAssignServiceToAPolicy' event (evid: 1145)
 *
 * Event description: Policy list > assign service to a policy
 *
 * @param {bookingsCatalogAssignServiceToAPolicyParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} selectedAll - TRUE / FALSE
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} policyId - list of services assigned to the policy
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsCatalogAssignServiceToAPolicyParams>} LogObject<bookingsCatalogAssignServiceToAPolicyParams>
 */
export function bookingsCatalogAssignServiceToAPolicy(params) {
    return { evid: 1145, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOrdersPageCreateNewOrderAddAServicePopupInteractions' event (evid: 1146)
 *
 * Event description: when add a service popup opens in orders page
 *
 * @param {bookingsOrdersPageCreateNewOrderAddAServicePopupInteractionsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} service_id - service_id
 * @property {string} action - load/close/search/tooltip
 * @return {LogObject<bookingsOrdersPageCreateNewOrderAddAServicePopupInteractionsParams>} LogObject<bookingsOrdersPageCreateNewOrderAddAServicePopupInteractionsParams>
 */
export function bookingsOrdersPageCreateNewOrderAddAServicePopupInteractions(params) {
    return { evid: 1146, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOrdersPageCreateNewOrderAddAServicePopupWithNoAppointments' event (evid: 1147)
 *
 * Event description: when add a service popup opens in orders page while the user has no services in general or only has classes/courses
 *
 * @param {bookingsOrdersPageCreateNewOrderAddAServicePopupWithNoAppointmentsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} error_type - no services/no appointments
 * @property {string} action - load/close/create new service
 * @return {LogObject<bookingsOrdersPageCreateNewOrderAddAServicePopupWithNoAppointmentsParams>} LogObject<bookingsOrdersPageCreateNewOrderAddAServicePopupWithNoAppointmentsParams>
 */
export function bookingsOrdersPageCreateNewOrderAddAServicePopupWithNoAppointments(params) {
    return { evid: 1147, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOrdersPageCreateNewOrderScheduleSessionModal' event (evid: 1148)
 *
 * Event description: Open the schedule modal in orders page
 *
 * @param {bookingsOrdersPageCreateNewOrderScheduleSessionModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} serviceType - service type
 * @property {string} start_date - start time
 * @property {GUID} biToken - msid
 * @property {number} price - price
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isPlanRedeem - true if checkbox is marked
 * @property {boolean} isEmptyState - True - empty state
 * @property {string} end_date - end date
 * @property {GUID} staff_id - staff_id
 * @property {GUID} service_id - service id
 * @property {string} value - dropdown selection
 * @property {string} action - load/ close/ back/open dropdown /continue/ checkbox click
 * @property {boolean} isPriceOverride - t/f
 * @return {LogObject<bookingsOrdersPageCreateNewOrderScheduleSessionModalParams>} LogObject<bookingsOrdersPageCreateNewOrderScheduleSessionModalParams>
 */
export function bookingsOrdersPageCreateNewOrderScheduleSessionModal(params) {
    return { evid: 1148, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOrdersPageAddItemDropdown' event (evid: 1149)
 *
 * Event description: when add a service popup opens in orders page
 *
 * @param {bookingsOrdersPageAddItemDropdownParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} action - opened/clicked on services
 * @return {LogObject<bookingsOrdersPageAddItemDropdownParams>} LogObject<bookingsOrdersPageAddItemDropdownParams>
 */
export function bookingsOrdersPageAddItemDropdown(params) {
    return { evid: 1149, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAddNewServiceClick' event (evid: 115)
 *
 * Event description: Click on add a new service (either from web or the mobile app)
 *
 * @param {bookingsAddNewServiceClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} location - {bottom_link, button, one_app_services_tab, one_app_quick_actions_menu, calendar, empty_category, category_hover, empty_state}
 * @property {number} num_of_service - number of services that are currently available in the service list
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - not relevant!!!!
 * @return {LogObject<bookingsAddNewServiceClickParams>} LogObject<bookingsAddNewServiceClickParams>
 */
export function bookingsAddNewServiceClick(params) {
    return { evid: 115, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppTapToPayDiscoverabilityBanner' event (evid: 1150)
 *
 * Event description: Fires when Tap to Pay Discoverability banner, is shown to the user in the Owner App.
 *
 * @param {bookingsOwnerAppTapToPayDiscoverabilityBannerParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - page name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} contactId - -
 * @property {string} action - learn more click/ close click
 * @return {LogObject<bookingsOwnerAppTapToPayDiscoverabilityBannerParams>} LogObject<bookingsOwnerAppTapToPayDiscoverabilityBannerParams>
 */
export function bookingsOwnerAppTapToPayDiscoverabilityBanner(params) {
    return { evid: 1150, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppSellAPlanClick' event (evid: 1153)
 *
 * Event description: Owner clicks on Sell a plan of the service details, visible when the book should be paid with a plan but the client lacks of one. Currently relevant only for appointments.
 *
 * @param {bookingsOwnerMobileAppSellAPlanClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - -
 * @property {string} origin - agneda/calendar_daily/caledare_3_days / Upcoming
 * @property {string} sessionId - --
 * @property {boolean} isPendingApproval - T/F for pending approval service
 * @property {string} type - service type - {individual,groups}
 * @property {string} serviceId - serviceId
 * @return {LogObject<bookingsOwnerMobileAppSellAPlanClickParams>} LogObject<bookingsOwnerMobileAppSellAPlanClickParams>
 */
export function bookingsOwnerMobileAppSellAPlanClick(params) {
    return { evid: 1153, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppAddASessionModal1154' event (evid: 1154)
 *
 * Event description: Add a session modal in the Owner App, which can be opened from two places: quick_action_menu/ one_app_schedule
 *
 * @param {bookingsOwnerAppAddASessionModal1154Params} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} modal_type - manage/connect
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} origin - where did the users come from
 * @property {string} action - load/ appointment_click/ class_click/ blocked_time_click
 * @return {LogObject<bookingsOwnerAppAddASessionModal1154Params>} LogObject<bookingsOwnerAppAddASessionModal1154Params>
 */
export function bookingsOwnerAppAddASessionModal1154(params) {
    return { evid: 1154, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppAddASessionModal1155' event (evid: 1155)
 *
 * Event description: Add a session modal, which can be opened from two places:
 * quick_action_menu/ one_app_schedule.
 * Please pay attention to the action field.
 *
 * @param {bookingsOwnerAppAddASessionModal1155Params} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - from where the modal was opened: quick_action_menu/ one_app_schedule
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} action - load/appointment_click/ class_click/ blocked_time_click
 * @return {LogObject<bookingsOwnerAppAddASessionModal1155Params>} LogObject<bookingsOwnerAppAddASessionModal1155Params>
 */
export function bookingsOwnerAppAddASessionModal1155(params) {
    return { evid: 1155, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarManageParticipantsSellAPlanIntercations' event (evid: 1156)
 *
 * Event description: when the user is shown the sell a plan strip and interact with
 *
 * @param {bookingsCalendarManageParticipantsSellAPlanIntercationsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} session_id - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} client_id - client_id
 * @property {string} origin - calendar/manage participants
 * @property {string} contactId - contact_id
 * @property {string} type - {class, course, blocked_time, appointment, appointment_pending_approval, google_item, ical_item}
 * @property {GUID} service_id - -
 * @property {string} action - load/click
 * @return {LogObject<bookingsCalendarManageParticipantsSellAPlanIntercationsParams>} LogObject<bookingsCalendarManageParticipantsSellAPlanIntercationsParams>
 */
export function bookingsCalendarManageParticipantsSellAPlanIntercations(params) {
    return { evid: 1156, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogFeedbackFormSubmit' event (evid: 1157)
 *
 * Event description: When the user click Submit to feedback form in service list
 *
 * @param {bookingsCatalogFeedbackFormSubmitParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} subject - test in 'Subject'
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} tell_us_more_is_empty - TRUE if empty
 * @property {number} rating - rating
 * @return {LogObject<bookingsCatalogFeedbackFormSubmitParams>} LogObject<bookingsCatalogFeedbackFormSubmitParams>
 */
export function bookingsCatalogFeedbackFormSubmit(params) {
    return { evid: 1157, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditorsServiceListSettingMigration' event (evid: 1158)
 *
 * Event description: This event indicate if the migration to the new Editor service list settings succeeded
 *
 * @param {bookingsEditorsServiceListSettingMigrationParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} servicesFromDifferentCategories - true / false
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} migrationStatus - migration_status
 * @property {string} status - status
 * @property {boolean} singleServiceWidgetWithMoreThanOneService - true / false
 * @property {string} origSettings - orig_settings
 * @property {string} componentMigrated - book_online_page / widget / ...
 * @property {string} component - component
 * @property {number} numberOfServicesWhenMigrated - Number of services on site when migration started
 * @property {string} settings - settings
 * @return {LogObject<bookingsEditorsServiceListSettingMigrationParams>} LogObject<bookingsEditorsServiceListSettingMigrationParams>
 */
export function bookingsEditorsServiceListSettingMigration(params) {
    return { evid: 1158, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarAppointmentModalPopUpLoad' event (evid: 1159)
 *
 * Event description: When a pop up modal load inside the schedule an appointment modal. for example - "this staff member doesn't provide this service"
 *
 * @param {bookingsCalendarAppointmentModalPopUpLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} name - the pop over that was loaded
 * @property {string} modalType - modal_type
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - origin
 * @property {string} action - action
 * @property {string} type - type
 * @property {string} resourceId - resourceId
 * @return {LogObject<bookingsCalendarAppointmentModalPopUpLoadParams>} LogObject<bookingsCalendarAppointmentModalPopUpLoadParams>
 */
export function bookingsCalendarAppointmentModalPopUpLoad(params) {
    return { evid: 1159, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsDeleteButton' event (evid: 116)
 *
 * Event description: Delete_button ALSO SENT FROM ONE APP !!!! notice that the session deletions have the same reffral - need to separate with the browser_name / mobile_app_id
 *
 * @param {bookingsDeleteButtonParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} mobileOneApp - Null\F= desktop\mobile= non app
 * @property {GUID} categoryId - category_id
 * @property {string} session_id - appointment_id as string for new server
 * @property {GUID} biToken - msid
 * @property {number} refund_amount - the refunded amount
 * @property {string} serviceIdList - when is_bulk = true this field contain list of service ids
 * @property {GUID} staffId - when deleting a staff member - send staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isBulk - if the delete action was bulk with few entities (possible since q4 22, from the service list)
 * @property {string} bookingId - booking_id when deleting a course participant booking
 * @property {boolean} confirm_refund - true/ false
 * @property {boolean} notifyChecked - notify_checked
 * @property {string} appointmentId - Deprecated for new server platform
 * @property {string} referal_info - {confirm_delete_CourseSession
 * , confirm_delete_individual
 * , confirm_delete_Groupparticipant
 * , confirm_delete_individualSession
 * , confirm_delete_groupsSession
 * , delete_category
 * , staff
 * , confirm_delete_category
 * , confirm_delete_blockSession
 * , confirm_delete_Courseparticipant
 * , confirm_delete_groups
 * , confirm_delete_course
 * , client note
 * , one_app_delete_service
 * , one_app_delete_service_session
 * ,confirm_delete_class_participant}
 * @property {string} contactId - contact_id in case deleting a participant
 * @property {boolean} isEntireAppointment - true/false
 * @property {string} type - {individual,
 * blockSession,
 * Group,Course,class}
 * @property {string} service_id - service_id
 * @property {string} instance_id - for course instances - send as a string
 * @property {string} refundType - online/ offline/ pricing plans
 * @property {boolean} applyCancellationFee - true / false according to user selection
 * @property {number} cancellationFeeAmount - amount of fee that apply for the cancellation (if applicable)
 * @property {string} cancellationFeeCurrency - currency of the fee that apply for the cancellation (if applicable)
 * @return {LogObject<bookingsDeleteButtonParams>} LogObject<bookingsDeleteButtonParams>
 */
export function bookingsDeleteButton(params) {
    return { evid: 116, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppCalendarClickTodayButton' event (evid: 1160)
 *
 * Event description: Bookings > Owner Mobile App > calendar > click "today" button - brings the user calendar for today's date
 *
 * @param {bookingsOwnerMobileAppCalendarClickTodayButtonParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {DateTime} currentDate - the date the calendar was on when the user clicked
 * @return {LogObject<bookingsOwnerMobileAppCalendarClickTodayButtonParams>} LogObject<bookingsOwnerMobileAppCalendarClickTodayButtonParams>
 */
export function bookingsOwnerMobileAppCalendarClickTodayButton(params) {
    return { evid: 1160, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppCollectPaymentModalClickOnAnOption' event (evid: 1161)
 *
 * Event description: when a user clicks on an option in the collect payment modal
 *
 * @param {bookingsOwnerMobileAppCollectPaymentModalClickOnAnOptionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} clickName - mark_as_paid, send_invoice, view_invoice, enter_card_info, charge_with_pos , redeem_pp, sell_pp
 * @return {LogObject<bookingsOwnerMobileAppCollectPaymentModalClickOnAnOptionParams>} LogObject<bookingsOwnerMobileAppCollectPaymentModalClickOnAnOptionParams>
 */
export function bookingsOwnerMobileAppCollectPaymentModalClickOnAnOption(params) {
    return { evid: 1161, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsEmailReminderToggleOnOff' event (evid: 1163)
 *
 * Event description: Bookings > Settings > Email Reminder Toggle > On/Off
 *
 * @param {bookingsSettingsEmailReminderToggleOnOffParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} section - confirmation / cancelation / reminders
 * @property {string} action - On / Off
 * @return {LogObject<bookingsSettingsEmailReminderToggleOnOffParams>} LogObject<bookingsSettingsEmailReminderToggleOnOffParams>
 */
export function bookingsSettingsEmailReminderToggleOnOff(params) {
    return { evid: 1163, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsEmailRemindersEdit' event (evid: 1164)
 *
 * Event description: Bookings > Settings > Email Reminders > click Edit
 *
 * @param {bookingsSettingsEmailRemindersEditParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} section - confirmation / cancelation / reminders
 * @return {LogObject<bookingsSettingsEmailRemindersEditParams>} LogObject<bookingsSettingsEmailRemindersEditParams>
 */
export function bookingsSettingsEmailRemindersEdit(params) {
    return { evid: 1164, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsEmailRemindersSectionClick' event (evid: 1165)
 *
 * Event description: Bookings > Settings > Email reminders section open
 *
 * @param {bookingsSettingsEmailRemindersSectionClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} section - confirmation / cancelation / reminders
 * @return {LogObject<bookingsSettingsEmailRemindersSectionClickParams>} LogObject<bookingsSettingsEmailRemindersSectionClickParams>
 */
export function bookingsSettingsEmailRemindersSectionClick(params) {
    return { evid: 1165, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsAppsPendingForSuccessfulConnection' event (evid: 1166)
 *
 * Event description: This event fires when the connection ( between  Book button and FB/ Instagram etc) was made successfully
 *
 * @param {bookingsBookingsAppsPendingForSuccessfulConnectionParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} value - Facebook/instagram etc
 * @property {string} action - first_save/edit/upgrade
 * @return {LogObject<bookingsBookingsAppsPendingForSuccessfulConnectionParams>} LogObject<bookingsBookingsAppsPendingForSuccessfulConnectionParams>
 */
export function bookingsBookingsAppsPendingForSuccessfulConnection(params) {
    return { evid: 1166, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsMultiServiceAppointmentPageClick' event (evid: 1168)
 *
 * Event description: Any click on the Multi Service Appointment page in Bookings Settings
 *
 * @param {bookingsSettingsMultiServiceAppointmentPageClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} actionType - The button clicked
 * @property {string} component - The area in Multi Service Appointment page
 * @property {string} toggleStatus - On / Off when clicked SAVE
 * @return {LogObject<bookingsSettingsMultiServiceAppointmentPageClickParams>} LogObject<bookingsSettingsMultiServiceAppointmentPageClickParams>
 */
export function bookingsSettingsMultiServiceAppointmentPageClick(params) {
    return { evid: 1168, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogGenerateAiServiceDescriptionClick' event (evid: 1169)
 *
 * Event description: On Service Form > Generate AI Service Description > Click
 *
 * @param {bookingsCatalogGenerateAiServiceDescriptionClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsCatalogGenerateAiServiceDescriptionClickParams>} LogObject<bookingsCatalogGenerateAiServiceDescriptionClickParams>
 */
export function bookingsCatalogGenerateAiServiceDescriptionClick(params) {
    return { evid: 1169, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEdit' event (evid: 117)
 *
 * Event description: edit click - also relevant to OneApp.                                                          'Staff id' field = resource id (isn't the same guid as 'staff member id')
 * Starting from Feb-2024 there is a new entity = staff member id
 *
 * @param {bookingsEditParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} categoryId - -
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} staffMembersIds - staffMembersIds
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - -
 * @property {string} appointmentId - -
 * @property {string} referal_info - {calendar_groups_session, calendar_individual_session, services_list,appt, staff, staff_availability_service, staff_availability_after_show_service_availability, staff_availability_calendar_pimple, staff_availability_staff_card, one_app_services_tab, one_app_group_session, one_app_individual_session,calendar_block_session, calendar_Course_session}
 * @property {string} sessionId - only when referal_info=appointment-->appointment_id for new server platform
 * @property {string} type - {ind, groups,course,block}
 * @property {string} serviceId - -
 * @property {boolean} isMainParticipant - relevant for participant only- T=main, F- another participant
 * @property {GUID} multiServiceBookingId - multi_service_booking_id
 * @property {string} editType - appointment / session details
 * @return {LogObject<bookingsEditParams>} LogObject<bookingsEditParams>
 */
export function bookingsEdit(params) {
    return { evid: 117, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogResourcesPageClick' event (evid: 1170)
 *
 * Event description: Any click on Resources page
 *
 * @param {bookingsCatalogResourcesPageClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} clickType - the button clicked
 * @property {string} pagename - page name (resources types / items / service form)
 * @property {string} resourceType - Resource type ID
 * @property {string} resource - Resource item ID
 * @return {LogObject<bookingsCatalogResourcesPageClickParams>} LogObject<bookingsCatalogResourcesPageClickParams>
 */
export function bookingsCatalogResourcesPageClick(params) {
    return { evid: 1170, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogResourcesSaveModalClick' event (evid: 1171)
 *
 * Event description: Resources > Save Modal Click
 *
 * @param {bookingsCatalogResourcesSaveModalClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} name - type/item name
 * @property {number} quantity - # of items
 * @property {string} location - location
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} id - type_id / item_id
 * @property {string} selection - save / cancel / close
 * @property {string} entity - resource_type / resource_item
 * @property {string} saveType - new / edit
 * @return {LogObject<bookingsCatalogResourcesSaveModalClickParams>} LogObject<bookingsCatalogResourcesSaveModalClickParams>
 */
export function bookingsCatalogResourcesSaveModalClick(params) {
    return { evid: 1171, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogResourcesDeleteModalClick' event (evid: 1172)
 *
 * Event description: Resources > Delete Modal Click
 *
 * @param {bookingsCatalogResourcesDeleteModalClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} name - type/item name
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} id - type_id / item_id
 * @property {string} selection - save / cancel / close
 * @property {string} entity - resource_type / resource_item
 * @return {LogObject<bookingsCatalogResourcesDeleteModalClickParams>} LogObject<bookingsCatalogResourcesDeleteModalClickParams>
 */
export function bookingsCatalogResourcesDeleteModalClick(params) {
    return { evid: 1172, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogServiceFormSectionClick' event (evid: 1173)
 *
 * Event description: Open / Close a section in Bookings Service Form.
 * Currently implemented only for Resources (July 2023), should be applied also for other sections as well.
 *
 * @param {bookingsCatalogServiceFormSectionClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} section - for example: Resources
 * @property {string} action - open / close
 * @return {LogObject<bookingsCatalogServiceFormSectionClickParams>} LogObject<bookingsCatalogServiceFormSectionClickParams>
 */
export function bookingsCatalogServiceFormSectionClick(params) {
    return { evid: 1173, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsContinueToNextStep' event (evid: 118)
 *
 * Event description: Continue to next step
 *
 * @param {bookingsContinueToNextStepParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - type
 * @property {GUID} biToken - msid
 * @property {string} staffId - staff_id
 * @property {number} price - price
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {GUID} location_guid - location_id
 * @property {string} properties - if any
 * @property {string} scheduleId - schedule_id
 * @property {string} referal_info - {services_list,appt}
 * @property {string} sessionId - session_id
 * @property {GUID} contactId - contact_id
 * @property {string} timeslot - timeslot
 * @property {string} paymentProvider - payment_provider
 * @property {GUID} serviceId - service_id
 * @property {string} action - action
 * @return {LogObject<bookingsContinueToNextStepParams>} LogObject<bookingsContinueToNextStepParams>
 */
export function bookingsContinueToNextStep(params) {
    return { evid: 118, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarManageParticipantsNewParticipantAdded' event (evid: 1181)
 *
 * Event description: after the participant was added, only aug-23
 *
 * @param {bookingsCalendarManageParticipantsNewParticipantAddedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} success - is the action scceeded - NOT SENT
 * @property {GUID} planGuid - plan_guid
 * @property {boolean} isSaveAndAddAnother - T if used the click "Save and add another one"
 * @property {GUID} biToken - msid
 * @property {string} orderId - ecom order id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} recurringRepetition - if not recurring then null
 * @property {string} bookingId - booking_id
 * @property {number} numberOfOptions - from json file, num or price selection
 * @property {string} paymentType - {in_person, paid_plan}
 * @property {string} addOrigin - add participants/add recurring
 * @property {number} numParticipants - Total number of participants (additional participants +main)
 * @property {string} recurringFrequency - if not recurring then null
 * @property {string} save_type - {new, edit}
 * @property {boolean} paymentRequest - T if payment requested
 * @property {string} error - json with the error reason- name, email,phone,over_max
 * @property {string} sessionId - --
 * @property {GUID} contactId - contact_id
 * @property {boolean} confirmationEmailChecked - Send confirmation email is checked?
 * @property {boolean} isRecurring - t/f
 * @property {boolean} checkedOrNot - In the oneApp the owner can mark as checked in from the add-participant-modal. If the owner clicked "Add participant" and the checkbox is checked the value should be TRUE else FALSE
 * @property {string} type - {course, group, class}
 * @property {string} dynamic_price_participants_json - label, amount, num_participants
 * @property {string} serviceId - -
 * @return {LogObject<bookingsCalendarManageParticipantsNewParticipantAddedParams>} LogObject<bookingsCalendarManageParticipantsNewParticipantAddedParams>
 */
export function bookingsCalendarManageParticipantsNewParticipantAdded(params) {
    return { evid: 1181, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarManageParticipantsAddParticipantModal' event (evid: 1182)
 *
 * Event description: Click on the session popover on the calendar. Generic event {component, element}
 *
 * @param {bookingsCalendarManageParticipantsAddParticipantModalParams} params - The parameters for this event
 * @property {GUID} businessId - instance id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} addOrigin - addOrigin
 * @property {GUID} sessionId - session_id
 * @property {string} contactId - contact_id
 * @property {string} modalName - modal_name
 * @property {string} serviceId - service_id
 * @property {string} component - component
 * @property {string} value - value
 * @property {string} action - action
 * @property {number} capacity - num of participants available to this session
 * @return {LogObject<bookingsCalendarManageParticipantsAddParticipantModalParams>} LogObject<bookingsCalendarManageParticipantsAddParticipantModalParams>
 */
export function bookingsCalendarManageParticipantsAddParticipantModal(params) {
    return { evid: 1182, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogLinkBuilderClick' event (evid: 1183)
 *
 * Event description: Bookings > Catalog > Link Builder > Click
 *
 * @param {bookingsCatalogLinkBuilderClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} step - Create link flow: start_link / customize_link / share_options
 * @property {string} location - location
 * @property {GUID} biToken - msid
 * @property {string} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} clickType - button name
 * @property {string} origin - What was the entry point for the create link modal
 * @property {string} serviceId - service_id
 * @property {string} component - component
 * @return {LogObject<bookingsCatalogLinkBuilderClickParams>} LogObject<bookingsCatalogLinkBuilderClickParams>
 */
export function bookingsCatalogLinkBuilderClick(params) {
    return { evid: 1183, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppCalendarEditSessionDetailsModalLoad' event (evid: 1184)
 *
 * Event description: When a modal load from the service list
 *
 * @param {bookingsOwnerAppCalendarEditSessionDetailsModalLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} servicesId - service_id
 * @property {boolean} success - did the modal load successfully. true / false
 * @property {GUID} biToken - msid
 * @property {string} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - edit_appointment_page/create_appointment_page
 * @property {GUID} sessionId - session_id
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsOwnerAppCalendarEditSessionDetailsModalLoadParams>} LogObject<bookingsOwnerAppCalendarEditSessionDetailsModalLoadParams>
 */
export function bookingsOwnerAppCalendarEditSessionDetailsModalLoad(params) {
    return { evid: 1184, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarManageParticipantsClick' event (evid: 1187)
 *
 * Event description: Clicks in manage participants
 *
 * @param {bookingsCalendarManageParticipantsClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} tabName - participants/waitlist
 * @property {string} component - name of the component clicked
 * @property {string} value - value
 * @property {string} action - action
 * @property {number} capacity - number of possible slots in the session
 * @return {LogObject<bookingsCalendarManageParticipantsClickParams>} LogObject<bookingsCalendarManageParticipantsClickParams>
 */
export function bookingsCalendarManageParticipantsClick(params) {
    return { evid: 1187, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarManageParticipantsConflictLoad' event (evid: 1188)
 *
 * Event description: When a conflict loads inside a modal.
 *
 * @param {bookingsCalendarManageParticipantsConflictLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} name - the pop over that was loaded
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} sessionId - session_id
 * @property {string} contactId - contact_id
 * @property {string} type - error/warning
 * @property {string} modalName - modal_name
 * @property {string} serviceId - service_id
 * @property {string} component - component
 * @property {string} conflictType - name of conflict
 * @return {LogObject<bookingsCalendarManageParticipantsConflictLoadParams>} LogObject<bookingsCalendarManageParticipantsConflictLoadParams>
 */
export function bookingsCalendarManageParticipantsConflictLoad(params) {
    return { evid: 1188, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPayrollCalculatorOnboardingClicks' event (evid: 1189)
 *
 * Event description: Generic event for clicks in the payroll calculator onboarding pages {component, action, value, page_name}
 *
 * @param {bookingsPayrollCalculatorOnboardingClicksParams} params - The parameters for this event
 * @property {GUID} businessId - instance id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} addOrigin - addOrigin
 * @property {string} pageName - page_name
 * @property {string} component - component
 * @property {string} value - value
 * @property {string} action - action
 * @property {string} msid2 - site id field for velo app
 * @property {string} uuid2 - userid field for velo app
 * @return {LogObject<bookingsPayrollCalculatorOnboardingClicksParams>} LogObject<bookingsPayrollCalculatorOnboardingClicksParams>
 */
export function bookingsPayrollCalculatorOnboardingClicks(params) {
    return { evid: 1189, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPayrollCalculatorClicksInPayrollReportsPage' event (evid: 1191)
 *
 * Event description: Generic event for clicks in the payroll reports page (component, action, value)
 *
 * @param {bookingsPayrollCalculatorClicksInPayrollReportsPageParams} params - The parameters for this event
 * @property {GUID} businessId - instance id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} addOrigin - addOrigin
 * @property {string} component - component
 * @property {string} value - value
 * @property {string} action - action
 * @return {LogObject<bookingsPayrollCalculatorClicksInPayrollReportsPageParams>} LogObject<bookingsPayrollCalculatorClicksInPayrollReportsPageParams>
 */
export function bookingsPayrollCalculatorClicksInPayrollReportsPage(params) {
    return { evid: 1191, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPayrollCalculatorSavePayrollSettings' event (evid: 1192)
 *
 * Event description: save staff successfully in the staff tab - new\existing and to make sure the app wasn't deleted from the site (24:7, with the relevant app_id)
 *
 * @param {bookingsPayrollCalculatorSavePayrollSettingsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} flatRateAmountPerSession - flat_rate_amount_per_session
 * @property {boolean} success - t/f
 * @property {string} staffid - staff_id
 * @property {string} whoCountsAsParticipant - checked_in_participants/booked_participants
 * @property {GUID} biToken - msid
 * @property {boolean} isPercentageRate - t/f
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isFlatRate - t/f
 * @property {string} origin - OneApp/Desktop
 * @property {boolean} isParticipantRate - t/f
 * @property {string} extraInfo - extra_info
 * @property {number} percentagePerSession - percentage_per_session
 * @property {number} flatRateAmountPerParticipant - flat_rate_amount_per_participan
 * @property {string} serviceId - service_id
 * @property {string} saveType - {create_new, save_changes}
 * @property {string} msid2 - site id field for velo app
 * @property {string} uuid2 - userid field for velo app
 * @return {LogObject<bookingsPayrollCalculatorSavePayrollSettingsParams>} LogObject<bookingsPayrollCalculatorSavePayrollSettingsParams>
 */
export function bookingsPayrollCalculatorSavePayrollSettings(params) {
    return { evid: 1192, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'copyOfBookingsPayrollCalculatorClicksInManagementPages' event (evid: 1193)
 *
 * Event description: Generic event for clicks in the payroll calculator onboarding pages {component, action, value, page_name}
 *
 * @param {copyOfBookingsPayrollCalculatorClicksInManagementPagesParams} params - The parameters for this event
 * @property {GUID} businessId - instance id
 * @property {GUID} biToken - msid
 * @property {string} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} addOrigin - addOrigin
 * @property {string} pageName - page_name
 * @property {string} component - component
 * @property {string} value - value
 * @property {string} action - action
 * @property {string} msid2 - site id field for velo app
 * @property {string} uuid2 - userid field for velo appp
 * @return {LogObject<copyOfBookingsPayrollCalculatorClicksInManagementPagesParams>} LogObject<copyOfBookingsPayrollCalculatorClicksInManagementPagesParams>
 */
export function copyOfBookingsPayrollCalculatorClicksInManagementPages(params) {
    return { evid: 1193, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarRemoveSessionFromGroupPopUp' event (evid: 1196)
 *
 * Event description: Pop up load
 *
 * @param {bookingsCalendarRemoveSessionFromGroupPopUpParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - -
 * @property {string} modalType - reschedule / split
 * @property {GUID} categoryId - -
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {GUID} bookingId - -
 * @property {string} appointmentId - -
 * @property {string} sessionId - -
 * @property {string} serviceId - -
 * @property {string} component - component
 * @property {string} value - value
 * @property {string} action - action
 * @property {GUID} multiServiceBookingId - multi_service_booking_id
 * @return {LogObject<bookingsCalendarRemoveSessionFromGroupPopUpParams>} LogObject<bookingsCalendarRemoveSessionFromGroupPopUpParams>
 */
export function bookingsCalendarRemoveSessionFromGroupPopUp(params) {
    return { evid: 1196, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarMultiServiceBookingSplitCreated' event (evid: 1198)
 *
 * Event description: edit click - also relevant to OneApp
 *
 * @param {bookingsCalendarMultiServiceBookingSplitCreatedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} newNumberOfBookings - New number of bookings in group after the split
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingIds - All booking ids in the group after the split
 * @property {number} originalNumberOfBookings - Old number of bookings in group before the split
 * @property {string} splitInitiator - owner/staff member
 * @property {boolean} isRescheduled - true/false
 * @property {GUID} multiServiceBookingId - multi_service_booking_id
 * @return {LogObject<bookingsCalendarMultiServiceBookingSplitCreatedParams>} LogObject<bookingsCalendarMultiServiceBookingSplitCreatedParams>
 */
export function bookingsCalendarMultiServiceBookingSplitCreated(params) {
    return { evid: 1198, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarCancelSessionWhichIsPartOfAGroupPopUp' event (evid: 1199)
 *
 * Event description: Pop up load
 *
 * @param {bookingsCalendarCancelSessionWhichIsPartOfAGroupPopUpParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - -
 * @property {GUID} categoryId - -
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {GUID} bookingId - -
 * @property {string} appointmentId - -
 * @property {string} sessionId - -
 * @property {string} serviceId - -
 * @property {string} component - component
 * @property {string} value - value
 * @property {string} action - action
 * @property {GUID} multiServiceBookingId - multi_service_booking_id
 * @return {LogObject<bookingsCalendarCancelSessionWhichIsPartOfAGroupPopUpParams>} LogObject<bookingsCalendarCancelSessionWhichIsPartOfAGroupPopUpParams>
 */
export function bookingsCalendarCancelSessionWhichIsPartOfAGroupPopUp(params) {
    return { evid: 1199, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOpenDatesCalendar' event (evid: 120)
 *
 * Event description: Open Dates Calendar
 *
 * @param {bookingsOpenDatesCalendarParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsOpenDatesCalendarParams>} LogObject<bookingsOpenDatesCalendarParams>
 */
export function bookingsOpenDatesCalendar(params) {
    return { evid: 120, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileOwnerAppLabelsCheckForAbTests' event (evid: 1200)
 *
 * Event description: Label check for A/B tests on owner app
 *
 * @param {bookingsMobileOwnerAppLabelsCheckForAbTestsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - business_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} properties - properties
 * @return {LogObject<bookingsMobileOwnerAppLabelsCheckForAbTestsParams>} LogObject<bookingsMobileOwnerAppLabelsCheckForAbTestsParams>
 */
export function bookingsMobileOwnerAppLabelsCheckForAbTests(params) {
    return { evid: 1200, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppCheckoutMobilePosItemsLoaded' event (evid: 1201)
 *
 * Event description: Items loaded event for Checkout flow in Owner app Mobile POS
 *
 * @param {bookingsOwnerAppCheckoutMobilePosItemsLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} page_index - the pagination age index currently loaded
 * @property {GUID} biToken - msid
 * @property {number} paginationSize - the total number of pages in pagination
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} loadType - {default,navigation}
 * @property {string} origin - {sale_screen / search_screen / barcode_scanner / barcode_select_product}
 * @property {number} syncTime - Milliseconds, time of the sync from start
 * @property {number} number_of_items - The number of services loaded on the screen
 * @property {string} mode - referral
 * @return {LogObject<bookingsOwnerAppCheckoutMobilePosItemsLoadedParams>} LogObject<bookingsOwnerAppCheckoutMobilePosItemsLoadedParams>
 */
export function bookingsOwnerAppCheckoutMobilePosItemsLoaded(params) {
    return { evid: 1201, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppCheckoutMobilePosClickItem' event (evid: 1202)
 *
 * Event description: Items loaded event for Checkout flow in Owner app Mobile POS
 *
 * @param {bookingsOwnerAppCheckoutMobilePosClickItemParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} page_index - The first page is always 1. If there was pagination the second is 2
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} rank - number of the item in the list from up to down 1-based count
 * @property {string} origin - {sale_screen / search_screen / barcode_scanner / barcode_select_product}
 * @property {GUID} service_id - the id of the service
 * @property {string} mode - mode
 * @return {LogObject<bookingsOwnerAppCheckoutMobilePosClickItemParams>} LogObject<bookingsOwnerAppCheckoutMobilePosClickItemParams>
 */
export function bookingsOwnerAppCheckoutMobilePosClickItem(params) {
    return { evid: 1202, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCatalogResourcesLimitationBarLoad' event (evid: 1206)
 *
 * Event description: Bookings > Catalog > Resources limitation bar > Load
 *
 * @param {bookingsCatalogResourcesLimitationBarLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} limitationMessage - reached_maximum / almost_reached_maximum
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} limitationType - resource_types / resource_items
 * @property {number} maxAmountAllowed - Max limit of items/types
 * @property {number} currentAmount - current number of of items/types
 * @return {LogObject<bookingsCatalogResourcesLimitationBarLoadParams>} LogObject<bookingsCatalogResourcesLimitationBarLoadParams>
 */
export function bookingsCatalogResourcesLimitationBarLoad(params) {
    return { evid: 1206, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarFirstTimeWelcomeModalLoad' event (evid: 1207)
 *
 * Event description: Modal load or clicks inside the modal when a user first enters the calendar
 *
 * @param {bookingsCalendarFirstTimeWelcomeModalLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} isServiceExist - is there a service on the site when the modal loads
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @property {string} component - component
 * @property {string} action - action
 * @return {LogObject<bookingsCalendarFirstTimeWelcomeModalLoadParams>} LogObject<bookingsCalendarFirstTimeWelcomeModalLoadParams>
 */
export function bookingsCalendarFirstTimeWelcomeModalLoad(params) {
    return { evid: 1207, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditorAddMembersAreaModal' event (evid: 1208)
 *
 * Event description: Bookings > Editor > Add Members Area Modal
 *
 * @param {bookingsEditorAddMembersAreaModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} refferalName - refferal_name
 * @property {string} action - load/ close/ learn more/question mark/ maybe later/ add members area
 * @return {LogObject<bookingsEditorAddMembersAreaModalParams>} LogObject<bookingsEditorAddMembersAreaModalParams>
 */
export function bookingsEditorAddMembersAreaModal(params) {
    return { evid: 1208, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMoveDatesCalendar' event (evid: 121)
 *
 * Event description: Move Dates_calendar
 *
 * @param {bookingsMoveDatesCalendarParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referal_info - {backward,forward}
 * @return {LogObject<bookingsMoveDatesCalendarParams>} LogObject<bookingsMoveDatesCalendarParams>
 */
export function bookingsMoveDatesCalendar(params) {
    return { evid: 121, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsListMainPage' event (evid: 1210)
 *
 * Event description: https://docs.google.com/presentation/d/1ZytlonSKvme90EHZoW7dJQLR9Rj5x0fWui0YyGntQJc/edit#slide=id.g260c05b28c6_1_13
 *
 * @param {bookingsBookingsListMainPageParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} component - name of the component clicked
 * @property {string} value - value
 * @property {string} action - action
 * @property {GUID} bookingId - bookingId
 * @property {string} tabName - tabName
 * @property {string} activeFilters - activeFilters
 * @return {LogObject<bookingsBookingsListMainPageParams>} LogObject<bookingsBookingsListMainPageParams>
 */
export function bookingsBookingsListMainPage(params) {
    return { evid: 1210, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsListCustomFields' event (evid: 1211)
 *
 * Event description: https://docs.google.com/presentation/d/1ZytlonSKvme90EHZoW7dJQLR9Rj5x0fWui0YyGntQJc/edit#slide=id.g2a9263afa48_0_9
 *
 * @param {bookingsBookingsListCustomFieldsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} component - name of the component clicked
 * @property {string} value - value
 * @property {string} action - action
 * @return {LogObject<bookingsBookingsListCustomFieldsParams>} LogObject<bookingsBookingsListCustomFieldsParams>
 */
export function bookingsBookingsListCustomFields(params) {
    return { evid: 1211, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsListUpdateBookingsListApp' event (evid: 1212)
 *
 * Event description: https://docs.google.com/presentation/d/1ZytlonSKvme90EHZoW7dJQLR9Rj5x0fWui0YyGntQJc/edit#slide=id.g2a9263afa48_0_9
 *
 * @param {bookingsBookingsListUpdateBookingsListAppParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} value - value
 * @property {string} action - action
 * @return {LogObject<bookingsBookingsListUpdateBookingsListAppParams>} LogObject<bookingsBookingsListUpdateBookingsListAppParams>
 */
export function bookingsBookingsListUpdateBookingsListApp(params) {
    return { evid: 1212, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppViewSessionSessionActionSheet' event (evid: 1213)
 *
 * Event description: Bookings --> mobile apps --> view --> 3 dots modal
 *
 * clicks inside that modal.
 *
 * @param {bookingsOwnerMobileAppViewSessionSessionActionSheetParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} selectedView - view
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - platform
 * @property {string} selection - selection
 * @property {string} sessionId - session_id
 * @property {string} type - service_type
 * @property {GUID} service_id - service_id
 * @property {string} refferal_info - referral
 * @return {LogObject<bookingsOwnerMobileAppViewSessionSessionActionSheetParams>} LogObject<bookingsOwnerMobileAppViewSessionSessionActionSheetParams>
 */
export function bookingsOwnerMobileAppViewSessionSessionActionSheet(params) {
    return { evid: 1213, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerAppAddNewSessionEmptyStateModal' event (evid: 1215)
 *
 * Event description: When user tries to add a session of some kind, but doesn't have this kind of service on his site.
 *
 * @param {bookingsOwnerAppAddNewSessionEmptyStateModalParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - from where the modal was opened
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} type - appointment /class / no services / no sessions
 * @property {string} component - modal/create/back/add
 * @property {string} action - load/click
 * @return {LogObject<bookingsOwnerAppAddNewSessionEmptyStateModalParams>} LogObject<bookingsOwnerAppAddNewSessionEmptyStateModalParams>
 */
export function bookingsOwnerAppAddNewSessionEmptyStateModal(params) {
    return { evid: 1215, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffStaffContributorsLimitationBarLoad' event (evid: 1216)
 *
 * Event description: when staff / contributors limitation bar is loaded
 *
 * @param {bookingsStaffStaffContributorsLimitationBarLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} messageType - the text on message
 * @property {string} limitType - staff / contributes
 * @property {number} numberOfStaffOrContributersOnSite - Current number of staff / contributors on site
 * @property {string} pageName - page name
 * @return {LogObject<bookingsStaffStaffContributorsLimitationBarLoadParams>} LogObject<bookingsStaffStaffContributorsLimitationBarLoadParams>
 */
export function bookingsStaffStaffContributorsLimitationBarLoad(params) {
    return { evid: 1216, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsFunnelUpgradeButtonClick' event (evid: 1217)
 *
 * Event description: Bookings > Funnel > Upgrade Button > Click
 *
 * @param {bookingsFunnelUpgradeButtonClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} intent - the context for the upgrade click. For example: add staff, add contributor, add resource etc.
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pageName - the page of the upgrade button
 * @return {LogObject<bookingsFunnelUpgradeButtonClickParams>} LogObject<bookingsFunnelUpgradeButtonClickParams>
 */
export function bookingsFunnelUpgradeButtonClick(params) {
    return { evid: 1217, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsTemplateBiEvent' event (evid: 1218)
 *
 * Event description: Template for your use
 *
 * @param {bookingsTemplateBiEventParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - previous page
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} element - element
 * @property {string} component - {modal, back, continue, client}
 * @property {string} value - {check/uncheck, date and time chosen, staff chosen..}
 * @property {string} action - {click, load ...}
 * @return {LogObject<bookingsTemplateBiEventParams>} LogObject<bookingsTemplateBiEventParams>
 */
export function bookingsTemplateBiEvent(params) {
    return { evid: 1218, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsTodayCalendar' event (evid: 122)
 *
 * Event description: Today_calendar - replaced with 16:654.
 *
 * @param {bookingsTodayCalendarParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsTodayCalendarParams>} LogObject<bookingsTodayCalendarParams>
 */
export function bookingsTodayCalendar(params) {
    return { evid: 122, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarCreateNewAppt' event (evid: 123)
 *
 * Event description: schedule a new session
 *
 * @param {bookingsCalendarCreateNewApptParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} location - {button,calendar,one_app_schedule_screen,one_app_calendar, one_app_member_card,one_app_quick_action,quick_actions_panel,one_app_manage_course_sessions_screen}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - {appointment, group session,blockSession, course_session}
 * @return {LogObject<bookingsCalendarCreateNewApptParams>} LogObject<bookingsCalendarCreateNewApptParams>
 */
export function bookingsCalendarCreateNewAppt(params) {
    return { evid: 123, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsDisconnectCalendar' event (evid: 124)
 *
 * Event description: https://zpl.io/2vpxg8j
 *
 * @param {bookingsDisconnectCalendarParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsDisconnectCalendarParams>} LogObject<bookingsDisconnectCalendarParams>
 */
export function bookingsDisconnectCalendar(params) {
    return { evid: 124, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetCategoryMenuSelection' event (evid: 125)
 *
 * Event description: category_menu_selection - app settings . since 14/12/15
 *
 * @param {bookingsAppSetCategoryMenuSelectionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= app settings, widget}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pagetype - {private/group}
 * @property {string} page_name - {services_list,calendar,booking_info,confirmation,thank_you}
 * @property {string} selection - {top, left, no_display}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSetCategoryMenuSelectionParams>} LogObject<bookingsAppSetCategoryMenuSelectionParams>
 */
export function bookingsAppSetCategoryMenuSelection(params) {
    return { evid: 125, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetImageSelection' event (evid: 126)
 *
 * Event description: image_selection - app settings
 *
 * @param {bookingsAppSetImageSelectionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pagetype - {private/group}  NULL for widget
 * @property {string} element - NOT RELEVANT
 * @property {string} page_name - {services_list,calendar,booking_info,confirmation,thank_you}
 * @property {string} selection - {square,round,non}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSetImageSelectionParams>} LogObject<bookingsAppSetImageSelectionParams>
 */
export function bookingsAppSetImageSelection(params) {
    return { evid: 126, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetAlignmentSelection' event (evid: 127)
 *
 * Event description: only in widget and service_page
 *
 * @param {bookingsAppSetAlignmentSelectionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - referral_info
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} element - {title,desc, summary}
 * @property {string} page_name - page_name
 * @property {string} selection - selection
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSetAlignmentSelectionParams>} LogObject<bookingsAppSetAlignmentSelectionParams>
 */
export function bookingsAppSetAlignmentSelection(params) {
    return { evid: 127, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOpenBusinessInfo' event (evid: 128)
 *
 * Event description: Open Editor FROM business_info
 *
 * @param {bookingsOpenBusinessInfoParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referal_info - {confirm_page_link,confirm_page_button}
 * @return {LogObject<bookingsOpenBusinessInfoParams>} LogObject<bookingsOpenBusinessInfoParams>
 */
export function bookingsOpenBusinessInfo(params) {
    return { evid: 128, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsTooltip' event (evid: 130)
 *
 * Event description: clicking on an event in the calendar or the right panel widgets that opens the tooltip
 *
 * @param {bookingsTooltipParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {DateTime} startTime - --
 * @property {string} session_id - session_id
 * @property {string} paymentStatus - { deposit paid / fully paid / Not Paid /Paid in Person / Paid with a paid plan / Paid with invoice / fully paid / free}
 * @property {GUID} biToken - msid
 * @property {string} errorMsg - if there is no error send null
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - -
 * @property {GUID} groupId - group_id
 * @property {string} sessionTimeRange - time range
 * @property {string} attendanceStatus - {Booked / Checked In / No Show}
 * @property {string} contactId - appointment contact
 * @property {boolean} isRecurring - t/f
 * @property {string} layout - calendar layout when clicking on session and the tooltip show up.{Week,Day,Agenda,Staff} *Added on 23.12.21
 * @property {string} type - {class, course, blocked_time, appointment, appointment_pending_approval, google_item, ical_item}
 * @property {GUID} service_id - -
 * @property {GUID} multiServiceBookingId - multi_service_booking_id
 * @property {DateTime} stopTime - --
 * @property {string} additionalResources - additional_resources
 * @return {LogObject<bookingsTooltipParams>} LogObject<bookingsTooltipParams>
 */
export function bookingsTooltip(params) {
    return { evid: 130, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarPopoverClick' event (evid: 131)
 *
 * Event description: Click on the session popover on the calendar. Generic event {component, element}
 *
 * @param {bookingsCalendarPopoverClickParams} params - The parameters for this event
 * @property {GUID} businessId - instance id
 * @property {number} numberOfParticipants - num of participants currently booked to this session (in appointmet will be 0/1)
 * @property {boolean} isPastSchedulingConflict - is_past_scheduling_conflict
 * @property {GUID} sessionStaffId - staff id of this session
 * @property {string} modalType - create / edit
 * @property {DateTime} startTime - session start time
 * @property {string} paymentStatus - paid online, not paid, paid in person, paid with paid plan
 * @property {GUID} biToken - msid
 * @property {boolean} staffNotExists - staff not extists in rebook
 * @property {string} noteMessagae - which conflict? if none then null
 * @property {string} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} numberOnWaitlist - num of participants currently in the waitlist,  0 - if there aren't any,  null - if waitlist is not available
 * @property {GUID} groupId - group_id
 * @property {string} element - name of the element inside the component that was clicked
 * @property {DateTime} endTime - session end time
 * @property {boolean} isSchedulingConflicts - is_scheduling_conflicts
 * @property {string} attendanceStatus - booked / checked in / no show,
 * when change status click, send the status before clicking
 * @property {GUID} locationId - session location id
 * @property {boolean} isWithConflict - true/false
 * @property {string} vcStatus - connected - if the site connected zoom account, generated - if this session already have vc link, null - if not connected
 * @property {GUID} loggedStaffId - logged user staff id
 * @property {string} sessionId - session id
 * @property {string} vcType - type of generated link - zoom / custom / null
 * @property {boolean} isRecurring - is this session recurring
 * @property {boolean} staffNotExist - client not extists in rebook
 * @property {number} numberOfSessions - how many sessions scheduled
 * @property {boolean} seviceNotExists - service not extists in rebook
 * @property {string} pendingStatus - pending / declined / approved / rescheduled,  null - if not pending approval,  when changing status click, send the status before clicking
 * @property {string} type - appointment/class/course/external/block
 * @property {boolean} locationNotExists - location not extists in rebook
 * @property {GUID} serviceId - service_id
 * @property {string} component - component
 * @property {string} locationName - session location name
 * @property {string} value - value
 * @property {boolean} isPaymentRequestSent - when click on send request, send the status before clicking
 * @property {boolean} isStaffNotAssignedConflict - is_staff_not_assigned_conflict
 * @property {GUID} multiServiceBookingId - multi_service_booking_id
 * @property {number} capacity - num of participants available to this session
 * @return {LogObject<bookingsCalendarPopoverClickParams>} LogObject<bookingsCalendarPopoverClickParams>
 */
export function bookingsCalendarPopoverClick(params) {
    return { evid: 131, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsHeaderClose' event (evid: 132)
 *
 * Event description: bookings > header_close.
 *
 * @param {bookingsHeaderCloseParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referal_info - {add_service,services_list,calendar,business_info,confirm_delete_service,callendar_appt,callendar_pop}
 * @return {LogObject<bookingsHeaderCloseParams>} LogObject<bookingsHeaderCloseParams>
 */
export function bookingsHeaderClose(params) {
    return { evid: 132, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBackOfficeOpened' event (evid: 133)
 *
 * Event description: Back office opened
 *
 * @param {bookingsBackOfficeOpenedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} setup_status_services - setup_status_services
 * @property {boolean} setup_status_business_info - setup_status_business_info
 * @property {boolean} setup_status_calendar - setup_status_calendar
 * @property {number} loadingTime - in miliseconds . BO loading time. try-->open
 * @property {string} origin - origin
 * @property {string} pageView - The page that the BO was opened on- {calendar,save_service,popup, business_info}
 * @property {boolean} fromFeed - from_feed
 * @return {LogObject<bookingsBackOfficeOpenedParams>} LogObject<bookingsBackOfficeOpenedParams>
 */
export function bookingsBackOfficeOpened(params) {
    return { evid: 133, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsGetStartedClick' event (evid: 134)
 *
 * Event description: BO - RWG in Marketing state. Get started CTA
 *
 * @param {bookingsGetStartedClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {get_started, create_your_first_service,set_up_your_calendar,add_your_business_info}
 * @return {LogObject<bookingsGetStartedClickParams>} LogObject<bookingsGetStartedClickParams>
 */
export function bookingsGetStartedClick(params) {
    return { evid: 134, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOkGotIt' event (evid: 135)
 *
 * Event description: Temporary modal open and clicked. used for example when showing the 'new calendar' modal in 2022
 *
 * @param {bookingsOkGotItParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} modal_name - {new_calendar}
 * @property {string} got_it_type - {google_connect,calendar_view} , in 2022 changed to: {modal_loaded, cta_clicked}
 * @return {LogObject<bookingsOkGotItParams>} LogObject<bookingsOkGotItParams>
 */
export function bookingsOkGotIt(params) {
    return { evid: 135, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSaveServiceClick' event (evid: 136)
 *
 * Event description: save service click https://jira.wixpress.com/browse/SCHED-1942?filter=-2
 *
 * @param {bookingsSaveServiceClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} price_text_empty - -
 * @property {GUID} biToken - msid
 * @property {boolean} categoryExists - F = empty category
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} service_name_empty - service_name_empty
 * @property {number} participants - number of max participants in service
 * @property {string} errorReason - if null- success
 * @property {string} plan_type - "Priced as": {single_session / membership}
 * @property {string} save_type - {create_new, save_changes}
 * @property {boolean} is_member - TRUE only if membership pricing is chosen AND a connected plan is chosen as well
 * @property {boolean} service_description_empty - -
 * @property {string} price_selection - {price_paid, price_free, empty}
 * @property {boolean} photo_empty - -
 * @property {boolean} duration_empty - -
 * @property {string} category - {empty,new,existing}
 * @property {string} type - { individual,class,course}
 * @property {string} location_choice - {my_place,customer's place,other}
 * @property {string} service_id - -
 * @property {boolean} price_empty - -
 * @property {GUID} clubId - oneapp
 * @return {LogObject<bookingsSaveServiceClickParams>} LogObject<bookingsSaveServiceClickParams>
 */
export function bookingsSaveServiceClick(params) {
    return { evid: 136, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMore137' event (evid: 137)
 *
 * Event description: bookings >  Catalog > RWG > learn_more.click.
 *
 * @param {bookingsMore137Params} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - marketing_state,disconnect_pop_over,criteria_list,category_note_,business_status_box,info_box_submitted_state,info_box_connected_state
 * @property {string} pageName - -
 * @return {LogObject<bookingsMore137Params>} LogObject<bookingsMore137Params>
 */
export function bookingsMore137(params) {
    return { evid: 137, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSaveAppointment' event (evid: 138)
 *
 * Event description: Sent when saving a session - also available from the app (browser name)
 *
 * @param {bookingsSaveAppointmentParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} note_added - True if it filled and False if it's empty
 * @property {number} duration - the session duration(currently only relevant for owner app)
 * @property {boolean} phoneFilled - T=filled
 * @property {string} referralInfo - currenlty only relevant for owner app.from where the session was saved. for example:one_app_quick_action_menu/ one_app_schedule
 * @property {boolean} staffFilled - T= selected
 * @property {boolean} success - T=appointment created
 * @property {string} endDate - timestamp of end time and date
 * @property {string} linkCreationStatus - {null/generated/exists}
 * @property {boolean} emailFilled - T=filled
 * @property {GUID} biToken - msid
 * @property {GUID} orderId - orderId
 * @property {string} noteMessagae - which conflict? if none then null
 * @property {string} staffId - staff_member_id (unique per site)
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} recurringRepetition - repetition count
 * @property {string} bookingId - booking_id
 * @property {string} price_type - label/staff/location
 * @property {GUID} staffUuid - the uuid of the chosen staff member
 * @property {string} paymentType - {paid_plan} or null
 * @property {string} errorReason - if null- success
 * @property {string} repeatUnit - null or if class: {never, weekly, every 2 weeks, every 3 weeks, every 4 weeks}
 * @property {string} recurringFrequency - if not recurring then null
 * @property {string} save_type - {create_appt, save_changes, create_and_add_more}
 * @property {boolean} isOwner - -
 * @property {GUID} locationGuid - location id - if chose business location
 * @property {string} collectPayment - which "collect payment" option the user choose
 * @property {boolean} paymentRequest - T if payment requested
 * @property {string} serviceDetails - json with service_id, start date, end date, session id, staff id for every session booked
 * @property {string} end_date_type - null or 'exists'
 * @property {boolean} notifyChecked - TRUE if the user wishes to notify participants. Only when editing a session
 * @property {string} origin - place where action started
 * @property {boolean} isWithConflict - True if it filled and False if it's empty
 * @property {string} sessionId - -
 * @property {string} contactId - contact_id of the client
 * @property {boolean} locationFilled - true if business location was filled
 * @property {boolean} isRecurring - t/f
 * @property {boolean} clientNameFilled - T=filled
 * @property {boolean} email_checked - T\F
 * @property {boolean} titleFilled - T/F
 * @property {number} numberOfSessions - number_of_sessions
 * @property {boolean} isRebook - is rebooked session
 * @property {string} type - { appointment, group session, appointment_pending_approval,course_session,individualSession, one_app_blockSession, blockSession, course interval, group interval, appointment_pending_approval}
 * @property {boolean} isMultiLocation - True if this is service if more than one location
 * @property {string} startDate - timestamp of start time and date
 * @property {string} dynamic_price_participants_json - ‘label, amount, num_participants
 * @property {string} serviceId - service_id
 * @property {GUID} multiServiceBookingId - multi_service_booking_id
 * @property {string} additionalResources - additional_resources
 * @property {boolean} isPriceChanged - is price changed
 * @property {string} isFromAppointmentWaitlist - is_from_appointment_waitlist
 * @property {string} submissionId - submission_id
 * @property {boolean} bookWithoutEmail - book_without_email
 * @return {LogObject<bookingsSaveAppointmentParams>} LogObject<bookingsSaveAppointmentParams>
 */
export function bookingsSaveAppointment(params) {
    return { evid: 138, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsChangeBusinessInfo' event (evid: 140)
 *
 * Event description: a specific field in the business info was changed
 *
 * @param {bookingsChangeBusinessInfoParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} field - {time_zone,cancellation_policy,subject,message,
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} section - {additional_info,confirmation_email_private,confirmation_email_groups,reminder_email_private,reminder_email_groups,cancellation_email_groups}
 * @return {LogObject<bookingsChangeBusinessInfoParams>} LogObject<bookingsChangeBusinessInfoParams>
 */
export function bookingsChangeBusinessInfo(params) {
    return { evid: 140, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsGetServiceId' event (evid: 141)
 *
 * Event description: after a new service was added (saved) send the service id. service id is created only on save event and not on creation (only in NEW).
 *
 * @param {bookingsGetServiceIdParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} service_id - -
 * @return {LogObject<bookingsGetServiceIdParams>} LogObject<bookingsGetServiceIdParams>
 */
export function bookingsGetServiceId(params) {
    return { evid: 141, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsGetStartedAppSettingsClicked' event (evid: 142)
 *
 * Event description: get_started_app_settings_clicked
 *
 * @param {bookingsGetStartedAppSettingsClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} is_get_started - -
 * @property {string} referral - [service_list_settings, widget_settings]
 * @property {string} pageName - ['manage', 'services']
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsGetStartedAppSettingsClickedParams>} LogObject<bookingsGetStartedAppSettingsClickedParams>
 */
export function bookingsGetStartedAppSettingsClicked(params) {
    return { evid: 142, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetPageTitle' event (evid: 143)
 *
 * Event description: page title - app settings
 *
 * @param {bookingsAppSetPageTitleParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pagetype - {private/group}
 * @property {string} page_name - {services_list,calendar,booking_info,confirmation,thank_you}
 * @property {boolean} check_box - -
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSetPageTitleParams>} LogObject<bookingsAppSetPageTitleParams>
 */
export function bookingsAppSetPageTitle(params) {
    return { evid: 143, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCreateNewCategory' event (evid: 144)
 *
 * Event description: sent when a user add a new category in the edit service screen
 *
 * @param {bookingsCreateNewCategoryParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} categoryId - category_id
 * @property {GUID} biToken - msid
 * @property {string} categoryName - category_name
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} refferalName - service_form / service_list_organize_servoces
 * @property {string} type - private \ group \ none
 * @return {LogObject<bookingsCreateNewCategoryParams>} LogObject<bookingsCreateNewCategoryParams>
 */
export function bookingsCreateNewCategory(params) {
    return { evid: 144, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentsGetPaidClicked' event (evid: 145)
 *
 * Event description: paypal_exp_get_paid.clicked
 *
 * @param {bookingsPaymentsGetPaidClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - type
 * @property {string} referralInfo - -
 * @property {GUID} biToken - msid
 * @property {string} staffId - staff_id value
 * @property {number} price - price
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} bookingId - booking_id
 * @property {GUID} location_guid - location_id value
 * @property {string} scheduleId - schedule_id value
 * @property {string} sessionId - session_id value
 * @property {GUID} contactId - contact_id
 * @property {string} timeslot - timeslot
 * @property {string} paymentProvider - {paypal,stripe} NULL=paypal
 * @property {GUID} serviceId - service_id
 * @return {LogObject<bookingsPaymentsGetPaidClickedParams>} LogObject<bookingsPaymentsGetPaidClickedParams>
 */
export function bookingsPaymentsGetPaidClicked(params) {
    return { evid: 145, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSyncCalendarSendVerificationSuccess' event (evid: 147)
 *
 * Event description: sync calendar request success
 *
 * @param {bookingsSyncCalendarSendVerificationSuccessParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} linkedResourceId - -
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {string} calendarType - calendar_type
 * @return {LogObject<bookingsSyncCalendarSendVerificationSuccessParams>} LogObject<bookingsSyncCalendarSendVerificationSuccessParams>
 */
export function bookingsSyncCalendarSendVerificationSuccess(params) {
    return { evid: 147, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOwnerMobileAppSessionMenuLocationChooseNavigationApp' event (evid: 148)
 *
 * Event description: Bookings > Owner Mobile App >  Session menu > location > choose navigation app
 * When the user click on the location widget in the bottom of the session page in OneApp he can choose to navigate with a navigation app (google maps, waze, apple maps) this event fired when he click on one option
 *
 * @param {bookingsOwnerMobileAppSessionMenuLocationChooseNavigationAppParams} params - The parameters for this event
 * @property {GUID} businessId - businessId
 * @property {string} serviceType - serviceType
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - selection
 * @property {string} sessionId - sessionId
 * @property {GUID} serviceId - serviceId
 * @return {LogObject<bookingsOwnerMobileAppSessionMenuLocationChooseNavigationAppParams>} LogObject<bookingsOwnerMobileAppSessionMenuLocationChooseNavigationAppParams>
 */
export function bookingsOwnerMobileAppSessionMenuLocationChooseNavigationApp(params) {
    return { evid: 148, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentsDisconnectPaymentConfirm' event (evid: 149)
 *
 * Event description: payments.disconnect_payment.confirm
 *
 * @param {bookingsPaymentsDisconnectPaymentConfirmParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} disconnected - if cancel-- FALSE
 * @property {string} paymentProvider - {paypal,stripe} NULL=paypal
 * @return {LogObject<bookingsPaymentsDisconnectPaymentConfirmParams>} LogObject<bookingsPaymentsDisconnectPaymentConfirmParams>
 */
export function bookingsPaymentsDisconnectPaymentConfirm(params) {
    return { evid: 149, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsFeaturePopupOpenIntroduceNewFeature' event (evid: 150)
 *
 * Event description: payments_welcome_popup_open / staff popup / service on video
 *
 * @param {bookingsFeaturePopupOpenIntroduceNewFeatureParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - video conference on service fiorm= "service_video" / {staff} / NULL=payments
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsFeaturePopupOpenIntroduceNewFeatureParams>} LogObject<bookingsFeaturePopupOpenIntroduceNewFeatureParams>
 */
export function bookingsFeaturePopupOpenIntroduceNewFeature(params) {
    return { evid: 150, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceGalleryLoaded' event (evid: 151)
 *
 * Event description: when the service gallery page is loaded - https://prnt.sc/26xne3a
 *
 * @param {bookingsServiceGalleryLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} structureId - The structure id that the page was loaded with (based on it the user get personalized templates for the services)
 * @property {string} templatePricingPlanType - if the template have pricing plan attached what type is it - package or membership. if not null
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} errorReason - If the page wasn't load successfully
 * @property {boolean} isSuccess - did the page loaded succesfully
 * @property {number} numberOfTemplates - num_templates
 * @property {string} origin - button, bottom_link, services empty state, category_hover, empty_category	, deep link
 * @property {string} businessTerm - the user business term
 * @property {string} pageName - bookings_bo / biz_first_funnel
 * @property {string} templateDetails - json with info about all the templates in the page - start from the top left corner, in the following structure- template 1: id, type, name, location, payment_type. template 2:
 * @return {LogObject<bookingsServiceGalleryLoadedParams>} LogObject<bookingsServiceGalleryLoadedParams>
 */
export function bookingsServiceGalleryLoaded(params) {
    return { evid: 151, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentsChangeServicePaymentMethodPopupOpen' event (evid: 152)
 *
 * Event description: payments_change_service_payment_method_popup_open
 *
 * @param {bookingsPaymentsChangeServicePaymentMethodPopupOpenParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {advanced_settings_service_form, price_section_service_form}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsPaymentsChangeServicePaymentMethodPopupOpenParams>} LogObject<bookingsPaymentsChangeServicePaymentMethodPopupOpenParams>
 */
export function bookingsPaymentsChangeServicePaymentMethodPopupOpen(params) {
    return { evid: 152, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceGalleryClick' event (evid: 154)
 *
 * Event description: When a user click something in the service gallery page
 *
 * @param {bookingsServiceGalleryClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} structureName - the structure name the template belongs to
 * @property {string} serviceType - appointment / class/ course
 * @property {string} referralInfo - {funnel,}
 * @property {string} structureId - structure_id
 * @property {string} templatePricingPlanType - Package / membership
 * @property {GUID} biToken - msid
 * @property {string} templatePaymentType - the template payment text
 * @property {string} paymentMethod - online, in person / online and in person / deposit
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} clickType - edit / start from scratch / back / explore_more_templates / next / skip
 * @property {string} templateName - template_name
 * @property {string} loaction - Business location / Custom location / Client's place
 * @property {string} templateId - template_id
 * @property {string} businessTerm - the business term the template belongs to
 * @property {string} pageName - bookings_bo / biz_first_funnel
 * @property {string} templateLocation - the template location text
 * @return {LogObject<bookingsServiceGalleryClickParams>} LogObject<bookingsServiceGalleryClickParams>
 */
export function bookingsServiceGalleryClick(params) {
    return { evid: 154, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingCalendarDeepLinks' event (evid: 155)
 *
 * Event description: Enter the calendar with a deep link. for example when clicking on notification of new booking -> leads to the session on the calendar. an error toast is shown when not success
 *
 * @param {bookingCalendarDeepLinksParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - {notifications, activity_panel_<widget>, staff_page, email, orders}
 * @property {boolean} success - -
 * @property {DateTime} startTime - session start time
 * @property {string} session_id - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} errorReason - -
 * @property {string} action - {open_session_popover, open_external_sync}}
 * @property {DateTime} stopTime - session end time
 * @return {LogObject<bookingCalendarDeepLinksParams>} LogObject<bookingCalendarDeepLinksParams>
 */
export function bookingCalendarDeepLinks(params) {
    return { evid: 155, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsUpgradeReferralClick' event (evid: 156)
 *
 * Event description: upgrade_clicked- from all different locations (referral_info)- {new_group_page,popup_new_group,payments,popup_payments,reminders,popup_reminders,woot,app_settings,left_menu,left_menu_hover,popup_preview_mode}
 *
 * @param {bookingsUpgradeReferralClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget type
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} ts - ts
 * @property {string} referral_info - {new_group_page,popup_new_group,payments,popup_payments,reminders,popup_reminders,woot,app_settings,left_menu,left_menu_hover,popup_preview_mode}
 * @property {string} viewmode - i.e. preview
 * @property {string} editor_working_mode - i.e. desktop
 * @property {GUID} esi - esi
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsUpgradeReferralClickParams>} LogObject<bookingsUpgradeReferralClickParams>
 */
export function bookingsUpgradeReferralClick(params) {
    return { evid: 156, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPopupOpened' event (evid: 157)
 *
 * Event description: upgrade_popup_opened- in popups that are not opened on every click (on certain button)- new_group popup is opened only on the first time of each session.
 *
 * @param {bookingsPopupOpenedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} widget_name - widget name
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {popup_new_group,popup_payments_stripe,popup_payments_paypal, popup_course, popup_individual, popup_service_with_paid_plan_intent}
 * @property {string} paymentProvider - NOT SENT!
 * @return {LogObject<bookingsPopupOpenedParams>} LogObject<bookingsPopupOpenedParams>
 */
export function bookingsPopupOpened(params) {
    return { evid: 157, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsReminderEmailToggle' event (evid: 158)
 *
 * Event description: turn on\off reminder email toggle
 *
 * @param {bookingsReminderEmailToggleParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} action - {ON,OFF}
 * @return {LogObject<bookingsReminderEmailToggleParams>} LogObject<bookingsReminderEmailToggleParams>
 */
export function bookingsReminderEmailToggle(params) {
    return { evid: 158, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEmailServiceTypeTabClick' event (evid: 159)
 *
 * Event description: click on ind\groups tab in the confirmation email or reminder email section in business info                     https://jira.wixpress.com/browse/SCHED-1942?filter=-2
 *
 * @param {bookingsEmailServiceTypeTabClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} tabClicked - {ind,group}
 * @property {string} email_type - {confirmation,reminder}
 * @return {LogObject<bookingsEmailServiceTypeTabClickParams>} LogObject<bookingsEmailServiceTypeTabClickParams>
 */
export function bookingsEmailServiceTypeTabClick(params) {
    return { evid: 159, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSettingsOpened' event (evid: 160)
 *
 * Event description: open app settings of the app
 *
 * @param {bookingsAppSettingsOpenedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {Null = app_settings , widget, service_page, members_area}
 * @property {GUID} biToken - msid
 * @property {string} widget_name - {old_widget}
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isFirst - first time of site
 * @property {boolean} isEmptyState - [true, false]
 * @property {string} serviceId - Service ID
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSettingsOpenedParams>} LogObject<bookingsAppSettingsOpenedParams>
 */
export function bookingsAppSettingsOpened(params) {
    return { evid: 160, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsViewParticipantsCalendarClick' event (evid: 161)
 *
 * Event description: click on view Participants from a meeting in the calendar tooltip
 *
 * @param {bookingsViewParticipantsCalendarClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - place where action took place
 * @property {string} serviceId - -
 * @return {LogObject<bookingsViewParticipantsCalendarClickParams>} LogObject<bookingsViewParticipantsCalendarClickParams>
 */
export function bookingsViewParticipantsCalendarClick(params) {
    return { evid: 161, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsParticipantsAddNewClick' event (evid: 162)
 *
 * Event description: click on add Participants - available also from the app - to be separated by the browser name
 *
 * @param {bookingsParticipantsAddNewClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} location - {upper_button,middle_button}
 * @property {GUID} biToken - msid
 * @property {number} exsitingParticipants - number of exsiting Participants - already in the session
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} maxParticipants - number of Maximum Participants
 * @property {string} origin - {waiting_list}
 * @property {string} sessionId - --
 * @property {string} type - {course, class}
 * @property {string} serviceId - -
 * @return {LogObject<bookingsParticipantsAddNewClickParams>} LogObject<bookingsParticipantsAddNewClickParams>
 */
export function bookingsParticipantsAddNewClick(params) {
    return { evid: 162, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsParticipantsSaveClick' event (evid: 163)
 *
 * Event description: click on the V next to the new Participants. started to be sent again only AROUND 10/7 - available also from the app (browser name)
 *
 * @param {bookingsParticipantsSaveClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} success - is the action scceeded - NOT SENT
 * @property {GUID} planGuid - plan_guid
 * @property {boolean} isSaveAndAddAnother - T if used the click "Save and add another one"
 * @property {GUID} biToken - msid
 * @property {number} exsitingParticipants - number of exsiting Participants - already in the session
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} recurringRepetition - if not recurring then null
 * @property {string} bookingId - booking_id
 * @property {number} numberOfOptions - from json file, num or price selection
 * @property {string} price_type - staff/location/label
 * @property {string} paymentType - {in_person, paid_plan}
 * @property {string} addOrigin - add participants/add recurring
 * @property {string} planName - plan_name
 * @property {number} numParticipants - Total number of participants (additional participants +main)
 * @property {string} recurringFrequency - if not recurring then null
 * @property {string} save_type - {new, edit}
 * @property {number} maxParticipants - number of Maximum Participants
 * @property {boolean} paymentRequest - T if payment requested
 * @property {string} error - json with the error reason- name, email,phone,over_max
 * @property {boolean} notifyChecked - In the oneApp the owner can mark a checkbox to notify the participant from the add-participant-modal. If the owner clicked "Notify participant" and the checkbox is checked the value should be TRUE else FALSE
 * @property {string} origin - OneApp/Desktop
 * @property {string} sessionId - --
 * @property {GUID} contactId - contact_id
 * @property {boolean} confirmationEmailChecked - Send confirmation email is checked?
 * @property {boolean} isRecurring - t/f
 * @property {boolean} checkedOrNot - In the oneApp the owner can mark as checked in from the add-participant-modal. If the owner clicked "Add participant" and the checkbox is checked the value should be TRUE else FALSE
 * @property {string} type - {course, group, class}
 * @property {string} dynamic_price_participants_json - label, amount, num_participants
 * @property {string} serviceId - -
 * @property {boolean} emailFilled - true/false
 * @property {boolean} bookWithoutEmail - book_without_email
 * @return {LogObject<bookingsParticipantsSaveClickParams>} LogObject<bookingsParticipantsSaveClickParams>
 */
export function bookingsParticipantsSaveClick(params) {
    return { evid: 163, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarFilterApptByType' event (evid: 164)
 *
 * Event description: sent when a user filter a service type in the calendar
 *
 * @param {bookingsCalendarFilterApptByTypeParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} isChecked - T/F
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} serviceFiltered - {private \ group \ personal \ non-working}
 * @return {LogObject<bookingsCalendarFilterApptByTypeParams>} LogObject<bookingsCalendarFilterApptByTypeParams>
 */
export function bookingsCalendarFilterApptByType(params) {
    return { evid: 164, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetAddServiceClicked' event (evid: 165)
 *
 * Event description: app settings --> + tab --> add group \ private service
 *
 * @param {bookingsAppSetAddServiceClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pagetype - {private/group/any}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSetAddServiceClickedParams>} LogObject<bookingsAppSetAddServiceClickedParams>
 */
export function bookingsAppSetAddServiceClicked(params) {
    return { evid: 165, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetTextTabChangeText' event (evid: 166)
 *
 * Event description: change text in any element in the app settings- sent only if the element was changed
 *
 * @param {bookingsAppSetTextTabChangeTextParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= app settings, widget,service_page}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pagetype - {private/group} NULL for membersArea
 * @property {string} element - {page_title,button_text,link...}
 * @property {string} page_name - {services,calendar,info,confirmation, members_area}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSetTextTabChangeTextParams>} LogObject<bookingsAppSetTextTabChangeTextParams>
 */
export function bookingsAppSetTextTabChangeText(params) {
    return { evid: 166, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetDesignTabChangeStyle' event (evid: 167)
 *
 * Event description: change color,font or opacity in any element in the app settings - sent only if the element was changed
 *
 * @param {bookingsAppSetDesignTabChangeStyleParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= app settings, widget}
 * @property {string} parameter - {opacity,color,font, slider,width,radius,box,underline}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pagetype - {private/group} NULL for widget or membersArea
 * @property {string} element - {page_title,button_text,text,page background...}
 * @property {string} page_name - {services,calendar,info,confirmation, members_area}NULL for widget
 * @property {boolean} isPreview - is_preview
 * @property {string} tagName - tag_name
 * @return {LogObject<bookingsAppSetDesignTabChangeStyleParams>} LogObject<bookingsAppSetDesignTabChangeStyleParams>
 */
export function bookingsAppSetDesignTabChangeStyle(params) {
    return { evid: 167, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetLayoutTabChangePosition' event (evid: 168)
 *
 * Event description: back click
 *
 * @param {bookingsAppSetLayoutTabChangePositionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} tabTo - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} tabFrom - -
 * @property {string} selection - {private first/ groups first}
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsAppSetLayoutTabChangePositionParams>} LogObject<bookingsAppSetLayoutTabChangePositionParams>
 */
export function bookingsAppSetLayoutTabChangePosition(params) {
    return { evid: 168, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAdditionalHours' event (evid: 169)
 *
 * Event description: add_business_hours
 *
 * @param {bookingsAdditionalHoursParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {business_info, group_service,staff}
 * @property {string} action - {add,remove}
 * @return {LogObject<bookingsAdditionalHoursParams>} LogObject<bookingsAdditionalHoursParams>
 */
export function bookingsAdditionalHours(params) {
    return { evid: 169, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAddNewStaffClick' event (evid: 170)
 *
 * Event description: click on 'add new staff member' in the services pages or in the staff tab
 *
 * @param {bookingsAddNewStaffClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} staffMembersIds - staffMembersIds
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {private_service,group_service,staff_list,staff_tab_button,funnel}
 * @return {LogObject<bookingsAddNewStaffClickParams>} LogObject<bookingsAddNewStaffClickParams>
 */
export function bookingsAddNewStaffClick(params) {
    return { evid: 170, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesCreateNewStaffSuccessExpress' event (evid: 171)
 *
 * Event description: click on V on 'add new staff member' from service page
 *
 * @param {bookingsServicesCreateNewStaffSuccessExpressParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {Funnel, }
 * @property {string} type - {private,group,none}
 * @return {LogObject<bookingsServicesCreateNewStaffSuccessExpressParams>} LogObject<bookingsServicesCreateNewStaffSuccessExpressParams>
 */
export function bookingsServicesCreateNewStaffSuccessExpress(params) {
    return { evid: 171, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffLastDeletePopup' event (evid: 172)
 *
 * Event description: opens when the user wants to delete the remain last staff member
 *
 * @param {bookingsStaffLastDeletePopupParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - OneApp/desktop
 * @return {LogObject<bookingsStaffLastDeletePopupParams>} LogObject<bookingsStaffLastDeletePopupParams>
 */
export function bookingsStaffLastDeletePopup(params) {
    return { evid: 172, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffSaveStaffSuccess' event (evid: 173)
 *
 * Event description: save staff successfully in the staff tab - new\existing
 *
 * @param {bookingsStaffSaveStaffSuccessParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} phoneFilled - -
 * @property {string} referralInfo - {Funnel,}
 * @property {number} businessHoursCounter - number of business hours sections chosen
 * @property {boolean} emailFilled - -
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - 'staff id' field = resource id (isn't the same guid as 'staff member id')
 * Starting from Feb-2024 there is a new entity = staff member id, can be found under staff_members_ids
 * @property {string} staffMembersIds - staff_members_ids
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} vcState - default/personal_zoom/personal_vc/none
 * @property {string} origin - OneApp/Desktop
 * @property {boolean} photoAttached - -
 * @property {string} saveType - {create_new, save_changes}
 * @return {LogObject<bookingsStaffSaveStaffSuccessParams>} LogObject<bookingsStaffSaveStaffSuccessParams>
 */
export function bookingsStaffSaveStaffSuccess(params) {
    return { evid: 173, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarFilterApptByStaffMember' event (evid: 174)
 *
 * Event description: filter calendar appointments by a staff member- one or more. sent only when the selection is changed.
 *
 * @param {bookingsCalendarFilterApptByStaffMemberParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsCalendarFilterApptByStaffMemberParams>} LogObject<bookingsCalendarFilterApptByStaffMemberParams>
 */
export function bookingsCalendarFilterApptByStaffMember(params) {
    return { evid: 174, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditPanelOpen' event (evid: 175)
 *
 * Event description: -
 *
 * @param {bookingsEditPanelOpenParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} panelName - {private_service_list...}
 * @property {boolean} isMainPanel - True= main panel False= sub panel
 * @return {LogObject<bookingsEditPanelOpenParams>} LogObject<bookingsEditPanelOpenParams>
 */
export function bookingsEditPanelOpen(params) {
    return { evid: 175, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditPanelChangeView' event (evid: 176)
 *
 * Event description: -
 *
 * @param {bookingsEditPanelChangeViewParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pageName - {private_service_list...}
 * @return {LogObject<bookingsEditPanelChangeViewParams>} LogObject<bookingsEditPanelChangeViewParams>
 */
export function bookingsEditPanelChangeView(params) {
    return { evid: 176, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditPanelChange' event (evid: 177)
 *
 * Event description: In any change in the edit panel elements the event is sent
 *
 * @param {bookingsEditPanelChangeParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} element - {Button_Text,,Name_of_tab...}
 * @property {string} panelName - NOT SENT
 * @property {string} value - {5:3, 1:1}
 * @return {LogObject<bookingsEditPanelChangeParams>} LogObject<bookingsEditPanelChangeParams>
 */
export function bookingsEditPanelChange(params) {
    return { evid: 177, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditPanelElementShowHide' event (evid: 179)
 *
 * Event description: show hide element
 *
 * @param {bookingsEditPanelElementShowHideParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {boolean} isShow - T=show F=hide
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} element - {Button_Text,,Name_of_tab...}
 * @property {string} panelName - {private_service_list...}
 * @return {LogObject<bookingsEditPanelElementShowHideParams>} LogObject<bookingsEditPanelElementShowHideParams>
 */
export function bookingsEditPanelElementShowHide(params) {
    return { evid: 179, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffExternalCalendarClick' event (evid: 180)
 *
 * Event description: click on the connect\manage staff calendar on the staff tab. Previous to 12.1.22 we didn't have the selection field
 *
 * @param {bookingsStaffExternalCalendarClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - more_actions/staff_card
 * @property {boolean} isResend - T=resend
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - -'staff id' field = resource id (isn't the same guid as 'staff member id')
 * Starting from Feb-2024 there is a new entity = staff member id, can be found in staff_members_ids
 * @property {string} staffMembersIds - staff_members_ids
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isConnect - T= connect click, invite to sync is sent. F= disconnect click, unsync. relevant before change to manage
 * @property {boolean} isResourceLinkedToUserInSession - is the resource is unsyncing himself
 * @property {string} selection - unsync_via_disconnect_modal, unsync_via_providers_list_modal, manage_connection, sync, invite_to_sync
 * @return {LogObject<bookingsStaffExternalCalendarClickParams>} LogObject<bookingsStaffExternalCalendarClickParams>
 */
export function bookingsStaffExternalCalendarClick(params) {
    return { evid: 180, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditor6thButtonGetStartedClick' event (evid: 182)
 *
 * Event description: when the users clicks on bookings 6th button BEFORE provision a popup opens - this event is sent when the "Add Now"/ is clicked --> provision the app + opens BO
 *
 * @param {bookingsEditor6thButtonGetStartedClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} post_reg - post_reg
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} panel_name - bookings_6th_button / editor_add_panel
 * @property {boolean} is_bookings_provisioned - true if this template had Bookings
 * @return {LogObject<bookingsEditor6thButtonGetStartedClickParams>} LogObject<bookingsEditor6thButtonGetStartedClickParams>
 */
export function bookingsEditor6thButtonGetStartedClick(params) {
    return { evid: 182, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppointmentStaffDropDown' event (evid: 185)
 *
 * Event description: change selection in the staff drop down inside the appointments modal
 * http://prntscr.com/bmz2x8
 *
 * @param {bookingsAppointmentStaffDropDownParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isFirst - T=first staff selection, F= change.  NOT SENT
 * @property {string} type - { appointment, group session}
 * @return {LogObject<bookingsAppointmentStaffDropDownParams>} LogObject<bookingsAppointmentStaffDropDownParams>
 */
export function bookingsAppointmentStaffDropDown(params) {
    return { evid: 185, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarAppointmentBeforeServicePopup' event (evid: 188)
 *
 * Event description: when  the "first create service" popup is opened- the user wants to book an appointment manually in the calendar before he created a service.
 * http://prntscr.com/bp1izg
 *
 * @param {bookingsCalendarAppointmentBeforeServicePopupParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsCalendarAppointmentBeforeServicePopupParams>} LogObject<bookingsCalendarAppointmentBeforeServicePopupParams>
 */
export function bookingsCalendarAppointmentBeforeServicePopup(params) {
    return { evid: 188, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffSyncStaffPopupSendVerificationEmail' event (evid: 189)
 *
 * Event description: click on the send in the popup that openes after you click on sync staff. http://prntscr.com/br3rwv
 *
 * @param {bookingsStaffSyncStaffPopupSendVerificationEmailParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} isResend - T=resend
 * @property {boolean} validEmail - T= email is valid
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {staff, calendar}
 * @return {LogObject<bookingsStaffSyncStaffPopupSendVerificationEmailParams>} LogObject<bookingsStaffSyncStaffPopupSendVerificationEmailParams>
 */
export function bookingsStaffSyncStaffPopupSendVerificationEmail(params) {
    return { evid: 189, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffMoreActionsClick' event (evid: 190)
 *
 * Event description: click on the more actions 3 dots on staff tab.
 * http://prntscr.com/by6yvi.
 *  'Staff id' field = resource id (isn't the same guid as 'staff member id')
 * Starting from Feb-2024 there is a new entity = staff member id
 *
 * @param {bookingsStaffMoreActionsClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - -
 * @property {string} staffMembersIds - staffMembersIds
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} generalOrPerStaff - general / per_staff
 * @return {LogObject<bookingsStaffMoreActionsClickParams>} LogObject<bookingsStaffMoreActionsClickParams>
 */
export function bookingsStaffMoreActionsClick(params) {
    return { evid: 190, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsFeaturePopupClicked' event (evid: 193)
 *
 * Event description: payments_welcome_popup_open / staff popup is clicked
 *
 * @param {bookingsFeaturePopupClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - video conference on service form= "service_video" / {staff} / NULL=payments
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {find_out_more, update, cancel, got_it, zoom, connect_zoom, custom_link}
 * @return {LogObject<bookingsFeaturePopupClickedParams>} LogObject<bookingsFeaturePopupClickedParams>
 */
export function bookingsFeaturePopupClicked(params) {
    return { evid: 193, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsManageBookingsOnEditPanelIsClicked' event (evid: 194)
 *
 * Event description: bookings >manage bookings on edit panel is clicked
 *
 * @param {bookingsManageBookingsOnEditPanelIsClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsManageBookingsOnEditPanelIsClickedParams>} LogObject<bookingsManageBookingsOnEditPanelIsClickedParams>
 */
export function bookingsManageBookingsOnEditPanelIsClicked(params) {
    return { evid: 194, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsWidgetChooseService' event (evid: 195)
 *
 * Event description: choose service: http://prntscr.com/c5lecm
 *
 * @param {bookingsWidgetChooseServiceParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} checkedLocation - true/false
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} view_type - {single_service, multi_services}
 * @property {string} pageName - Widget
 * @property {string} filterBy - location/service name
 * @property {string} type - {ind,groups, course}
 * @return {LogObject<bookingsWidgetChooseServiceParams>} LogObject<bookingsWidgetChooseServiceParams>
 */
export function bookingsWidgetChooseService(params) {
    return { evid: 195, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsWidgetEditOrAddService' event (evid: 196)
 *
 * Event description: http://prntscr.com/c5li0c
 *
 * @param {bookingsWidgetEditOrAddServiceParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isEmptyState - Null - no such option. True=empty state, False - not empty state (and has the option in the product)
 * @return {LogObject<bookingsWidgetEditOrAddServiceParams>} LogObject<bookingsWidgetEditOrAddServiceParams>
 */
export function bookingsWidgetEditOrAddService(params) {
    return { evid: 196, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetButtonStyle' event (evid: 197)
 *
 * Event description: only in widget
 *
 * @param {bookingsAppSetButtonStyleParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {NULL= app settings, widget, service_page}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} page_name - {services_list,calendar,booking_info,confirmation,thank_you}
 * @property {string} selection - {frame_colored_background, frame, no_frame}
 * @return {LogObject<bookingsAppSetButtonStyleParams>} LogObject<bookingsAppSetButtonStyleParams>
 */
export function bookingsAppSetButtonStyle(params) {
    return { evid: 197, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsWidgetAppSetServiceInfoShowHide' event (evid: 202)
 *
 * Event description: bookings >widget.app set. service info show\hide
 *
 * @param {bookingsWidgetAppSetServiceInfoShowHideParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {boolean} isShow - T=show F=hide
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} serviceid - -
 * @property {string} cta_name - cta_name
 * @property {string} info - {service_name, duration, type...}
 * @return {LogObject<bookingsWidgetAppSetServiceInfoShowHideParams>} LogObject<bookingsWidgetAppSetServiceInfoShowHideParams>
 */
export function bookingsWidgetAppSetServiceInfoShowHide(params) {
    return { evid: 202, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesRenameStaffClicked' event (evid: 218)
 *
 * Event description: http://prntscr.com/dauc07
 *
 * @param {bookingsServicesRenameStaffClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - {private,group}
 * @return {LogObject<bookingsServicesRenameStaffClickedParams>} LogObject<bookingsServicesRenameStaffClickedParams>
 */
export function bookingsServicesRenameStaffClicked(params) {
    return { evid: 218, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarSyncCalendarsClick' event (evid: 222)
 *
 * Event description: Update 30.8.21 - instead of sending this we are sending 16:362 with page_name = Calendar
 * link_name = manage_external_calendar_connections_modal
 *
 * @param {bookingsCalendarSyncCalendarsClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {sidebar, omni-setup}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsCalendarSyncCalendarsClickParams>} LogObject<bookingsCalendarSyncCalendarsClickParams>
 */
export function bookingsCalendarSyncCalendarsClick(params) {
    return { evid: 222, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBusinessOptionsBookingsPolicySave' event (evid: 224)
 *
 * Event description: http://prntscr.com/dofvq5
 *
 * @param {bookingsBusinessOptionsBookingsPolicySaveParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} clientCanChooseTimezone - client_can_choose_timezone
 * @property {number} waitlistCapacity - Waitlist Capacity - if waitlist_enabled = true. Else - null
 * @property {GUID} biToken - msid
 * @property {string} timezone - the time zone selected
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} save_type - {timeslot_saved,general_settings_saved}
 * @property {boolean} waitlistEnabled - true if the toggle is on and false otherwise
 * @property {string} origin - OneApp/desktop
 * @property {boolean} limit_bookings_in_advance - t/f (toggle on or off)
 * @property {string} timeslot - {service_duration,custom}
 * @property {number} hoursBeforeBookingsLimit - since 3.10: minutes and not hours; how long before the session can clients start bookings (in hours)
 * @property {string} pageName - settings page
 * @property {number} hoursBeforeBookings - since 3.10: minutes and not hours; when is the latest that clients can book the session (in hours)
 * @property {number} hoursBeforeCancellation - since 3.10: minutes and not hours; customers can cancel x hrs before
 * @property {boolean} cancellation_policy_filled - T= filled, F= empty
 * @property {number} waitlistOfferSpot - value in minutes
 * @return {LogObject<bookingsBusinessOptionsBookingsPolicySaveParams>} LogObject<bookingsBusinessOptionsBookingsPolicySaveParams>
 */
export function bookingsBusinessOptionsBookingsPolicySave(params) {
    return { evid: 224, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSaveChangesPopupOpen' event (evid: 225)
 *
 * Event description: bookings >services>save changes popup - http://prntscr.com/dog2nt or http://prntscr.com/i1oj09
 *
 * @param {bookingsSaveChangesPopupOpenParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {staff,services,business_info, delete_service, course_change,save_staff} NULL=payments
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsSaveChangesPopupOpenParams>} LogObject<bookingsSaveChangesPopupOpenParams>
 */
export function bookingsSaveChangesPopupOpen(params) {
    return { evid: 225, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsNoEmailIsConnectedRibbonShowOrClicked' event (evid: 226)
 *
 * Event description: sent when the "no email is connected" ribbon appears\clicked - http://prntscr.com/dog7v6
 *
 * @param {bookingsNoEmailIsConnectedRibbonShowOrClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} action - {show, click} click=define email
 * @return {LogObject<bookingsNoEmailIsConnectedRibbonShowOrClickedParams>} LogObject<bookingsNoEmailIsConnectedRibbonShowOrClickedParams>
 */
export function bookingsNoEmailIsConnectedRibbonShowOrClicked(params) {
    return { evid: 226, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBusinessOptionsCalendarSettingsSave' event (evid: 227)
 *
 * Event description: send when a user finish filling business_setup > calendar settings http://prntscr.com/dogmqk
 *
 * @param {bookingsBusinessOptionsCalendarSettingsSaveParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {number} businessHoursCounter - number of business hours sections chosen
 * @property {GUID} biToken - msid
 * @property {string} timezone - -
 * @property {boolean} business_hours_added - Did the user clicked to add an additional business hours
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} timeInterval - time interval
 * @property {boolean} timezoneChanged - was the timezone changed
 * @property {string} properties - schedule properties
 * @property {string} scheduleId - schedule_id
 * @property {string} previousProperties - schedule properties before save changes
 * @property {string} referralinfo - where the action happened (bookings settings / focus widget/Funnel)
 * @return {LogObject<bookingsBusinessOptionsCalendarSettingsSaveParams>} LogObject<bookingsBusinessOptionsCalendarSettingsSaveParams>
 */
export function bookingsBusinessOptionsCalendarSettingsSave(params) {
    return { evid: 227, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSaveChangesPopupLeaveWoSavingClick' event (evid: 228)
 *
 * Event description: http://prntscr.com/dqjv88
 *
 * @param {bookingsSaveChangesPopupLeaveWoSavingClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - on what page the user is on currently
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} targetInfo - target page
 * @return {LogObject<bookingsSaveChangesPopupLeaveWoSavingClickParams>} LogObject<bookingsSaveChangesPopupLeaveWoSavingClickParams>
 */
export function bookingsSaveChangesPopupLeaveWoSavingClick(params) {
    return { evid: 228, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarChangeView' event (evid: 232)
 *
 * Event description: relevant for calendar before BM calendar implemented on January 2022
 *
 * @param {bookingsCalendarChangeViewParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} view - {week, day,agenda}
 * @return {LogObject<bookingsCalendarChangeViewParams>} LogObject<bookingsCalendarChangeViewParams>
 */
export function bookingsCalendarChangeView(params) {
    return { evid: 232, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppCreatAppoitmentScreenClick' event (evid: 233)
 *
 * Event description: Generic event for clicks in the Add Participant Page or in the Add Appointment page. The clicks differ by component and element.  Pay attention to Origin = Add Participant page/  Add Appointment page.
 *
 * @param {bookingsOneAppCreatAppoitmentScreenClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} outsideWorkingHoursConflict - t/f
 * @property {boolean} isPastSchedulingConflict - t/f
 * @property {GUID} biToken - -
 * @property {GUID} uuid - uuid
 * @property {string} noteMessagae - which note presented on the screen. If none, then null.
 * @property {string} staffId - staff_id
 * @property {string} bookingsPlatform - bookings_platform
 * @property {DateTime} originalEndDate - the timestamp of the end date and time
 * @property {string} element - service / staff member / service location / start date / start time / end date / end time / x button/ search focus
 * @property {DateTime} originalStartDate - original_start_date
 * @property {boolean} isOwner - true if he is the owner of the site
 * @property {GUID} locationGuid - location_guid
 * @property {boolean} isSchedulingConflicts - t/f
 * @property {string} properties - contact_id / service_id / staff member idff/ service location / the start date / the start time / the end date / the end time
 * @property {boolean} anotherSessionBookedConflict - t/f
 * @property {boolean} staffNotWorkingAtThisLocationConflict - t/f
 * @property {string} origin - Have the clicks been made on the add appointment or on edit appointment  or on the add participant page
 * @property {boolean} isWithConflict - T/F
 * @property {string} contactId - contact_id
 * @property {boolean} isNoActivePlansConflict - t/f
 * @property {string} serviceId - service_id
 * @property {string} component - name of the component clicked, for example -
 * service location modal
 * @property {string} action - click/swipe
 * @property {boolean} isStaffNotAssignedConflict - t/f
 * @property {GUID} multiServiceBookingId - multi_service_booking_id
 * @return {LogObject<bookingsOneAppCreatAppoitmentScreenClickParams>} LogObject<bookingsOneAppCreatAppoitmentScreenClickParams>
 */
export function bookingsOneAppCreatAppoitmentScreenClick(params) {
    return { evid: 233, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAdiAddPanelMemberLoginToggle' event (evid: 234)
 *
 * Event description: http://prntscr.com/e5pt9v
 *
 * @param {bookingsAdiAddPanelMemberLoginToggleParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {boolean} toggle - T= activated\enable, F=disable
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsAdiAddPanelMemberLoginToggleParams>} LogObject<bookingsAdiAddPanelMemberLoginToggleParams>
 */
export function bookingsAdiAddPanelMemberLoginToggle(params) {
    return { evid: 234, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentsSquareConnectionPopupClick' event (evid: 235)
 *
 * Event description: send payment request or view invoice drafts
 *
 * @param {bookingsPaymentsSquareConnectionPopupClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - ind/class
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingId - booking_id
 * @property {string} ctaType - create, view_draft, view_partial_paid, view_sent_invoice
 * @property {GUID} invoiceId - invoice_id
 * @property {number} numParticipants - number of participants
 * @property {string} pageName - manage_participants, appointment_pop_over, contact_panel, full_contact_view
 * @property {string} contact_id - contact_id
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsPaymentsSquareConnectionPopupClickParams>} LogObject<bookingsPaymentsSquareConnectionPopupClickParams>
 */
export function bookingsPaymentsSquareConnectionPopupClick(params) {
    return { evid: 235, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBackOfficeOpenClick' event (evid: 238)
 *
 * Event description: back office loaded. (BizManager Only - every time bookings page is loaded)
 *
 * @param {bookingsBackOfficeOpenClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} buttonType - button_type
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - {editor,myaccount,ADI...}
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsBackOfficeOpenClickParams>} LogObject<bookingsBackOfficeOpenClickParams>
 */
export function bookingsBackOfficeOpenClick(params) {
    return { evid: 238, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormOpened' event (evid: 239)
 *
 * Event description: service form is opened (either from the web or from the app)
 *
 * @param {bookingsServiceFormOpenedParams} params - The parameters for this event
 * @property {GUID} businessId - business id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - wizard/preset selection/one_app_create_service/one_app_edit_service / service_gallery_bo / service_gallery_funnel/ one_app_create_service_quick_actions
 * @property {string} type - {individual,class,course} - serviceX: {single,multi}
 * @property {string} screenName - mobile screen name
 * @property {string} mobileFlow - mini form / full form
 * @return {LogObject<bookingsServiceFormOpenedParams>} LogObject<bookingsServiceFormOpenedParams>
 */
export function bookingsServiceFormOpened(params) {
    return { evid: 239, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBusinessOptionsEmailsSaveEmailTemplate' event (evid: 240)
 *
 * Event description: http://prntscr.com/ehx8nn
 *
 * @param {bookingsBusinessOptionsEmailsSaveEmailTemplateParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - not sent
 * @property {boolean} linkExists - whether the vc link exists in the mail
 * @property {string} email_type - {confirmation,reminder,cancellation}
 * @return {LogObject<bookingsBusinessOptionsEmailsSaveEmailTemplateParams>} LogObject<bookingsBusinessOptionsEmailsSaveEmailTemplateParams>
 */
export function bookingsBusinessOptionsEmailsSaveEmailTemplate(params) {
    return { evid: 240, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBusinessOptionsEmailsSendTestEmail' event (evid: 241)
 *
 * Event description: http://prntscr.com/ehx8nn
 *
 * @param {bookingsBusinessOptionsEmailsSendTestEmailParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} success - T=email sent
 * @property {GUID} biToken - msid
 * @property {boolean} emailDefined - T=email exist, F= no email
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - {ind,groups}
 * @property {string} email_type - {confirmation,reminder,cancellation}
 * @return {LogObject<bookingsBusinessOptionsEmailsSendTestEmailParams>} LogObject<bookingsBusinessOptionsEmailsSendTestEmailParams>
 */
export function bookingsBusinessOptionsEmailsSendTestEmail(params) {
    return { evid: 241, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBusinessOptionsEmailsAddEmailClicked' event (evid: 242)
 *
 * Event description: http://prntscr.com/ehxb81 - email_edit
 * http://prntscr.com/ehxbui - banner
 *
 * @param {bookingsBusinessOptionsEmailsAddEmailClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} location - {banner,email_edit)
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - not sent
 * @property {string} email_type - {confirmation,reminder,cancellation}
 * @return {LogObject<bookingsBusinessOptionsEmailsAddEmailClickedParams>} LogObject<bookingsBusinessOptionsEmailsAddEmailClickedParams>
 */
export function bookingsBusinessOptionsEmailsAddEmailClicked(params) {
    return { evid: 242, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBusinessOptionsEmailsSaveEmailAddressSuccess' event (evid: 243)
 *
 * Event description: email address is saved successfully - http://prntscr.com/ek8a7b
 *
 * @param {bookingsBusinessOptionsEmailsSaveEmailAddressSuccessParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} email_type - {ind,groups}
 * @return {LogObject<bookingsBusinessOptionsEmailsSaveEmailAddressSuccessParams>} LogObject<bookingsBusinessOptionsEmailsSaveEmailAddressSuccessParams>
 */
export function bookingsBusinessOptionsEmailsSaveEmailAddressSuccess(params) {
    return { evid: 243, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsParticipantNameClicked' event (evid: 244)
 *
 * Event description: Open the schedule modal (service list or service form). When clicking on the modal - the users redirect to the calendar
 *
 * @param {bookingsClubsGroupSessionsParticipantNameClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {service_list,service_form}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isEmptyState - True - empty state
 * @property {string} type - {class,course}
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsClubsGroupSessionsParticipantNameClickedParams>} LogObject<bookingsClubsGroupSessionsParticipantNameClickedParams>
 */
export function bookingsClubsGroupSessionsParticipantNameClicked(params) {
    return { evid: 244, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsAddToSessionClicked' event (evid: 245)
 *
 * Event description: In the schedule modal - click to schedule sessions
 *
 * @param {bookingsClubsGroupSessionsAddToSessionClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {service_list,service_form}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isEmptyState - is_empty_state
 * @property {string} selection - {calendar_page, schedule_session}
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsClubsGroupSessionsAddToSessionClickedParams>} LogObject<bookingsClubsGroupSessionsAddToSessionClickedParams>
 */
export function bookingsClubsGroupSessionsAddToSessionClicked(params) {
    return { evid: 245, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsRemoveParticipantClicked' event (evid: 250)
 *
 * Event description: When user clicks on remove a participant (should be sent after the confirmation screen).
 *
 * @param {bookingsClubsGroupSessionsRemoveParticipantClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} scheduleId - schedule_id
 * @property {string} sessionId - --
 * @property {GUID} participant_id - participant member Id
 * @property {string} type - {class/course}
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsClubsGroupSessionsRemoveParticipantClickedParams>} LogObject<bookingsClubsGroupSessionsRemoveParticipantClickedParams>
 */
export function bookingsClubsGroupSessionsRemoveParticipantClicked(params) {
    return { evid: 250, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsClickOnAddParticipant' event (evid: 251)
 *
 * Event description: When user clicks on add participant to a group session within the bookings manager.
 *
 * @param {bookingsClubsGroupSessionsClickOnAddParticipantParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} buttonType - Type of button clicked ( 'participant list plus’ / 'empty state participant list'/empty state waitlist)
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} participants - number of booked participants in list
 * @property {string} tabName - waitlist/booked
 * @property {string} sessionId - -
 * @property {GUID} msid - msid
 * @property {GUID} serviceId - service_id
 * @return {LogObject<bookingsClubsGroupSessionsClickOnAddParticipantParams>} LogObject<bookingsClubsGroupSessionsClickOnAddParticipantParams>
 */
export function bookingsClubsGroupSessionsClickOnAddParticipant(params) {
    return { evid: 251, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsMeTabCheckInToSessionClicked' event (evid: 253)
 *
 * Event description: When user clicks on confirm/cancel refund (should be sent after the refund confirmation screen).
 *
 * @param {bookingsClubsMeTabCheckInToSessionClickedParams} params - The parameters for this event
 * @property {GUID} businessId - --
 * @property {string} refund_type - online/ offline/ pricing plans
 * @property {GUID} biToken - --
 * @property {number} refund_amount - the refunded amount
 * @property {string} bookingsPlatform - --
 * @property {boolean} confirm_refund - true/ false
 * @property {string} scheduleId - schedule_id
 * @property {string} sessionId - --
 * @property {GUID} participant_id - participant member Id
 * @property {string} type - {class/course}
 * @property {GUID} msid - --
 * @return {LogObject<bookingsClubsMeTabCheckInToSessionClickedParams>} LogObject<bookingsClubsMeTabCheckInToSessionClickedParams>
 */
export function bookingsClubsMeTabCheckInToSessionClicked(params) {
    return { evid: 253, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsSelfCheckInUnlockClicked' event (evid: 261)
 *
 * Event description: When user clicks on the unlock button
 *
 * @param {bookingsClubsGroupSessionsSelfCheckInUnlockClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsClubsGroupSessionsSelfCheckInUnlockClickedParams>} LogObject<bookingsClubsGroupSessionsSelfCheckInUnlockClickedParams>
 */
export function bookingsClubsGroupSessionsSelfCheckInUnlockClicked(params) {
    return { evid: 261, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsSelfCheckInUnlockSuccess' event (evid: 262)
 *
 * Event description: When user got out of self check in mode
 *
 * @param {bookingsClubsGroupSessionsSelfCheckInUnlockSuccessParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsClubsGroupSessionsSelfCheckInUnlockSuccessParams>} LogObject<bookingsClubsGroupSessionsSelfCheckInUnlockSuccessParams>
 */
export function bookingsClubsGroupSessionsSelfCheckInUnlockSuccess(params) {
    return { evid: 262, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsSelfCheckInImHereClicked' event (evid: 263)
 *
 * Event description: When user clicks on the i'm here button after choosing a name.
 *
 * @param {bookingsClubsGroupSessionsSelfCheckInImHereClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsClubsGroupSessionsSelfCheckInImHereClickedParams>} LogObject<bookingsClubsGroupSessionsSelfCheckInImHereClickedParams>
 */
export function bookingsClubsGroupSessionsSelfCheckInImHereClicked(params) {
    return { evid: 263, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsSelfCheckInClickDone' event (evid: 264)
 *
 * Event description: When user clicks on the i'm here button after choosing a name.
 *
 * @param {bookingsClubsGroupSessionsSelfCheckInClickDoneParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsClubsGroupSessionsSelfCheckInClickDoneParams>} LogObject<bookingsClubsGroupSessionsSelfCheckInClickDoneParams>
 */
export function bookingsClubsGroupSessionsSelfCheckInClickDone(params) {
    return { evid: 264, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsMeTabUncheckClicked' event (evid: 265)
 *
 * Event description: When user click on uncheck in the session screen (after he checked himself to that sessions)
 *
 * @param {bookingsClubsMeTabUncheckClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsClubsMeTabUncheckClickedParams>} LogObject<bookingsClubsMeTabUncheckClickedParams>
 */
export function bookingsClubsMeTabUncheckClicked(params) {
    return { evid: 265, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsMeTabUncheckConfirmationClicked' event (evid: 266)
 *
 * Event description: When user clicks on a button in the confirmation modal presented after clicking on uncheck
 *
 * @param {bookingsClubsMeTabUncheckConfirmationClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @property {string} value - button value: cancel / uncheck
 * @return {LogObject<bookingsClubsMeTabUncheckConfirmationClickedParams>} LogObject<bookingsClubsMeTabUncheckConfirmationClickedParams>
 */
export function bookingsClubsMeTabUncheckConfirmationClicked(params) {
    return { evid: 266, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsParticipantViewContactClicked' event (evid: 268)
 *
 * Event description: When user clicks on "view contact" after clicking on a participant
 *
 * @param {bookingsClubsGroupSessionsParticipantViewContactClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsClubsGroupSessionsParticipantViewContactClickedParams>} LogObject<bookingsClubsGroupSessionsParticipantViewContactClickedParams>
 */
export function bookingsClubsGroupSessionsParticipantViewContactClicked(params) {
    return { evid: 268, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClubsGroupSessionsCheckInOutAllClicked' event (evid: 269)
 *
 * Event description: When a user clicks on check in all button
 *
 * @param {bookingsClubsGroupSessionsCheckInOutAllClickedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @property {string} value - check in / check out
 * @return {LogObject<bookingsClubsGroupSessionsCheckInOutAllClickedParams>} LogObject<bookingsClubsGroupSessionsCheckInOutAllClickedParams>
 */
export function bookingsClubsGroupSessionsCheckInOutAllClicked(params) {
    return { evid: 269, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceInfoMoreDetails' event (evid: 270)
 *
 * Event description: http://prntscr.com/hh8lyn
 *
 * @param {bookingsServiceInfoMoreDetailsParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {more_details, less_details}
 * @property {string} type - group\private\course\none
 * @return {LogObject<bookingsServiceInfoMoreDetailsParams>} LogObject<bookingsServiceInfoMoreDetailsParams>
 */
export function bookingsServiceInfoMoreDetails(params) {
    return { evid: 270, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarServiceFilterClick' event (evid: 271)
 *
 * Event description: http://prntscr.com/i1knyu
 *
 * @param {bookingsCalendarServiceFilterClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsCalendarServiceFilterClickParams>} LogObject<bookingsCalendarServiceFilterClickParams>
 */
export function bookingsCalendarServiceFilterClick(params) {
    return { evid: 271, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSaveChangesPopupClick' event (evid: 272)
 *
 * Event description: bookings > save changes popup click http://prntscr.com/i1m8hw
 *
 * @param {bookingsSaveChangesPopupClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - {edit_course,delete_course_past,delete_course_future, edit_group}
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} email_checked - true=send email to participants
 * @return {LogObject<bookingsSaveChangesPopupClickParams>} LogObject<bookingsSaveChangesPopupClickParams>
 */
export function bookingsSaveChangesPopupClick(params) {
    return { evid: 272, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCustomerCardTabOpened' event (evid: 273)
 *
 * Event description: http://prntscr.com/i3i3du
 *
 * @param {bookingsCustomerCardTabOpenedParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} customer_id - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isEmptyState - true=empty state
 * @return {LogObject<bookingsCustomerCardTabOpenedParams>} LogObject<bookingsCustomerCardTabOpenedParams>
 */
export function bookingsCustomerCardTabOpened(params) {
    return { evid: 273, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarContactInfoClick' event (evid: 274)
 *
 * Event description: Click on the contact name in the appointment popover or manage participants
 *
 * @param {bookingsCalendarContactInfoClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} customer_id - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingId - booking_id
 * @property {string} origin - calendar pop-up / manage participants page /
 * @property {string} contact_id - contact_id
 * @property {string} type - service type
 * @property {string} serviceId - -
 * @return {LogObject<bookingsCalendarContactInfoClickParams>} LogObject<bookingsCalendarContactInfoClickParams>
 */
export function bookingsCalendarContactInfoClick(params) {
    return { evid: 274, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsManageBookingsOnSettingsPanelIsClicked' event (evid: 275)
 *
 * Event description: sent when clicking a link in one of the app settings tab
 *
 * @param {bookingsManageBookingsOnSettingsPanelIsClickedParams} params - The parameters for this event
 * @property {GUID} businessId - businessId
 * @property {Url} linkUrl - goto link
 * @property {string} linkName - Link Name
 * @property {string} tab - Manage, Layout, Settings, Design, Text
 * @property {GUID} biToken - biToken
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} section - optional
 * @property {string} referral - bookings settings, service-widget, old-widget, service_page
 * @property {boolean} isPreview - is_preview
 * @return {LogObject<bookingsManageBookingsOnSettingsPanelIsClickedParams>} LogObject<bookingsManageBookingsOnSettingsPanelIsClickedParams>
 */
export function bookingsManageBookingsOnSettingsPanelIsClicked(params) {
    return { evid: 275, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBoPageLoaded' event (evid: 277)
 *
 * Event description: Page loaded in Backoffice (for each tab) , with the page name parameter
 *
 * @param {bookingsBoPageLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isEmptyState - only on manage participants
 * /waitlist/offerings/services tab: T=services empty state/empty waitlist
 * @property {string} screenResolution - screen resolution
 * @property {string} page_name - page name that is loaded: {Web: calendar,manage participants
 * , offerings, staff, business-info; Mobile: one_app_schedule, one_app_services, one_app_settings, waitlist}
 * @property {string} previousPage - last page seen by the user
 * @property {string} origin - {editor,myaccount,ADI,OneApp}
 * @property {string} accountLanguage - Account language
 * @return {LogObject<bookingsBoPageLoadedParams>} LogObject<bookingsBoPageLoadedParams>
 */
export function bookingsBoPageLoaded(params) {
    return { evid: 277, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceTabLoaded' event (evid: 279)
 *
 * Event description: Service tab loaded in Bookings tabs - dashboard (for each load)
 *
 * @param {bookingsServiceTabLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isEmptyState - only on offerings/services tab: T=services empty state
 * @property {string} origin - {editor,dashboard,onboarding...}
 * @property {string} bannerName - send banner name if not null
 * @return {LogObject<bookingsServiceTabLoadedParams>} LogObject<bookingsServiceTabLoadedParams>
 */
export function bookingsServiceTabLoaded(params) {
    return { evid: 279, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceListPlanClick' event (evid: 280)
 *
 * Event description: view or create price plan from service-list
 *
 * @param {bookingsServiceListPlanClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} location - {upper_button , service_scope, popup_service_with_paid_plan_intent, service_form_connect_plan_dropdown, service_form_connect_plan_empty_state}
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} target_page - {paid_plan_form, paid_plans_modal}
 * @property {string} type - {create_new_limited-plan, create_new_unlimited-plan, view_plan_list , add_to_package,create_new_package , view_plan_list_package , add_to_package}
 * @return {LogObject<bookingsServiceListPlanClickParams>} LogObject<bookingsServiceListPlanClickParams>
 */
export function bookingsServiceListPlanClick(params) {
    return { evid: 280, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPlanSavePlanClick' event (evid: 281)
 *
 * Event description: save plan with number of services in the plan
 *
 * @param {bookingsPlanSavePlanClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - service_list_model = 'service_list_model', paid_plans_bo = null or 'paid_plans_bo'
 * @property {number} numOfServices - num
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} planType - {limited,unlimited}
 * @property {number} numOfActivities - num of sessions / if unlimited - null
 * @property {string} save_type - {create_new, save_changes}
 * @return {LogObject<bookingsPlanSavePlanClickParams>} LogObject<bookingsPlanSavePlanClickParams>
 */
export function bookingsPlanSavePlanClick(params) {
    return { evid: 281, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPricingPlanLoad' event (evid: 282)
 *
 * Event description: Bookings > Catalog > pricing plan > load.
 *
 * @param {bookingsPricingPlanLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - service_list_model = 'service_list_model',  paid_plans_bo = null or 'paid_plans_bo'
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isEmptyState - Bookings service section empty state
 * @return {LogObject<bookingsPricingPlanLoadParams>} LogObject<bookingsPricingPlanLoadParams>
 */
export function bookingsPricingPlanLoad(params) {
    return { evid: 282, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffSetDefaultAvailability' event (evid: 283)
 *
 * Event description: http://prntscr.com/jqm0mu
 * http://prntscr.com/jqm1gy
 *
 * @param {bookingsStaffSetDefaultAvailabilityParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {set availability, back to staff availability}
 * @return {LogObject<bookingsStaffSetDefaultAvailabilityParams>} LogObject<bookingsStaffSetDefaultAvailabilityParams>
 */
export function bookingsStaffSetDefaultAvailability(params) {
    return { evid: 283, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarClickOnCalendar' event (evid: 284)
 *
 * Event description: clicking on the calendar / + button and seeing the pop-up. Also being sent from OneApp (look in the browser name)
 *
 * @param {bookingsCalendarClickOnCalendarParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {DateTime} startTime - only when origin = "time", selected time frame start time
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {DateTime} endTime - only when origin = "time", selected time frame end time
 * @property {string} origin - where did the user click? ("time"/"add_new"/"plus_button (OneApp)")
 * @return {LogObject<bookingsCalendarClickOnCalendarParams>} LogObject<bookingsCalendarClickOnCalendarParams>
 */
export function bookingsCalendarClickOnCalendar(params) {
    return { evid: 284, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsWizardLoaded' event (evid: 285)
 *
 * Event description: Wizard loaded in the BO
 *
 * @param {bookingsWizardLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} isEmptyState - if was opened from services page empty state
 * @property {string} page_name - what page was the wizard opened on (for cases of AB testing) - 'service type'/'vertical type'...
 * @property {string} origin - {services empty state, add button, calendar, empty_category, category_hover, 6th button..}
 * @return {LogObject<bookingsWizardLoadedParams>} LogObject<bookingsWizardLoadedParams>
 */
export function bookingsWizardLoaded(params) {
    return { evid: 285, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsWizardNextOrDone' event (evid: 286)
 *
 * Event description: Wizard - click on next stage after selection
 *
 * @param {bookingsWizardNextOrDoneParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} display_options - string containing all the options the users can choose from on the screen, separated by ','
 * @property {number} question - 1/2
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - 'appointment'/'multiple'/'course'/'class'/different categories
 * @return {LogObject<bookingsWizardNextOrDoneParams>} LogObject<bookingsWizardNextOrDoneParams>
 */
export function bookingsWizardNextOrDone(params) {
    return { evid: 286, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceListOpenPlanTypeClick' event (evid: 287)
 *
 * Event description: http://prntscr.com/ko51zz - when clicking on the button that shows the selection between packages and membership
 *
 * @param {bookingsServiceListOpenPlanTypeClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} location - {upper_button , service_scope}
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - {create_new_plan, manage_memberships}
 * @return {LogObject<bookingsServiceListOpenPlanTypeClickParams>} LogObject<bookingsServiceListOpenPlanTypeClickParams>
 */
export function bookingsServiceListOpenPlanTypeClick(params) {
    return { evid: 287, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppRescheduleASessionUserFlow' event (evid: 289)
 *
 * Event description: Click on Reschedule a session / delete a session
 *
 * @param {bookingsOneAppRescheduleASessionUserFlowParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - agenda_course_more_actions
 * @property {string} session_id - session_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - delete / reschedule
 * @property {string} type - service type (currently only appointment)
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsOneAppRescheduleASessionUserFlowParams>} LogObject<bookingsOneAppRescheduleASessionUserFlowParams>
 */
export function bookingsOneAppRescheduleASessionUserFlow(params) {
    return { evid: 289, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppAddNoteToTheSession' event (evid: 293)
 *
 * Event description: Add note to the session
 *
 * @param {bookingsOneAppAddNoteToTheSessionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - {owner_flow,member_flow}
 * @property {string} type - service type
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsOneAppAddNoteToTheSessionParams>} LogObject<bookingsOneAppAddNoteToTheSessionParams>
 */
export function bookingsOneAppAddNoteToTheSession(params) {
    return { evid: 293, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppSettingsClick' event (evid: 294)
 *
 * Event description: click on one of the settings components
 *
 * @param {bookingsOneAppSettingsClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - f1903b54-7c75-4730-b664-909b9926a7b8
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} component_type - {availability,cancellations_policy, staff, display_settings, roles&permissions}
 * @return {LogObject<bookingsOneAppSettingsClickParams>} LogObject<bookingsOneAppSettingsClickParams>
 */
export function bookingsOneAppSettingsClick(params) {
    return { evid: 294, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppSettingsSave' event (evid: 295)
 *
 * Event description: save one of the settings components
 *
 * @param {bookingsOneAppSettingsSaveParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} groupByCategories - true - if the toggle was switched to on and the other way arround
 * @property {GUID} biToken - f1903b54-7c75-4730-b664-909b9926a7b8
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} params - params json format
 * @property {string} component_type - {availability,display_settings}
 * @return {LogObject<bookingsOneAppSettingsSaveParams>} LogObject<bookingsOneAppSettingsSaveParams>
 */
export function bookingsOneAppSettingsSave(params) {
    return { evid: 295, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsWizardBackToBusinessType' event (evid: 296)
 *
 * Event description: Wizard - click back from question 1 to question 0 in order to re-select (change or no change) the business type
 *
 * @param {bookingsWizardBackToBusinessTypeParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} category - the business category when the user clicked
 * @return {LogObject<bookingsWizardBackToBusinessTypeParams>} LogObject<bookingsWizardBackToBusinessTypeParams>
 */
export function bookingsWizardBackToBusinessType(params) {
    return { evid: 296, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSocialShareClick' event (evid: 297)
 *
 * Event description: Clicking on the share button from a service
 *
 * @param {bookingsSocialShareClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - currently only available in the service card
 * @property {string} type - Service type {class, course, individual}
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsSocialShareClickParams>} LogObject<bookingsSocialShareClickParams>
 */
export function bookingsSocialShareClick(params) {
    return { evid: 297, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSocialShareSelectChannel' event (evid: 298)
 *
 * Event description: Selecting a social share channel by clicking it
 *
 * @param {bookingsSocialShareSelectChannelParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} channel - {Facebook, Linkdin, Twitter, Whatsapp, Copy}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - -
 * @property {string} type - Service type {class, course, individual}
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsSocialShareSelectChannelParams>} LogObject<bookingsSocialShareSelectChannelParams>
 */
export function bookingsSocialShareSelectChannel(params) {
    return { evid: 298, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditor6thButtonSetupWidgetClick' event (evid: 299)
 *
 * Event description: click on one of the CTAs in the bookings 6th button panel in the editor
 *
 * @param {bookingsEditor6thButtonSetupWidgetClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} post_reg - post reg category
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} button_name - {set work hours, set email, connect}
 * @property {string} viewmode - {DESKTOP}
 * @property {string} category - postreg category
 * @return {LogObject<bookingsEditor6thButtonSetupWidgetClickParams>} LogObject<bookingsEditor6thButtonSetupWidgetClickParams>
 */
export function bookingsEditor6thButtonSetupWidgetClick(params) {
    return { evid: 299, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppAppointmentSessionClick' event (evid: 301)
 *
 * Event description: Owner clicks to view of the service details -
 * http://prntscr.com/dcrddz
 *
 * @param {bookingsOneAppAppointmentSessionClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} availableCapacity - --
 * @property {string} origin - agneda/calendar_daily/caledare_3_days / Upcoming
 * @property {GUID} sessionId - --
 * @property {boolean} isPendingApproval - T/F for pending approval service
 * @property {string} type - service type - {individual,groups}
 * @property {string} serviceId - serviceId
 * @return {LogObject<bookingsOneAppAppointmentSessionClickParams>} LogObject<bookingsOneAppAppointmentSessionClickParams>
 */
export function bookingsOneAppAppointmentSessionClick(params) {
    return { evid: 301, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppClickOnBuyMembershipMembershipFlow' event (evid: 306)
 *
 * Event description: Click on "Buy membership" (from the service page where a plan is connected)
 *
 * @param {bookingsOneAppClickOnBuyMembershipMembershipFlowParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} sessionId - --
 * @property {string} type - service type - {individual, groups}
 * @property {string} serviceId - serviceId
 * @return {LogObject<bookingsOneAppClickOnBuyMembershipMembershipFlowParams>} LogObject<bookingsOneAppClickOnBuyMembershipMembershipFlowParams>
 */
export function bookingsOneAppClickOnBuyMembershipMembershipFlow(params) {
    return { evid: 306, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppClickOnSelectMembershipMembershipFlow' event (evid: 307)
 *
 * Event description: Click on "select" membership after selecting to buy a membership
 *
 * @param {bookingsOneAppClickOnSelectMembershipMembershipFlowParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} planType - membership/package
 * @property {string} type - service type - {individual, groups}
 * @property {string} serviceId - serviceId
 * @return {LogObject<bookingsOneAppClickOnSelectMembershipMembershipFlowParams>} LogObject<bookingsOneAppClickOnSelectMembershipMembershipFlowParams>
 */
export function bookingsOneAppClickOnSelectMembershipMembershipFlow(params) {
    return { evid: 307, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppClickBuyNowMembershipFlow' event (evid: 308)
 *
 * Event description: bookings-->one app--> Click "Buy Now" (membership flow)
 *
 * @param {bookingsOneAppClickBuyNowMembershipFlowParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} planType - membership/package
 * @property {string} type - service type - {individual, groups}
 * @property {string} serviceId - serviceId
 * @return {LogObject<bookingsOneAppClickBuyNowMembershipFlowParams>} LogObject<bookingsOneAppClickBuyNowMembershipFlowParams>
 */
export function bookingsOneAppClickBuyNowMembershipFlow(params) {
    return { evid: 308, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppScreenRendered' event (evid: 314)
 *
 * Event description: when specific Bookings screen was rendered OneApp.
 *
 * @param {bookingsOneAppScreenRenderedParams} params - The parameters for this event
 * @property {GUID} businessId - Bookings business_id
 * @property {GUID} biToken - msid
 * @property {string} appName - app_name
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} attendanceStatus - No show / Booked / Checked in
 * @property {string} previousPage - previous_page
 * @property {string} pageName - page_name
 * @property {string} pendingStatus - APPROVED/DECLINED/PENDING
 * @return {LogObject<bookingsOneAppScreenRenderedParams>} LogObject<bookingsOneAppScreenRenderedParams>
 */
export function bookingsOneAppScreenRendered(params) {
    return { evid: 314, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppBannerShown' event (evid: 315)
 *
 * Event description: Banner shown to owner/member.
 * The event is firing When pressing on Broadcast quick action and there are no participants.
 *
 * @param {bookingsOneAppBannerShownParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} screenName - {owner_class_empty, owner_class, owner_private, member_success_screen}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bannerType - {invite_to_service}
 * @return {LogObject<bookingsOneAppBannerShownParams>} LogObject<bookingsOneAppBannerShownParams>
 */
export function bookingsOneAppBannerShown(params) {
    return { evid: 315, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppBannerDismiss' event (evid: 316)
 *
 * Event description: Click on dismiss banner
 *
 * @param {bookingsOneAppBannerDismissParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} screenName - {owner_class_empty, owner_class, owner_private, member_success_screen}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bannerType - {invite_to_service}
 * @return {LogObject<bookingsOneAppBannerDismissParams>} LogObject<bookingsOneAppBannerDismissParams>
 */
export function bookingsOneAppBannerDismiss(params) {
    return { evid: 316, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppBannerClickOnInvite' event (evid: 317)
 *
 * Event description: Click on invite inside the banner
 *
 * @param {bookingsOneAppBannerClickOnInviteParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} screenName - {owner_class_empty, owner_class, owner_private, member_success_screen}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} numParticipants - num of participants when the click in done
 * @property {string} bannerType - {invite_to_service}
 * @return {LogObject<bookingsOneAppBannerClickOnInviteParams>} LogObject<bookingsOneAppBannerClickOnInviteParams>
 */
export function bookingsOneAppBannerClickOnInvite(params) {
    return { evid: 317, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppChoosePaymentOwnerSide' event (evid: 319)
 *
 * Event description: In case of paid plans, the user can choose the desired payment method for the member if they have a membership/package available  https://www.screencast.com/t/w6BNxQZh
 *
 * @param {bookingsOneAppChoosePaymentOwnerSideParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pageType - {in_person, paid_plan}
 * @property {string} type - service type {single/class}
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsOneAppChoosePaymentOwnerSideParams>} LogObject<bookingsOneAppChoosePaymentOwnerSideParams>
 */
export function bookingsOneAppChoosePaymentOwnerSide(params) {
    return { evid: 319, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsWidgetCustomizeClick' event (evid: 322)
 *
 * Event description: click on "customize your widget"
 * http://prntscr.com/m1lnb9
 *
 * @param {bookingsWidgetCustomizeClickParams} params - The parameters for this event
 * @property {GUID} businessId - businessId
 * @property {GUID} biToken - biToken
 * @property {string} appName - widget, service_page
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} tabName - -
 * @property {string} pageName - -
 * @property {boolean} isPreview - -
 * @return {LogObject<bookingsWidgetCustomizeClickParams>} LogObject<bookingsWidgetCustomizeClickParams>
 */
export function bookingsWidgetCustomizeClick(params) {
    return { evid: 322, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEmailsRemindersClickOnBanner' event (evid: 323)
 *
 * Event description: clicking on a banner inside Bookings BO
 *
 * @param {bookingsEmailsRemindersClickOnBannerParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - -
 * @property {string} origin - staff page / any other page
 * @property {string} bannerName - {fitness_video,business info,roles & permissions}
 * @return {LogObject<bookingsEmailsRemindersClickOnBannerParams>} LogObject<bookingsEmailsRemindersClickOnBannerParams>
 */
export function bookingsEmailsRemindersClickOnBanner(params) {
    return { evid: 323, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditorAppSettingsClickOnCustomiseIntervals' event (evid: 325)
 *
 * Event description: https://www.screencast.com/t/I6vcyN2A0zLc
 *
 * @param {bookingsEditorAppSettingsClickOnCustomiseIntervalsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsEditorAppSettingsClickOnCustomiseIntervalsParams>} LogObject<bookingsEditorAppSettingsClickOnCustomiseIntervalsParams>
 */
export function bookingsEditorAppSettingsClickOnCustomiseIntervals(params) {
    return { evid: 325, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsWorkHoursClickOnCustomizeInStaffPage' event (evid: 326)
 *
 * Event description: clicking on the banner to go to "staff"
 *
 * @param {bookingsWorkHoursClickOnCustomizeInStaffPageParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsWorkHoursClickOnCustomizeInStaffPageParams>} LogObject<bookingsWorkHoursClickOnCustomizeInStaffPageParams>
 */
export function bookingsWorkHoursClickOnCustomizeInStaffPage(params) {
    return { evid: 326, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSettingsElementChanged' event (evid: 330)
 *
 * Event description: Bookings --> Settings - Element changed (in ADI or Editor)
 *
 * @param {bookingsSettingsElementChangedParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} appName - {Widget/Calendar/List}
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} platformName - {ADI/Editor}
 * @property {string} tabName - optional {Layouts/Design/Text...}
 * @property {string} element - field/element that was changed
 * @property {string} selection - {square,round,non}
 * @property {string} extraInfo - Json with extra data
 * @return {LogObject<bookingsSettingsElementChangedParams>} LogObject<bookingsSettingsElementChangedParams>
 */
export function bookingsSettingsElementChanged(params) {
    return { evid: 330, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBoSettingsNavigationFromTo' event (evid: 332)
 *
 * Event description: clicking on the  button from the services list to go to setting or clicking on the button from Bookings settings to go to Bookings services
 *
 * @param {bookingsBoSettingsNavigationFromToParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} targetInfo - target page
 * @property {string} buttonOrigin - where did the user click from? (settings/services list/waitlist settings)
 * @return {LogObject<bookingsBoSettingsNavigationFromToParams>} LogObject<bookingsBoSettingsNavigationFromToParams>
 */
export function bookingsBoSettingsNavigationFromTo(params) {
    return { evid: 332, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsTestsExposureEvent' event (evid: 333)
 *
 * Event description: test exposure event for bookings tests
 *
 * @param {bookingsTestsExposureEventParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} testName - test name
 * @property {string} post_reg - postreg_category
 * @property {GUID} biToken - -
 * @property {GUID} uuid - uuid if it's user test, else null
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} is_eligible - true/false
 * @property {string} triggerName - exposure point name
 * @return {LogObject<bookingsTestsExposureEventParams>} LogObject<bookingsTestsExposureEventParams>
 */
export function bookingsTestsExposureEvent(params) {
    return { evid: 333, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesKeyboardClickOnAServiceInKeyboard' event (evid: 334)
 *
 * Event description: when clicking on one of the services in crazy chat keyboard (OA) --or in chat in web
 *
 * @param {bookingsServicesKeyboardClickOnAServiceInKeyboardParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - service type
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsServicesKeyboardClickOnAServiceInKeyboardParams>} LogObject<bookingsServicesKeyboardClickOnAServiceInKeyboardParams>
 */
export function bookingsServicesKeyboardClickOnAServiceInKeyboard(params) {
    return { evid: 334, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesKeyboardClickOnSend' event (evid: 336)
 *
 * Event description: when clicking on the "send" button to send the service in the keyboard
 *
 * @param {bookingsServicesKeyboardClickOnSendParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - service type
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsServicesKeyboardClickOnSendParams>} LogObject<bookingsServicesKeyboardClickOnSendParams>
 */
export function bookingsServicesKeyboardClickOnSend(params) {
    return { evid: 336, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppClickOnCategoriesFilter' event (evid: 338)
 *
 * Event description: Clicking on the categories selector - member https://www.screencast.com/t/bYohVkAMmh
 *
 * @param {bookingsOneAppClickOnCategoriesFilterParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - {owner_flow,member_flow}
 * @return {LogObject<bookingsOneAppClickOnCategoriesFilterParams>} LogObject<bookingsOneAppClickOnCategoriesFilterParams>
 */
export function bookingsOneAppClickOnCategoriesFilter(params) {
    return { evid: 338, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppChooseACategory' event (evid: 339)
 *
 * Event description: Choose a category in the categories selector menu - member https://www.screencast.com/t/PmULrg7PY
 *
 * @param {bookingsOneAppChooseACategoryParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} categoryId - category_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - {owner_flow,member_flow}
 * @return {LogObject<bookingsOneAppChooseACategoryParams>} LogObject<bookingsOneAppChooseACategoryParams>
 */
export function bookingsOneAppChooseACategory(params) {
    return { evid: 339, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppClickOnSessionMenuItem' event (evid: 340)
 *
 * Event description: Click on one of the items in the session card - class or 1:1 - member and owner
 *
 * @param {bookingsOneAppClickOnSessionMenuItemParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} triggerBy - owner/member
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} numParticipants - how many participants are in the session
 * @property {string} item_name - View Order/ sell plan/broadcast/cancel_session/
 *  add_participant/invite/book/manage_participants/payment/check_in/message/call/
 * View_form_Responses/3_dots/map/add_cv_link/participant/order_link
 * @property {string} sessionId - --
 * @property {string} type - Service type (Class/Appointment)
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsOneAppClickOnSessionMenuItemParams>} LogObject<bookingsOneAppClickOnSessionMenuItemParams>
 */
export function bookingsOneAppClickOnSessionMenuItem(params) {
    return { evid: 340, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppNextAfterChoosingBroadcastRecipients' event (evid: 341)
 *
 * Event description: https://zpl.io/ad5EdL5
 *
 * @param {bookingsOneAppNextAfterChoosingBroadcastRecipientsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - one_app_course_owner_page
 * @property {string} type - course
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsOneAppNextAfterChoosingBroadcastRecipientsParams>} LogObject<bookingsOneAppNextAfterChoosingBroadcastRecipientsParams>
 */
export function bookingsOneAppNextAfterChoosingBroadcastRecipients(params) {
    return { evid: 341, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppTooltipIsShown' event (evid: 345)
 *
 * Event description: From the contact page - when the owner wants to sell paid plan (pricing plan), but the UoU doesn't have one - the owner can click to attach a plan to the UoU
 *
 * @param {bookingsOneAppTooltipIsShownParams} params - The parameters for this event
 * @property {GUID} businessId - Bookings business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} paidPlanId - paid plan id
 * @property {string} referral_info - {contact_page}
 * @return {LogObject<bookingsOneAppTooltipIsShownParams>} LogObject<bookingsOneAppTooltipIsShownParams>
 */
export function bookingsOneAppTooltipIsShown(params) {
    return { evid: 345, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAddRemoveParticipantToFromWaitingList' event (evid: 346)
 *
 * Event description: Add/Remove participant to/from Waiting list - triggered by the owner or member
 *
 * @param {bookingsAddRemoveParticipantToFromWaitingListParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} triggerBy - Owner/Member
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - session card/member card/waitlist
 * @property {string} sessionId - -
 * @property {string} dynamic_price_participants_json - dynamic pricing data
 * @property {string} serviceId - -
 * @property {string} value - Add/Remove
 * @return {LogObject<bookingsAddRemoveParticipantToFromWaitingListParams>} LogObject<bookingsAddRemoveParticipantToFromWaitingListParams>
 */
export function bookingsAddRemoveParticipantToFromWaitingList(params) {
    return { evid: 346, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsUpdatePaymentStatus' event (evid: 348)
 *
 * Event description: When a user updates the payment status of a client
 *
 * @param {bookingsUpdatePaymentStatusParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - old or new server
 * @property {GUID} paidPlanId - paid plan id
 * @property {string} bookingId - booking_id
 * @property {string} origin - calendar pop-up/contact panel/participants pane/participants_group_modal
 * @property {string} sessionId - session_id
 * @property {GUID} contactId - contact_id
 * @property {string} type - service type (ind/class/course)
 * @property {string} serviceId - service_id
 * @property {string} value - deposit paid / fully paid / Not Paid /Paid in Person / Paid with a paid plan / Paid with invoice / fully paid ; invoice deleted
 * @property {GUID} invoice_id - invoice_id
 * @return {LogObject<bookingsUpdatePaymentStatusParams>} LogObject<bookingsUpdatePaymentStatusParams>
 */
export function bookingsUpdatePaymentStatus(params) {
    return { evid: 348, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsUpdateAttendance' event (evid: 349)
 *
 * Event description: When the user updates the attendance status of a client in a class/appointment. Screenshot: Desktop screenshot: https://www.screencast.com/t/UjNNmKNEHv. OA screenshot: 1. https://www.screencast.com/t/s8sTmD1E8x. 2.
 *
 * @param {bookingsUpdateAttendanceParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - old or new server
 * @property {string} bookingId - booking_id
 * @property {string} origin - calendar pop-up/contact panel/participants pane/OneApp participant menu/ OneApp button/ Check In Velo App
 * @property {string} sessionId - --
 * @property {string} contactId - contact_id
 * @property {string} type - service type (ind/class/course)
 * @property {GUID} msid - msid
 * @property {string} serviceId - service_id
 * @property {string} value - Attended / No Show / Check In
 * @property {boolean} applyCancellationFee - true / false if cancellation fees apply according to user selection
 * @property {string} cancellationFeeCurrency - currency of fee when cancellation fees are applicable
 * @property {number} cancellationFeeAmount - amount of fee when cancellation fees are applicable
 * @return {LogObject<bookingsUpdateAttendanceParams>} LogObject<bookingsUpdateAttendanceParams>
 */
export function bookingsUpdateAttendance(params) {
    return { evid: 349, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppClickOnAParticipantFromManageParticipants' event (evid: 350)
 *
 * Event description: tap on a participant(3 dots) from the "manage participants" page to open the menu. https://www.screencast.com/t/sHgc2vGOTROc
 *
 * @param {bookingsOneAppClickOnAParticipantFromManageParticipantsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} tabName - tabName=waitlist/booked
 * @property {string} paymentMethods - list of the available payment methods
 * @property {string} payment_status - paid/not_paid
 * @property {string} sessionId - -
 * @property {string} contactId - contact_id
 * @property {string} type - service type (currently only class)
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsOneAppClickOnAParticipantFromManageParticipantsParams>} LogObject<bookingsOneAppClickOnAParticipantFromManageParticipantsParams>
 */
export function bookingsOneAppClickOnAParticipantFromManageParticipants(params) {
    return { evid: 350, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppActionSheetClick' event (evid: 351)
 *
 * Event description: clicking on "add" or "remove" or "cancel" after the action sheet pop-up appears. Screenshot: https://www.screencast.com/t/zqEEy7GP.
 *
 * @param {bookingsOneAppActionSheetClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} contactId - contact_id
 * @property {string} type - service type (currently only class)
 * @property {GUID} service_id - service_id
 * @property {string} action - add/remove/cancel
 * @return {LogObject<bookingsOneAppActionSheetClickParams>} LogObject<bookingsOneAppActionSheetClickParams>
 */
export function bookingsOneAppActionSheetClick(params) {
    return { evid: 351, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppClickOnInternalTab' event (evid: 353)
 *
 * Event description: Click on a tab inside "manage participants" or any other page - either owner or member
 *
 * @param {bookingsOneAppClickOnInternalTabParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} triggerBy - Owner/Member
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} tabName - waitlist/booked/schedule/services
 * @property {string} pageName - participants
 * @property {string} serviceId - -
 * @return {LogObject<bookingsOneAppClickOnInternalTabParams>} LogObject<bookingsOneAppClickOnInternalTabParams>
 */
export function bookingsOneAppClickOnInternalTab(params) {
    return { evid: 353, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsClickToAddAParticipantToTheWaitingList' event (evid: 354)
 *
 * Event description: Click on "Add to Waitlist". Screenshot: https://www.screencast.com/t/ikfPEx6ksV
 * From Dec-2019, add/remove to/from waitlist with value = add/remove
 *
 * @param {bookingsClickToAddAParticipantToTheWaitingListParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} location - {upper_button,lower_button}
 * @property {GUID} biToken - msid
 * @property {string} triggerBy - Owner/Member
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} participants - number of existing participants in wait list
 * @property {string} origin - session card/member card
 * @property {string} serviceId - -
 * @property {string} value - Add/Remove
 * @return {LogObject<bookingsClickToAddAParticipantToTheWaitingListParams>} LogObject<bookingsClickToAddAParticipantToTheWaitingListParams>
 */
export function bookingsClickToAddAParticipantToTheWaitingList(params) {
    return { evid: 354, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetShowHideClassSchedule' event (evid: 356)
 *
 * Event description: show/hide class schedule
 *
 * @param {bookingsAppSetShowHideClassScheduleParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - new_bookings_server/null
 * @property {string} pagetype - {class}
 * @property {string} page_name - {service_page}
 * @property {boolean} check_box - true/false. default value is false when false means the feature is off (don't display schedule)
 * @property {boolean} isPreview - true/false
 * @return {LogObject<bookingsAppSetShowHideClassScheduleParams>} LogObject<bookingsAppSetShowHideClassScheduleParams>
 */
export function bookingsAppSetShowHideClassSchedule(params) {
    return { evid: 356, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsConnectPaidPlanModalConnectDisconnect' event (evid: 357)
 *
 * Event description: indicating connect/disconnect paid plan to booking service using modal
 * The plan modal screenshot: https://zpl.io/VOpqy6k
 *
 * @param {bookingsConnectPaidPlanModalConnectDisconnectParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} planGuid - plan_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - null if old server
 * @property {GUID} service_id - service_id
 * @property {string} action - {connect,disconnect}
 * @return {LogObject<bookingsConnectPaidPlanModalConnectDisconnectParams>} LogObject<bookingsConnectPaidPlanModalConnectDisconnectParams>
 */
export function bookingsConnectPaidPlanModalConnectDisconnect(params) {
    return { evid: 357, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSaveServiceX' event (evid: 358)
 *
 * Event description: when a service is saved - the unified form for all services type (service X).   July-2023 update: template_id field was fixed, if null then it means the service was a "start from scratch"
 *
 * @param {bookingsSaveServiceXParams} params - The parameters for this event
 * @property {GUID} businessId - business id
 * @property {boolean} accept_bookings_after_start - advanced settings // FALSE if toggle is off
 * @property {number} duration - the service duration in minutes
 * @property {string} structureId - structure_id
 * @property {string} locationText - location_text if exist
 * @property {string} connected_payment_methods - json of connected payment methods
 * @property {boolean} staffFilled - True = error raised
 * @property {boolean} success - True = save success, False = fail
 * @property {string} priceOptions - no_fee / custom / fix
 * @property {boolean} headerImageChanged - True = header photo changed (add/replace/reorder)
 * @property {string} paymentOptions - per session / with a plan / both
 * @property {boolean} galleryImageChanged - True = gallery images changed (add/replace/reorder)
 * @property {string} videoInfo - Null=not installed. for auto-save: "connection_intent"; If installed + regular save - "enabled" / "disabled"
 * @property {GUID} biToken - -
 * @property {string} serviceName - service_name
 * @property {string} bookingsPlatform - -
 * @property {string} form_source - default/form_id
 * @property {string} request_type - bookings approval {auto_approve, manually_approve}
 * @property {boolean} service_name_empty - True = error raised
 * @property {number} priceAmount - pricing amount(wiil be sent only if the action happens on mobile)
 * @property {number} numberOfOptions - from jason file
 * @property {string} price_type - staff/location/label
 * @property {string} paymentType - {online, in person, online and in person, deposit}
 * @property {string} planType - {connection_intent, connect_success}
 * @property {boolean} headerImageEmpty - True = no header image
 * @property {string} errorReason - why the save failed
 * @property {string} serviceGalleryOrigin - if the origin is the service gallery then - start from scratch / template_id. else null
 * @property {boolean} is_visible - True = display on site
 * @property {number} numLocations - number of business locations the service is provided at
 * @property {string} loaction - location
 * @property {string} policyId - policy_id
 * @property {string} save_type - {create_new, save_changes}
 * @property {number} depositAmount - deposit amount(wiil be sent only if the action happens on mobile)
 * @property {string} saveOrigin - {save_click, auto_save,save_and_duplicate,schedule_session,edit_form, biz_first_funnel}
 * @property {boolean} service_description_empty - False = short description empty
 * @property {string} templateId - For biz_first - if the service was saved from a ready template
 * @property {string} price_selection - {fixed, varies, no charge}
 * @property {number} image_in_gallery_count - number of images in gallery
 * @property {boolean} photo_empty - True = no image
 * @property {string} resource_typeids - array of all marked resource types
 * @property {boolean} accept_online_bookings - advanced settings // FALSE if this a "no book flow"
 * @property {boolean} duration_empty - custom duration, True = error raised
 * @property {string} premiumStatus - {Website/Business/None}
 * @property {string} policy_name - policy_name
 * @property {string} dynamic_price_usre_jason - label, amount
 * @property {string} type - {single, multi}
 * @property {string} locationGuidList - list of business locations
 * @property {string} location_choice - {business, client, custom}
 * @property {string} service_id - service id
 * @property {boolean} is_default_policy - is_default_policy
 * @property {boolean} isTimeBuffer - True = using time buffer
 * @property {boolean} price_empty - True = error raised
 * @property {string} priceDetails - if fixed - amount, if custom - text
 * @property {boolean} galleryImageEmpty - True = no gallery images
 * @property {boolean} photo_changed - True = main photo changed (add/replace/reorder)
 * @return {LogObject<bookingsSaveServiceXParams>} LogObject<bookingsSaveServiceXParams>
 */
export function bookingsSaveServiceX(params) {
    return { evid: 358, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppClickOnDeclineRescheduleInPendingApprovalSession' event (evid: 359)
 *
 * Event description: tap on "Decline Reschedule" cta for pending approval session
 *
 * @param {bookingsOneAppClickOnDeclineRescheduleInPendingApprovalSessionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} session_id - session_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} referral_info - {session_page_cta,more_button}
 * @property {GUID} contactId - contact_id
 * @property {string} type - service type (currently only private)
 * @property {GUID} service_id - service_id
 * @property {string} action - decline/reschedule
 * @return {LogObject<bookingsOneAppClickOnDeclineRescheduleInPendingApprovalSessionParams>} LogObject<bookingsOneAppClickOnDeclineRescheduleInPendingApprovalSessionParams>
 */
export function bookingsOneAppClickOnDeclineRescheduleInPendingApprovalSession(params) {
    return { evid: 359, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppointmentPendingApprovalDeclineApproveReschedule' event (evid: 360)
 *
 * Event description: Decline/approve button for appointment pending approval modal
 *
 * @param {bookingsAppointmentPendingApprovalDeclineApproveRescheduleParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} mobileOneApp - Null\F = desktop\mobile non app
 * @property {string} categoryId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingId - booking_id
 * @property {string} referral_info - {appointment_pending_approval}
 * @property {string} appointmentId - session_id
 * @property {string} contactId - -
 * @property {string} type - appointment/class/course/private
 * @property {GUID} service_id - service_id
 * @property {string} action - decline/reschedule/approve
 * @return {LogObject<bookingsAppointmentPendingApprovalDeclineApproveRescheduleParams>} LogObject<bookingsAppointmentPendingApprovalDeclineApproveRescheduleParams>
 */
export function bookingsAppointmentPendingApprovalDeclineApproveReschedule(params) {
    return { evid: 360, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceListQuickLinksClick' event (evid: 361)
 *
 * Event description: Clicking on the button that opens the dropdown list in the service list page https://zpl.io/a3D4ne8
 *
 * @param {bookingsServiceListQuickLinksClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - Null if old platform
 * @property {string} page_name - service_list, calendar
 * @return {LogObject<bookingsServiceListQuickLinksClickParams>} LogObject<bookingsServiceListQuickLinksClickParams>
 */
export function bookingsServiceListQuickLinksClick(params) {
    return { evid: 361, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceListQuickLinksItemClick' event (evid: 362)
 *
 * Event description: clicking on an item within the drop down list. https://zpl.io/a3D4ne8
 *
 * @param {bookingsServiceListQuickLinksItemClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - Null if old platform
 * @property {string} link_name - {'Create Coupon','Manage Staff','Update Booking Settings','Accept Payment','Hire a Wix partner', 'RWG', 'Manage on the Go', 'View Analytics', 'Set work hours', 'Sync Google','Change Time Zone','Hire a Partner'}
 * @property {string} page_name - service_list, calendar
 * @return {LogObject<bookingsServiceListQuickLinksItemClickParams>} LogObject<bookingsServiceListQuickLinksItemClickParams>
 */
export function bookingsServiceListQuickLinksItemClick(params) {
    return { evid: 362, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffGoToRolesPermissions' event (evid: 364)
 *
 * Event description: grant permissions cta on Booking Staff Member paga
 *
 * @param {bookingsStaffGoToRolesPermissionsParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - staff card / create staff
 * @property {GUID} biToken - -
 * @property {GUID} staffId - 'staff id' field = resource id (isn't the same guid as 'staff member id')
 * Starting from Feb-2024 there is a new entity = staff member id, can be found in staff_members_ids
 * @property {string} staffMembersIds - staff_members_ids
 * @property {string} bookingsPlatform - -
 * @return {LogObject<bookingsStaffGoToRolesPermissionsParams>} LogObject<bookingsStaffGoToRolesPermissionsParams>
 */
export function bookingsStaffGoToRolesPermissions(params) {
    return { evid: 364, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsReminderSmsToggle' event (evid: 365)
 *
 * Event description: turn on\off reminder sms toggle
 * https://zpl.io/aXJNBqP
 *
 * @param {bookingsReminderSmsToggleParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - new_bookings_server
 * @property {string} action - {ON,OFF}
 * @return {LogObject<bookingsReminderSmsToggleParams>} LogObject<bookingsReminderSmsToggleParams>
 */
export function bookingsReminderSmsToggle(params) {
    return { evid: 365, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPreviewEditSmsReminder' event (evid: 366)
 *
 * Event description: View sms reminders phrasing per service type
 * https://zpl.io/291eWMY
 *
 * @param {bookingsPreviewEditSmsReminderParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} sms_type - reminder
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - new_bookings_server
 * @return {LogObject<bookingsPreviewEditSmsReminderParams>} LogObject<bookingsPreviewEditSmsReminderParams>
 */
export function bookingsPreviewEditSmsReminder(params) {
    return { evid: 366, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarExportItemClick' event (evid: 369)
 *
 * Event description: Clicking on the item within the dropdown list. https://zpl.io/V47xe98
 *
 * @param {bookingsCalendarExportItemClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - Null if old platform
 * @property {string} itemName - {Export Staff Hours, Export Booking List}
 * @return {LogObject<bookingsCalendarExportItemClickParams>} LogObject<bookingsCalendarExportItemClickParams>
 */
export function bookingsCalendarExportItemClick(params) {
    return { evid: 369, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsExportCalendarDataModalExport' event (evid: 371)
 *
 * Event description: Export calendar items between start and end date
 * https://zpl.io/2pAevX8
 *
 * @param {bookingsExportCalendarDataModalExportParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {DateTime} startTime - start date
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - null if old server
 * @property {DateTime} endTime - end date
 * @property {string} itemName - {Staff Hours, Booking List}
 * @return {LogObject<bookingsExportCalendarDataModalExportParams>} LogObject<bookingsExportCalendarDataModalExportParams>
 */
export function bookingsExportCalendarDataModalExport(params) {
    return { evid: 371, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffGrantPermissionsClick' event (evid: 373)
 *
 * Event description: invite cta on Booking Staff Member grant permissions modal
 *
 * @param {bookingsStaffGrantPermissionsClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {boolean} success - T/F
 * @property {GUID} biToken - -
 * @property {GUID} staffId - 'staff id' field = resource id (isn't the same guid as 'staff member id') Starting from Feb-2024 there is a new entity = staff member id, can be found in staff_members_ids
 * @property {string} staffMembersIds - staff_members_ids
 * @property {string} bookingsPlatform - -
 * @property {string} errorReason - error reason
 * @property {boolean} is_valid_email - email validation
 * @property {GUID} inviteId - R&P invite_id upon invite success
 * @property {boolean} emailChanged - when email is not pre-populated
 * @return {LogObject<bookingsStaffGrantPermissionsClickParams>} LogObject<bookingsStaffGrantPermissionsClickParams>
 */
export function bookingsStaffGrantPermissionsClick(params) {
    return { evid: 373, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMenuInServiceListClick' event (evid: 374)
 *
 * Event description: when clicking a service in the Owner App service list, opens a small menu. The event is triggered when clicking an option in that menu.
 *
 * @param {bookingsMenuInServiceListClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - platform
 * @property {string} selection - {edit_service,manage_paid_plans,delete_service}
 * @return {LogObject<bookingsMenuInServiceListClickParams>} LogObject<bookingsMenuInServiceListClickParams>
 */
export function bookingsMenuInServiceListClick(params) {
    return { evid: 374, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRwgOverflowClick' event (evid: 375)
 *
 * Event description: click on the more actions 3 dots on RWG
 * https://zpl.io/2vpxg8j
 *
 * @param {bookingsRwgOverflowClickParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_new_platform
 * @property {string} referral_info - RWG find your business, RWG set up your business
 * @return {LogObject<bookingsRwgOverflowClickParams>} LogObject<bookingsRwgOverflowClickParams>
 */
export function bookingsRwgOverflowClick(params) {
    return { evid: 375, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRwgModalDisconnectClick' event (evid: 376)
 *
 * Event description: https://zpl.io/VY43yEw
 *
 * @param {bookingsRwgModalDisconnectClickParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - new_bookings_platform
 * @return {LogObject<bookingsRwgModalDisconnectClickParams>} LogObject<bookingsRwgModalDisconnectClickParams>
 */
export function bookingsRwgModalDisconnectClick(params) {
    return { evid: 376, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRwgEditCllck' event (evid: 377)
 *
 * Event description: https://zpl.io/V0BOvel
 *
 * @param {bookingsRwgEditCllckParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {boolean} isValid - is valid for RWG {T/F}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - new_bookings_platform
 * @property {string} itemName - {name value}
 * @property {string} type - {business_category,business_name,business_address, service, using_an_existing_google_listing}
 * @property {string} serviceId - service_id in case editing a service
 * @return {LogObject<bookingsRwgEditCllckParams>} LogObject<bookingsRwgEditCllckParams>
 */
export function bookingsRwgEditCllck(params) {
    return { evid: 377, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsContactPanelFilter' event (evid: 378)
 *
 * Event description: sent when a user uses filters in contact panel
 * https://zpl.io/aNJ4Jr9
 *
 * @param {bookingsContactPanelFilterParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - new_bookings_platform
 * @property {string} filter_name - payment_status,attendance
 * @property {string} selection - All. values separated by commas
 * @return {LogObject<bookingsContactPanelFilterParams>} LogObject<bookingsContactPanelFilterParams>
 */
export function bookingsContactPanelFilter(params) {
    return { evid: 378, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffWidgetChangeLink' event (evid: 380)
 *
 * Event description: RWG expand/collapse service list/illegible service
 *
 * @param {bookingsStaffWidgetChangeLinkParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {boolean} isOpened - TRUE for expend, FALSE for collapse
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_new_platform
 * @property {string} fieldName - service_list, service
 * @property {string} serviceId - in case action is on service
 * @return {LogObject<bookingsStaffWidgetChangeLinkParams>} LogObject<bookingsStaffWidgetChangeLinkParams>
 */
export function bookingsStaffWidgetChangeLink(params) {
    return { evid: 380, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'copyOfBookingsStaffWidgetChangeLinkPage' event (evid: 381)
 *
 * Event description: click on add your business to Google
 * https://zpl.io/VD03j4l
 *
 * @param {copyOfBookingsStaffWidgetChangeLinkPageParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_new_platform
 * @property {string} referral_info - find your business search box, find your business  link
 * @return {LogObject<copyOfBookingsStaffWidgetChangeLinkPageParams>} LogObject<copyOfBookingsStaffWidgetChangeLinkPageParams>
 */
export function copyOfBookingsStaffWidgetChangeLinkPage(params) {
    return { evid: 381, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsShowHideStaff' event (evid: 382)
 *
 * Event description: show_hide_staff in staff widget
 *
 * @param {bookingsShowHideStaffParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} isShow - 0 for hide / 1 for show
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} info - {profile_picture,description,...}
 * @return {LogObject<bookingsShowHideStaffParams>} LogObject<bookingsShowHideStaffParams>
 */
export function bookingsShowHideStaff(params) {
    return { evid: 382, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRwgConnectClick' event (evid: 383)
 *
 * Event description: Click on accept in RWG consent modal
 *
 * @param {bookingsRwgConnectClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_new_platform
 * @return {LogObject<bookingsRwgConnectClickParams>} LogObject<bookingsRwgConnectClickParams>
 */
export function bookingsRwgConnectClick(params) {
    return { evid: 383, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsSettingsBusinessNotificationsSaveClick' event (evid: 385)
 *
 * Event description: turn on\off business notifications toggle
 * https://zpl.io/bJJmAw9
 *
 * @param {bookingsBookingsSettingsBusinessNotificationsSaveClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - new_bookings_server
 * @property {string} toggle_value - {ON,OFF}
 * @return {LogObject<bookingsBookingsSettingsBusinessNotificationsSaveClickParams>} LogObject<bookingsBookingsSettingsBusinessNotificationsSaveClickParams>
 */
export function bookingsBookingsSettingsBusinessNotificationsSaveClick(params) {
    return { evid: 385, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormChangeType' event (evid: 386)
 *
 * Event description: -
 *
 * @param {bookingsServiceFormChangeTypeParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - service type source {ind, class, course}
 * @property {boolean} success - T= changed
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} type - {ind, class, course} - the service type move to
 * @return {LogObject<bookingsServiceFormChangeTypeParams>} LogObject<bookingsServiceFormChangeTypeParams>
 */
export function bookingsServiceFormChangeType(params) {
    return { evid: 386, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsScheduleANewSession' event (evid: 387)
 *
 * Event description: click in schedule cta in service form
 *
 * @param {bookingsScheduleANewSessionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} location - {service_form}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - {new_bookings_server}
 * @property {boolean} emptyState - TRUE if empty state
 * @property {string} ctaType - on_calendar/add_sessions
 * @property {string} type - {class,course}
 * @property {string} serviceId - {service_id}
 * @return {LogObject<bookingsScheduleANewSessionParams>} LogObject<bookingsScheduleANewSessionParams>
 */
export function bookingsScheduleANewSession(params) {
    return { evid: 387, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsManageParticipantsPageExpandCollapseClick' event (evid: 388)
 *
 * Event description: contact expand/collapse in BO manage participants page
 * https://zpl.io/anqwgzv
 *
 * @param {bookingsManageParticipantsPageExpandCollapseClickParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {boolean} isOpened - TRUE for expend, FALSE for collapse
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_new_platform
 * @property {string} custom_field_type - the origin field type in booking form
 * @property {string} contactId - {contact_id}
 * @property {string} pageName - page name
 * @property {string} type - class/course
 * @property {string} form - json of the form answers
 * @property {string} serviceId - {service_id}
 * @return {LogObject<bookingsManageParticipantsPageExpandCollapseClickParams>} LogObject<bookingsManageParticipantsPageExpandCollapseClickParams>
 */
export function bookingsManageParticipantsPageExpandCollapseClick(params) {
    return { evid: 388, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppTapOnViewMoreFormResponsesCtaInCoursePage' event (evid: 390)
 *
 * Event description: tap on a "View More Form Responses" cta in course page
 *
 * @param {bookingsOneAppTapOnViewMoreFormResponsesCtaInCoursePageParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} emptyState - TRUE if no participants in course. Else FALSE
 * @property {string} type - course
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsOneAppTapOnViewMoreFormResponsesCtaInCoursePageParams>} LogObject<bookingsOneAppTapOnViewMoreFormResponsesCtaInCoursePageParams>
 */
export function bookingsOneAppTapOnViewMoreFormResponsesCtaInCoursePage(params) {
    return { evid: 390, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCompareServiceTypesClick' event (evid: 392)
 *
 * Event description: Edit confirmation email/click on "show me" to go to the automations page
 *
 * @param {bookingsCompareServiceTypesClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} linkUrl - link to KB
 * @property {string} location - service_form
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - new_bookings_platform
 * @property {string} type - {ind,class/course}
 * @property {string} serviceId - {service_id}
 * @property {string} toggle_value - {ind,class/course}
 * @return {LogObject<bookingsCompareServiceTypesClickParams>} LogObject<bookingsCompareServiceTypesClickParams>
 */
export function bookingsCompareServiceTypesClick(params) {
    return { evid: 392, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRwgOptInClick' event (evid: 393)
 *
 * Event description: click on RWG opt in
 *
 * @param {bookingsRwgOptInClickParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_new_platform
 * @return {LogObject<bookingsRwgOptInClickParams>} LogObject<bookingsRwgOptInClickParams>
 */
export function bookingsRwgOptInClick(params) {
    return { evid: 393, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAddSessionsFromTheCalendarModalContinueClick' event (evid: 394)
 *
 * Event description: Clicking on continue to calendar
 *
 * @param {bookingsAddSessionsFromTheCalendarModalContinueClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} triggerBy - {service_form_save_service,service_form_add_session}
 * @property {string} bookingsPlatform - new_bookings_server
 * @property {string} type - Service type {class, course}
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsAddSessionsFromTheCalendarModalContinueClickParams>} LogObject<bookingsAddSessionsFromTheCalendarModalContinueClickParams>
 */
export function bookingsAddSessionsFromTheCalendarModalContinueClick(params) {
    return { evid: 394, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'customServiceFormModal' event (evid: 395)
 *
 * Event description: event records selection on 'intake form' modal: save or cancel.
 *
 * @param {customServiceFormModalParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {create,edit}
 * @property {string} type - group\private\course\none
 * @return {LogObject<customServiceFormModalParams>} LogObject<customServiceFormModalParams>
 */
export function customServiceFormModal(params) {
    return { evid: 395, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'clickOnEditFormDropdown' event (evid: 396)
 *
 * Event description: click on 'edit form' dropdown
 *
 * @param {clickOnEditFormDropdownParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<clickOnEditFormDropdownParams>} LogObject<clickOnEditFormDropdownParams>
 */
export function clickOnEditFormDropdown(params) {
    return { evid: 396, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormConnectPaymentEntryPoint' event (evid: 398)
 *
 * Event description: user clicks save and cont from connect payment modal in service form
 *
 * @param {bookingsServiceFormConnectPaymentEntryPointParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {string} entryPoint - modal_in_service_form
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @return {LogObject<bookingsServiceFormConnectPaymentEntryPointParams>} LogObject<bookingsServiceFormConnectPaymentEntryPointParams>
 */
export function bookingsServiceFormConnectPaymentEntryPoint(params) {
    return { evid: 398, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsResetToOriginalDesignClick' event (evid: 399)
 *
 * Event description: user clicks add session in bulk scheduling modal
 *
 * @param {bookingsResetToOriginalDesignClickParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {string} location - service_form/
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} type - class
 * @property {string} serviceId - []
 * @return {LogObject<bookingsResetToOriginalDesignClickParams>} LogObject<bookingsResetToOriginalDesignClickParams>
 */
export function bookingsResetToOriginalDesignClick(params) {
    return { evid: 399, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsEditorHealthWaiverAddedToSite' event (evid: 400)
 *
 * Event description: health waiver was added to site in editor via bookings related elements
 *
 * @param {bookingsEditorHealthWaiverAddedToSiteParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {string} source - add_panel/6th button
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsEditorHealthWaiverAddedToSiteParams>} LogObject<bookingsEditorHealthWaiverAddedToSiteParams>
 */
export function bookingsEditorHealthWaiverAddedToSite(params) {
    return { evid: 400, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBusinessOptionsMenuClick' event (evid: 401)
 *
 * Event description: http://prntscr.com/f2tvda
 *
 * @param {bookingsBusinessOptionsMenuClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {calendar,policy,emails,business_notifications}
 * @property {string} category - the settings category
 * @return {LogObject<bookingsBusinessOptionsMenuClickParams>} LogObject<bookingsBusinessOptionsMenuClickParams>
 */
export function bookingsBusinessOptionsMenuClick(params) {
    return { evid: 401, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSettingsLeftNav' event (evid: 402)
 *
 * Event description: app settings left nav, NEW APP SETTINGS- NOT RELEVANT
 *
 * @param {bookingsAppSettingsLeftNavParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {Null = app_settings , widget, service_page}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {main.layout,text,design,support}
 * @return {LogObject<bookingsAppSettingsLeftNavParams>} LogObject<bookingsAppSettingsLeftNavParams>
 */
export function bookingsAppSettingsLeftNav(params) {
    return { evid: 402, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSetProportions' event (evid: 403)
 *
 * Event description: only in service_page - http://prntscr.com/f54c9r- NEW APP SETTINGS- NOT RELEVANT
 *
 * @param {bookingsAppSetProportionsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {rectangle, square}
 * @return {LogObject<bookingsAppSetProportionsParams>} LogObject<bookingsAppSetProportionsParams>
 */
export function bookingsAppSetProportions(params) {
    return { evid: 403, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingFormSaveFormClick' event (evid: 404)
 *
 * Event description: save booking form
 *
 * @param {bookingsBookingFormSaveFormClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} success - form settings saved
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} serviceId - service_id
 * @property {string} nameFormat - name format - full_name or _first_and_last
 * @return {LogObject<bookingsBookingFormSaveFormClickParams>} LogObject<bookingsBookingFormSaveFormClickParams>
 */
export function bookingsBookingFormSaveFormClick(params) {
    return { evid: 404, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingFormSectionAction' event (evid: 405)
 *
 * Event description: click on any action for any section on the bookings form
 *
 * @param {bookingsBookingFormSectionActionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} field - {title,name,email,phone_number,address..}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} action - {edit, duplicate, delete}
 * @return {LogObject<bookingsBookingFormSectionActionParams>} LogObject<bookingsBookingFormSectionActionParams>
 */
export function bookingsBookingFormSectionAction(params) {
    return { evid: 405, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingFormSaveSectionCheck' event (evid: 406)
 *
 * Event description: http://prntscr.com/f7mwgt
 *
 * @param {bookingsBookingFormSaveSectionCheckParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} field - {title,name,email,phone_number,address..}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} descriptionHidden - -
 * @return {LogObject<bookingsBookingFormSaveSectionCheckParams>} LogObject<bookingsBookingFormSaveSectionCheckParams>
 */
export function bookingsBookingFormSaveSectionCheck(params) {
    return { evid: 406, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingFormSaveFieldCheck' event (evid: 407)
 *
 * Event description: http://prntscr.com/f7mwgt
 *
 * @param {bookingsBookingFormSaveFieldCheckParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} field - {title,name,email,phone_number,address..}
 * @property {boolean} isRequired - T=required field (mandatory)
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} requiredFieldChecked - T=checked (T for mandatory fields).
 * @property {boolean} changed - T= a change was made
 * @property {string} fieldType - {email,phone_number,date, drop_down,paragraph, short_text} SWITCHED WITH FIELD!!
 * @property {boolean} descriptionHidden - only for title, T=hide desc is checked
 * @return {LogObject<bookingsBookingFormSaveFieldCheckParams>} LogObject<bookingsBookingFormSaveFieldCheckParams>
 */
export function bookingsBookingFormSaveFieldCheck(params) {
    return { evid: 407, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingFormAddNewFieldClick' event (evid: 409)
 *
 * Event description: http://prntscr.com/f7np8w
 *
 * @param {bookingsBookingFormAddNewFieldClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsBookingFormAddNewFieldClickParams>} LogObject<bookingsBookingFormAddNewFieldClickParams>
 */
export function bookingsBookingFormAddNewFieldClick(params) {
    return { evid: 409, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingFormTipsLinkClick' event (evid: 411)
 *
 * Event description: http://prntscr.com/f7nwqm
 *
 * @param {bookingsBookingFormTipsLinkClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsBookingFormTipsLinkClickParams>} LogObject<bookingsBookingFormTipsLinkClickParams>
 */
export function bookingsBookingFormTipsLinkClick(params) {
    return { evid: 411, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingFormCancel' event (evid: 412)
 *
 * Event description: http://prntscr.com/f7oou7 sent on cancel
 *
 * @param {bookingsBookingFormCancelParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsBookingFormCancelParams>} LogObject<bookingsBookingFormCancelParams>
 */
export function bookingsBookingFormCancel(params) {
    return { evid: 412, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAppSettingsVisitorLanguageDropDown' event (evid: 417)
 *
 * Event description: http://prntscr.com/fu7t2v
 *
 * @param {bookingsAppSettingsVisitorLanguageDropDownParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} newLanguage - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} oldLanguage - -
 * @return {LogObject<bookingsAppSettingsVisitorLanguageDropDownParams>} LogObject<bookingsAppSettingsVisitorLanguageDropDownParams>
 */
export function bookingsAppSettingsVisitorLanguageDropDown(params) {
    return { evid: 417, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAddServiceChooseType' event (evid: 418)
 *
 * Event description: http://prntscr.com/g3syaf
 *
 * @param {bookingsAddServiceChooseTypeParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} location - {service list, empty state}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} type - group\private\course
 * @return {LogObject<bookingsAddServiceChooseTypeParams>} LogObject<bookingsAddServiceChooseTypeParams>
 */
export function bookingsAddServiceChooseType(params) {
    return { evid: 418, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarFilterSessionsClick' event (evid: 422)
 *
 * Event description: user clicks on 'filter session' CTA in calendar - NOT ACTIVE since the new calendar, see event 16:654 (component='filters')
 *
 * @param {bookingsCalendarFilterSessionsClickParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @return {LogObject<bookingsCalendarFilterSessionsClickParams>} LogObject<bookingsCalendarFilterSessionsClickParams>
 */
export function bookingsCalendarFilterSessionsClick(params) {
    return { evid: 422, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarClearAllFiltersClick' event (evid: 423)
 *
 * Event description: user clicks clear all filters in calendar
 *
 * @param {bookingsCalendarClearAllFiltersClickParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @return {LogObject<bookingsCalendarClearAllFiltersClickParams>} LogObject<bookingsCalendarClearAllFiltersClickParams>
 */
export function bookingsCalendarClearAllFiltersClick(params) {
    return { evid: 423, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarFilterModalFilter' event (evid: 424)
 *
 * Event description: user clicked filter from filter modal
 *
 * @param {bookingsCalendarFilterModalFilterParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} filterByOccupancy - true if some filter was made on occupancy
 * @property {GUID} biToken - msid
 * @property {boolean} filterByClient - true if some filter was made on client
 * @property {string} bookingsPlatform - bookings_platform
 * @property {boolean} filterByLocation - true if some filter was made on location
 * @property {boolean} filterBySessionType - true if some filter was made on session type
 * @property {boolean} filterByStaff - true if some filter was made on staff
 * @return {LogObject<bookingsCalendarFilterModalFilterParams>} LogObject<bookingsCalendarFilterModalFilterParams>
 */
export function bookingsCalendarFilterModalFilter(params) {
    return { evid: 424, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffRenameStaffClick' event (evid: 425)
 *
 * Event description: click rename staff from new class schedule or appointment
 *
 * @param {bookingsStaffRenameStaffClickParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} type - class/appointment
 * @return {LogObject<bookingsStaffRenameStaffClickParams>} LogObject<bookingsStaffRenameStaffClickParams>
 */
export function bookingsStaffRenameStaffClick(params) {
    return { evid: 425, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffRenameStaffSave' event (evid: 426)
 *
 * Event description: user renamed staff from schedule
 *
 * @param {bookingsStaffRenameStaffSaveParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} origin - from where the user renamed the staff
 * @property {string} type - service type
 * @return {LogObject<bookingsStaffRenameStaffSaveParams>} LogObject<bookingsStaffRenameStaffSaveParams>
 */
export function bookingsStaffRenameStaffSave(params) {
    return { evid: 426, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarClearSingle' event (evid: 427)
 *
 * Event description: user cleared a single filter from calendar
 *
 * @param {bookingsCalendarClearSingleParams} params - The parameters for this event
 * @property {GUID} businessId - [
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @return {LogObject<bookingsCalendarClearSingleParams>} LogObject<bookingsCalendarClearSingleParams>
 */
export function bookingsCalendarClearSingle(params) {
    return { evid: 427, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBulkSchedulingNewSessionsSaved' event (evid: 428)
 *
 * Event description: user. saved new sessions from bulk scheduling modal
 *
 * @param {bookingsBulkSchedulingNewSessionsSavedParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {boolean} success - []
 * @property {string} location - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} sessionData - json containing the data on each session saved
 * @property {string} origin - modal_over_service_form
 * @property {number} numOfSessions - number of sessions saved
 * @property {string} serviceId - []
 * @return {LogObject<bookingsBulkSchedulingNewSessionsSavedParams>} LogObject<bookingsBulkSchedulingNewSessionsSavedParams>
 */
export function bookingsBulkSchedulingNewSessionsSaved(params) {
    return { evid: 428, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsResetToOriginalDesignClickSrc16Evid429' event (evid: 429)
 *
 * Event description: click on "Reset to original design"
 *
 * @param {bookingsResetToOriginalDesignClickSrc16Evid429Params} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} appName - -
 * @property {string} bookingsPlatform - bookings_new_platform
 * @property {string} sectionName - -
 * @property {string} items - items restored to default
 * @property {string} tabName - -
 * @return {LogObject<bookingsResetToOriginalDesignClickSrc16Evid429Params>} LogObject<bookingsResetToOriginalDesignClickSrc16Evid429Params>
 */
export function bookingsResetToOriginalDesignClickSrc16Evid429(params) {
    return { evid: 429, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRwgFindYourBusinessSkip' event (evid: 430)
 *
 * Event description: click on skip in RWG find your business screen
 *
 * @param {bookingsRwgFindYourBusinessSkipParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_new_platform
 * @return {LogObject<bookingsRwgFindYourBusinessSkipParams>} LogObject<bookingsRwgFindYourBusinessSkipParams>
 */
export function bookingsRwgFindYourBusinessSkip(params) {
    return { evid: 430, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRwgFindYourBusinessNext' event (evid: 431)
 *
 * Event description: click on next in RWG find your business screen
 *
 * @param {bookingsRwgFindYourBusinessNextParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_new_platform
 * @return {LogObject<bookingsRwgFindYourBusinessNextParams>} LogObject<bookingsRwgFindYourBusinessNextParams>
 */
export function bookingsRwgFindYourBusinessNext(params) {
    return { evid: 431, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRwgFindYourBusinessTypeInSearchBoxIntent' event (evid: 432)
 *
 * Event description: type in search box intent on RWG find your business screen
 *
 * @param {bookingsRwgFindYourBusinessTypeInSearchBoxIntentParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_new_platform
 * @return {LogObject<bookingsRwgFindYourBusinessTypeInSearchBoxIntentParams>} LogObject<bookingsRwgFindYourBusinessTypeInSearchBoxIntentParams>
 */
export function bookingsRwgFindYourBusinessTypeInSearchBoxIntent(params) {
    return { evid: 432, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRwgFindYourBusinessSelectBusinessFromSearchBox' event (evid: 433)
 *
 * Event description: select business from search box on  RWG find your business screen
 *
 * @param {bookingsRwgFindYourBusinessSelectBusinessFromSearchBoxParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_new_platform
 * @return {LogObject<bookingsRwgFindYourBusinessSelectBusinessFromSearchBoxParams>} LogObject<bookingsRwgFindYourBusinessSelectBusinessFromSearchBoxParams>
 */
export function bookingsRwgFindYourBusinessSelectBusinessFromSearchBox(params) {
    return { evid: 433, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRwgSetupPageLoad' event (evid: 434)
 *
 * Event description: reserve with Google setup page load
 *
 * @param {bookingsRwgSetupPageLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - new_bookings_server
 * @property {string} properties - OBJECT {Sites premium, Site category, sub-category, Business name, Business address, Bookings services - eligible / non-eligible}
 * @return {LogObject<bookingsRwgSetupPageLoadParams>} LogObject<bookingsRwgSetupPageLoadParams>
 */
export function bookingsRwgSetupPageLoad(params) {
    return { evid: 434, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsListFilterClick' event (evid: 435)
 *
 * Event description: user clicks on 'filter' in bookings list
 *
 * @param {bookingsBookingsListFilterClickParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {boolean} isOpened - T for filter click
 * @property {GUID} biToken - []
 * @property {string} filterName - status, payment
 * @property {string} bookingsPlatform - []
 * @property {boolean} isFilter - is_filter
 * @property {string} buttonName - button_name
 * @property {string} pageName - bookings list
 * @return {LogObject<bookingsBookingsListFilterClickParams>} LogObject<bookingsBookingsListFilterClickParams>
 */
export function bookingsBookingsListFilterClick(params) {
    return { evid: 435, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsResetToDefaultState' event (evid: 436)
 *
 * Event description: click on "Reset" in the BO
 *
 * @param {bookingsResetToDefaultStateParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - bookings_new_platform
 * @property {string} sectionName - -
 * @property {string} items - items restored to default
 * @property {string} pageName - -
 * @return {LogObject<bookingsResetToDefaultStateParams>} LogObject<bookingsResetToDefaultStateParams>
 */
export function bookingsResetToDefaultState(params) {
    return { evid: 436, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsListFilterApplyClick' event (evid: 437)
 *
 * Event description: user clicked on apply in bookings list filter Payment/Status
 *
 * @param {bookingsBookingsListFilterApplyClickParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} filterName - Payment, Status
 * @property {string} bookingsPlatform - bookings_new_platform
 * @property {string} filtered_content - comma separated values
 * @property {string} pageName - bookings list
 * @return {LogObject<bookingsBookingsListFilterApplyClickParams>} LogObject<bookingsBookingsListFilterApplyClickParams>
 */
export function bookingsBookingsListFilterApplyClick(params) {
    return { evid: 437, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffOpenWorkHoursModal' event (evid: 438)
 *
 * Event description: staff work hours modal was opened
 *
 * @param {bookingsStaffOpenWorkHoursModalParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} origin - staff page/service form - where the modal was opened from
 * @return {LogObject<bookingsStaffOpenWorkHoursModalParams>} LogObject<bookingsStaffOpenWorkHoursModalParams>
 */
export function bookingsStaffOpenWorkHoursModal(params) {
    return { evid: 438, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormAddNewBusinessLocationClick' event (evid: 439)
 *
 * Event description: click on CTA to add business location within service form (open OS modal)
 *
 * @param {bookingsServiceFormAddNewBusinessLocationClickParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {boolean} isEmptyState - true if no locations exist
 * @property {string} origin - where the CTA was clicked (service form,staff page)
 * @property {string} type - class/course
 * @return {LogObject<bookingsServiceFormAddNewBusinessLocationClickParams>} LogObject<bookingsServiceFormAddNewBusinessLocationClickParams>
 */
export function bookingsServiceFormAddNewBusinessLocationClick(params) {
    return { evid: 439, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppChooseLocationInMemberCalendar' event (evid: 440)
 *
 * Event description: choose a location from dropdown in oneapp owmer view
 *
 * @param {bookingsOneAppChooseLocationInMemberCalendarParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {GUID} locationGuid - selected location id (if specific location has been selected)
 * @property {string} locationName - selected location
 * @return {LogObject<bookingsOneAppChooseLocationInMemberCalendarParams>} LogObject<bookingsOneAppChooseLocationInMemberCalendarParams>
 */
export function bookingsOneAppChooseLocationInMemberCalendar(params) {
    return { evid: 440, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffWorkHoursModalOpen' event (evid: 441)
 *
 * Event description: work hours modal wwas opened
 *
 * @param {bookingsStaffWorkHoursModalOpenParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} origin - where the modal was opened staff page / service form
 * @property {string} type - service type, null if modal was opened on staff page
 * @return {LogObject<bookingsStaffWorkHoursModalOpenParams>} LogObject<bookingsStaffWorkHoursModalOpenParams>
 */
export function bookingsStaffWorkHoursModalOpen(params) {
    return { evid: 441, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffWorkHoursModalSave' event (evid: 442)
 *
 * Event description: work hours modal saved - Replaced with 1088 when dynamic availability  rollout started at Jan 2023
 *
 * @param {bookingsStaffWorkHoursModalSaveParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} origin - service form/staff page
 * @return {LogObject<bookingsStaffWorkHoursModalSaveParams>} LogObject<bookingsStaffWorkHoursModalSaveParams>
 */
export function bookingsStaffWorkHoursModalSave(params) {
    return { evid: 442, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffFilterByLocation' event (evid: 443)
 *
 * Event description: user filtered the hours by a location
 *
 * @param {bookingsStaffFilterByLocationParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @return {LogObject<bookingsStaffFilterByLocationParams>} LogObject<bookingsStaffFilterByLocationParams>
 */
export function bookingsStaffFilterByLocation(params) {
    return { evid: 443, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsFitnessIntent' event (evid: 444)
 *
 * Event description: fitness intent - based on template guid or ADI business name
 *
 * @param {bookingsFitnessIntentParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} origin - {adi_name, template}
 * @property {string} businessName - <adi business name> keep null if template
 * @property {GUID} template_id - <template id> keep null if adi
 * @return {LogObject<bookingsFitnessIntentParams>} LogObject<bookingsFitnessIntentParams>
 */
export function bookingsFitnessIntent(params) {
    return { evid: 444, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormEditSeoPanel' event (evid: 446)
 *
 * Event description: click on edit SEO settings from service form
 *
 * @param {bookingsServiceFormEditSeoPanelParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {boolean} success - success
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} type - service type
 * @return {LogObject<bookingsServiceFormEditSeoPanelParams>} LogObject<bookingsServiceFormEditSeoPanelParams>
 */
export function bookingsServiceFormEditSeoPanel(params) {
    return { evid: 446, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffSearchStaff' event (evid: 447)
 *
 * Event description: when owner searches for staff member
 *
 * @param {bookingsStaffSearchStaffParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} origin - service form
 * @property {string} type - type of service
 * @return {LogObject<bookingsStaffSearchStaffParams>} LogObject<bookingsStaffSearchStaffParams>
 */
export function bookingsStaffSearchStaff(params) {
    return { evid: 447, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffViewWorkHours' event (evid: 448)
 *
 * Event description: click to view service availability
 *
 * @param {bookingsStaffViewWorkHoursParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} origin - service form
 * @property {string} type - service type
 * @return {LogObject<bookingsStaffViewWorkHoursParams>} LogObject<bookingsStaffViewWorkHoursParams>
 */
export function bookingsStaffViewWorkHours(params) {
    return { evid: 448, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsWidgetSettingsServicesFilter' event (evid: 449)
 *
 * Event description: user chooses which services to display
 *
 * @param {bookingsWidgetSettingsServicesFilterParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} filterBy - service name/location
 * @property {string} location_choice - custom/business
 * @return {LogObject<bookingsWidgetSettingsServicesFilterParams>} LogObject<bookingsWidgetSettingsServicesFilterParams>
 */
export function bookingsWidgetSettingsServicesFilter(params) {
    return { evid: 449, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneappFilterAgenda' event (evid: 450)
 *
 * Event description: user filtered agenda by location
 *
 * @param {bookingsOneappFilterAgendaParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {boolean} filterApplied - true if filtered by a certain location
 * @return {LogObject<bookingsOneappFilterAgendaParams>} LogObject<bookingsOneappFilterAgendaParams>
 */
export function bookingsOneappFilterAgenda(params) {
    return { evid: 450, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneappMultilocationBlockingModalShown' event (evid: 451)
 *
 * Event description: blocking modal if the current version of the app doesnt support ML
 *
 * @param {bookingsOneappMultilocationBlockingModalShownParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} origin - where the modal was triggered
 * @return {LogObject<bookingsOneappMultilocationBlockingModalShownParams>} LogObject<bookingsOneappMultilocationBlockingModalShownParams>
 */
export function bookingsOneappMultilocationBlockingModalShown(params) {
    return { evid: 451, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRecurringSessionModalClickAction' event (evid: 453)
 *
 * Event description: user clicked edit/cancel from recurring sessions modal
 *
 * @param {bookingsRecurringSessionModalClickActionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} actionName - edit/cancel
 * @return {LogObject<bookingsRecurringSessionModalClickActionParams>} LogObject<bookingsRecurringSessionModalClickActionParams>
 */
export function bookingsRecurringSessionModalClickAction(params) {
    return { evid: 453, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsZoomIntegrationSuccess' event (evid: 454)
 *
 * Event description: sent when process of connecting to zoom is completed successfully
 *
 * @param {bookingsZoomIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsZoomIntegrationSuccessParams>} LogObject<bookingsZoomIntegrationSuccessParams>
 */
export function bookingsZoomIntegrationSuccess(params) {
    return { evid: 454, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSaveCustomVcLink' event (evid: 455)
 *
 * Event description: sent when a custom vc link is saved
 *
 * @param {bookingsSaveCustomVcLinkParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} description - link description
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} link_name - link entered by user
 * @property {boolean} notifyChecked - notify participants
 * @property {boolean} isPrivate - checked if a password is set
 * @property {string} action_type - {create/edit}
 * @return {LogObject<bookingsSaveCustomVcLinkParams>} LogObject<bookingsSaveCustomVcLinkParams>
 */
export function bookingsSaveCustomVcLink(params) {
    return { evid: 455, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormClickedBookingsLearnMore' event (evid: 456)
 *
 * Event description: click on 'learn more' in the connect VC
 *
 * @param {bookingsServiceFormClickedBookingsLearnMoreParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} referal_info - {service_form,choose_vc,default_account}
 * @property {string} type - {ind,class,course}
 * @property {GUID} service_id - {service_id}
 * @return {LogObject<bookingsServiceFormClickedBookingsLearnMoreParams>} LogObject<bookingsServiceFormClickedBookingsLearnMoreParams>
 */
export function bookingsServiceFormClickedBookingsLearnMore(params) {
    return { evid: 456, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormManageVcAccountsClicked' event (evid: 457)
 *
 * Event description: click on manage vc accounts
 *
 * @param {bookingsServiceFormManageVcAccountsClickedParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} type - {appointment,class,course}
 * @return {LogObject<bookingsServiceFormManageVcAccountsClickedParams>} LogObject<bookingsServiceFormManageVcAccountsClickedParams>
 */
export function bookingsServiceFormManageVcAccountsClicked(params) {
    return { evid: 457, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsProvisonedWithMl' event (evid: 458)
 *
 * Event description: bookings with multilocation was provisioned on site
 *
 * @param {bookingsProvisonedWithMlParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsProvisonedWithMlParams>} LogObject<bookingsProvisonedWithMlParams>
 */
export function bookingsProvisonedWithMl(params) {
    return { evid: 458, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarEditSessionGenerateNewVcLink' event (evid: 459)
 *
 * Event description: Sent when a user tries to edit VC link from the service page
 *
 * @param {bookingsCalendarEditSessionGenerateNewVcLinkParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - null if default account
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} current_platform - {zoom/custom link}
 * @return {LogObject<bookingsCalendarEditSessionGenerateNewVcLinkParams>} LogObject<bookingsCalendarEditSessionGenerateNewVcLinkParams>
 */
export function bookingsCalendarEditSessionGenerateNewVcLink(params) {
    return { evid: 459, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarSessionPopoverVcAction' event (evid: 460)
 *
 * Event description: sent when user performs an action in the session popover
 *
 * @param {bookingsCalendarSessionPopoverVcActionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - {calendar_popover, upcoming_sessions_widget}
 * @property {boolean} is_active - true if session has booked participants
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {generate,start,copy,share,change,email_participants,Remove,staff_link}
 * @property {string} link_type - current link type: {zoom,custom}
 * @property {string} type - {individual,group,course}
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsCalendarSessionPopoverVcActionParams>} LogObject<bookingsCalendarSessionPopoverVcActionParams>
 */
export function bookingsCalendarSessionPopoverVcAction(params) {
    return { evid: 460, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCancelServiceFormEditing' event (evid: 461)
 *
 * Event description: when a cancel is clicked by the user on the service form or the user leaves without saving
 *
 * @param {bookingsCancelServiceFormEditingParams} params - The parameters for this event
 * @property {GUID} businessId - business id
 * @property {boolean} accept_bookings_after_start - advanced settings // FALSE if toggle is off
 * @property {boolean} staffFilled - True = error raised
 * @property {boolean} headerImageChanged - True = header photo changed (add/replace/reorder)
 * @property {boolean} galleryImageChanged - True = gallery photo changed (add/replace/reorder)
 * @property {string} videoInfo - Null=not installed. for auto-save: "connection_intent"; If installed + regular save - "enabled" / "disabled"
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} form_source - default/form_id
 * @property {string} request_type - bookings approval {auto_approve, manually_approve}
 * @property {boolean} service_name_empty - True = error raised
 * @property {string} paymentType - {online, in person, online and in person, deposit}
 * @property {string} planType - {connection_intent, connect_success}
 * @property {boolean} headerImageEmpty - True = no header image
 * @property {boolean} is_visible - True = display on site
 * @property {number} numLocations - number of business locations the service is provided at
 * @property {string} save_type - {create_new, save_changes}
 * @property {boolean} service_description_empty - False = short description empty
 * @property {string} price_selection - {fixed, varies, no charge}
 * @property {number} image_in_gallery_count - number of images in gallery
 * @property {boolean} photo_empty - True = no image
 * @property {boolean} accept_online_bookings - advanced settings // FALSE if this a "no book flow"
 * @property {string} cancelType - {service_form_cancel_button, leave_without_saving}
 * @property {boolean} duration_empty - custom duration, True = error raised
 * @property {string} type - {single, multi}
 * @property {string} locationGuidList - list of business locations
 * @property {string} location_choice - {business, client, custom}
 * @property {boolean} isFirstDraft - If the first draft of a non saved service
 * @property {string} service_id - service id
 * @property {boolean} isTimeBuffer - True = using time buffer
 * @property {boolean} price_empty - True = error raised
 * @property {boolean} galleryImageEmpty - True = no gallery image(s)
 * @property {boolean} photo_changed - main photo changed (add/replace/reorder)
 * @return {LogObject<bookingsCancelServiceFormEditingParams>} LogObject<bookingsCancelServiceFormEditingParams>
 */
export function bookingsCancelServiceFormEditing(params) {
    return { evid: 461, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormPriceSectionInteraction' event (evid: 462)
 *
 * Event description: Service Form interaction with the following cta
 * "Price per Session" or
 * "Amount" or
 * "Pricing Plans (Memberships & Packages)"
 *
 * @param {bookingsServiceFormPriceSectionInteractionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} element - field/element that was changed
 * @property {boolean} isNewService - True = new unsaved service
 * @property {string} type - {single, multi, multi-course, unknown}
 * @property {string} serviceId - service_id
 * @property {string} value - The value selected in each element. For example in the element "Payment preferences" : the user can choose: ""entire amount online, "online deposit and the rest in person" etc.
 * @return {LogObject<bookingsServiceFormPriceSectionInteractionParams>} LogObject<bookingsServiceFormPriceSectionInteractionParams>
 */
export function bookingsServiceFormPriceSectionInteraction(params) {
    return { evid: 462, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicePageEditAccount' event (evid: 463)
 *
 * Event description: Sent when a user tries to edit VC link from the service page
 *
 * @param {bookingsServicePageEditAccountParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} is_default - true if service is currently connected to default account
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} current_platform - {zoom/custom link}
 * @property {string} type - {group/course/individual}
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsServicePageEditAccountParams>} LogObject<bookingsServicePageEditAccountParams>
 */
export function bookingsServicePageEditAccount(params) {
    return { evid: 463, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicePageDeleteOverrideLink' event (evid: 464)
 *
 * Event description: Sent when a user tries to edit VC link from the service page
 *
 * @param {bookingsServicePageDeleteOverrideLinkParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} current_platform - {zoom/custom link}
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsServicePageDeleteOverrideLinkParams>} LogObject<bookingsServicePageDeleteOverrideLinkParams>
 */
export function bookingsServicePageDeleteOverrideLink(params) {
    return { evid: 464, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsUpdateDefaultVcAccountConfirmation' event (evid: 467)
 *
 * Event description: Sent when a user is confirming that he really want to update the default account
 *
 * @param {bookingsUpdateDefaultVcAccountConfirmationParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsUpdateDefaultVcAccountConfirmationParams>} LogObject<bookingsUpdateDefaultVcAccountConfirmationParams>
 */
export function bookingsUpdateDefaultVcAccountConfirmation(params) {
    return { evid: 467, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffPageAddIndividualVcAccount' event (evid: 468)
 *
 * Event description: Sent when a user is adding a vc account to individual staff member
 *
 * @param {bookingsStaffPageAddIndividualVcAccountParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - 'staff id' field = resource id (isn't the same guid as 'staff member id')
 * Starting from Feb-2024 there is a new entity = staff member id, can be found in staff_members_ids. Null if default account
 * @property {string} staffMembersIds - staff_members_ids
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsStaffPageAddIndividualVcAccountParams>} LogObject<bookingsStaffPageAddIndividualVcAccountParams>
 */
export function bookingsStaffPageAddIndividualVcAccount(params) {
    return { evid: 468, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffPageDeleteVcAccount' event (evid: 469)
 *
 * Event description: Sent when a user tries to delete VC account from the staff page
 *
 * @param {bookingsStaffPageDeleteVcAccountParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {GUID} staffId - null if default account
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} current_platform - {zoom/custom link}
 * @return {LogObject<bookingsStaffPageDeleteVcAccountParams>} LogObject<bookingsStaffPageDeleteVcAccountParams>
 */
export function bookingsStaffPageDeleteVcAccount(params) {
    return { evid: 469, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsDeletingIndividualVcAccountConfirmation' event (evid: 470)
 *
 * Event description: Sent when a user is confirming that he really want to delete an individual VC account
 *
 * @param {bookingsDeletingIndividualVcAccountConfirmationParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} staff_id - staff_id
 * @return {LogObject<bookingsDeletingIndividualVcAccountConfirmationParams>} LogObject<bookingsDeletingIndividualVcAccountConfirmationParams>
 */
export function bookingsDeletingIndividualVcAccountConfirmation(params) {
    return { evid: 470, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsVcLinkSendEmailToParticipants' event (evid: 471)
 *
 * Event description: Sent when a user confirms send email to participants
 *
 * @param {bookingsVcLinkSendEmailToParticipantsParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsVcLinkSendEmailToParticipantsParams>} LogObject<bookingsVcLinkSendEmailToParticipantsParams>
 */
export function bookingsVcLinkSendEmailToParticipants(params) {
    return { evid: 471, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsVcLinkGenerateVcLinkModal' event (evid: 472)
 *
 * Event description: sent when a custom vc link is saved
 *
 * @param {bookingsVcLinkGenerateVcLinkModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} success - if link generation have succeed
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} current_platform - {zoom/custom link}
 * @property {boolean} notifyChecked - if to notify the participants
 * @property {string} action_type - {generate/restore}
 * @return {LogObject<bookingsVcLinkGenerateVcLinkModalParams>} LogObject<bookingsVcLinkGenerateVcLinkModalParams>
 */
export function bookingsVcLinkGenerateVcLinkModal(params) {
    return { evid: 472, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppUpcomingSessionsWidgetSettingsSave' event (evid: 475)
 *
 * Event description: click save setting of upcoming sessions widget
 *
 * @param {bookingsOneAppUpcomingSessionsWidgetSettingsSaveParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} removeSection - true if removed
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} emptyStateText - text for empty state
 * @property {string} showSectionTitleToggle - true/false
 * @property {boolean} showPreviousBookings - true / false
 * @property {string} sectionTitle - the title he chose
 * @property {boolean} showAvatars - t/f
 * @property {boolean} virtualSessionWithImage - true/false
 * @property {string} sectionLocationTab - home/other tab
 * @return {LogObject<bookingsOneAppUpcomingSessionsWidgetSettingsSaveParams>} LogObject<bookingsOneAppUpcomingSessionsWidgetSettingsSaveParams>
 */
export function bookingsOneAppUpcomingSessionsWidgetSettingsSave(params) {
    return { evid: 475, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsRemovingVcLinkFromSession' event (evid: 476)
 *
 * Event description: Sent when a user is removing a VC link from a session
 *
 * @param {bookingsRemovingVcLinkFromSessionParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsRemovingVcLinkFromSessionParams>} LogObject<bookingsRemovingVcLinkFromSessionParams>
 */
export function bookingsRemovingVcLinkFromSession(params) {
    return { evid: 476, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormClickOnManageLocations' event (evid: 477)
 *
 * Event description: click on locations modal
 *
 * @param {bookingsServiceFormClickOnManageLocationsParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} selection - {client/business/custom/learn_more/close}
 * @property {string} type - {appointment,class,course}
 * @property {string} location_choice - {client/business/custom}
 * @return {LogObject<bookingsServiceFormClickOnManageLocationsParams>} LogObject<bookingsServiceFormClickOnManageLocationsParams>
 */
export function bookingsServiceFormClickOnManageLocations(params) {
    return { evid: 477, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMoveSessionsWhenRemovingALocation' event (evid: 478)
 *
 * Event description: Multilocation - When a user is removing a location it needs to choose what to do with the scheduled sessions connected to this location. Sends when user is approving it's selection.
 *
 * @param {bookingsMoveSessionsWhenRemovingALocationParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {GUID} location_guid - guid of selected location if available
 * @property {string} loaction - name of selected location for the sessions
 * @property {boolean} notifyChecked - whether the notify participants is checked
 * @property {string} selection - move/keep
 * @property {string} location_choice - {business, client, custom}
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsMoveSessionsWhenRemovingALocationParams>} LogObject<bookingsMoveSessionsWhenRemovingALocationParams>
 */
export function bookingsMoveSessionsWhenRemovingALocation(params) {
    return { evid: 478, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsLoadHandleChangedLocationScreen' event (evid: 479)
 *
 * Event description: Multilocation - When a user is removing a location it needs to choose what to do with the scheduled sessions connected to this location. Sends when the modal is loaded.
 *
 * @param {bookingsLoadHandleChangedLocationScreenParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {string} state - biz location removed/location type changed/custom location - label changed / keep location
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsLoadHandleChangedLocationScreenParams>} LogObject<bookingsLoadHandleChangedLocationScreenParams>
 */
export function bookingsLoadHandleChangedLocationScreen(params) {
    return { evid: 479, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsManageLocationModalClickOnCta' event (evid: 480)
 *
 * Event description: Multilocation - sent when the user clicks on a cta in the 'Manage Locations' modal.
 *
 * @param {bookingsManageLocationModalClickOnCtaParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {number} numLocations - the length of businessLocationsList
 * @property {string} selection - {client/business/custom/learn_more/exit/cancel/save/check_location/uncheck_location/focus_custom_location}
 * @property {string} locationGuidList - list of the business location ids where the service is available
 * @property {string} location_choice - {business, client, custom}
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsManageLocationModalClickOnCtaParams>} LogObject<bookingsManageLocationModalClickOnCtaParams>
 */
export function bookingsManageLocationModalClickOnCta(params) {
    return { evid: 480, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'copyOfBookingsCompareServiceTypesClick' event (evid: 481)
 *
 * Event description: Click 'Learn More' on RWG multi-locations
 *
 * @param {copyOfBookingsCompareServiceTypesClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} linkUrl - link to KB
 * @property {string} location - {RWG Find Your Business,RWG Business Address, RWG Bookings Services}
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<copyOfBookingsCompareServiceTypesClickParams>} LogObject<copyOfBookingsCompareServiceTypesClickParams>
 */
export function copyOfBookingsCompareServiceTypesClick(params) {
    return { evid: 481, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsConfirmationEmailToggle' event (evid: 482)
 *
 * Event description: turn on\off confirmation email toggle
 *
 * @param {bookingsConfirmationEmailToggleParams} params - The parameters for this event
 * @property {GUID} businessId - bookings instance_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @property {string} action - {ON,OFF}
 * @return {LogObject<bookingsConfirmationEmailToggleParams>} LogObject<bookingsConfirmationEmailToggleParams>
 */
export function bookingsConfirmationEmailToggle(params) {
    return { evid: 482, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCancellationEmailToggle' event (evid: 483)
 *
 * Event description: turn on\off cancellation email toggle
 *
 * @param {bookingsCancellationEmailToggleParams} params - The parameters for this event
 * @property {GUID} businessId - bookings instance_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {GUID} msid - msid
 * @property {string} action - {ON,OFF}
 * @return {LogObject<bookingsCancellationEmailToggleParams>} LogObject<bookingsCancellationEmailToggleParams>
 */
export function bookingsCancellationEmailToggle(params) {
    return { evid: 483, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesDealerComponentMoreActionsClick' event (evid: 484)
 *
 * Event description: After click on 'more actions' on the dealer component on the services list
 *
 * @param {bookingsServicesDealerComponentMoreActionsClickParams} params - The parameters for this event
 * @property {GUID} businessId - businessId
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} clickType - {remove,show_later}
 * @property {GUID} offer_id - offer guid
 * @property {GUID} msid - msid
 * @return {LogObject<bookingsServicesDealerComponentMoreActionsClickParams>} LogObject<bookingsServicesDealerComponentMoreActionsClickParams>
 */
export function bookingsServicesDealerComponentMoreActionsClick(params) {
    return { evid: 484, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'copyOfBookingsCalendarRefreshClick' event (evid: 485)
 *
 * Event description: Clicking on the refresh button.
 *
 * @param {copyOfBookingsCalendarRefreshClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - Null if old platform
 * @return {LogObject<copyOfBookingsCalendarRefreshClickParams>} LogObject<copyOfBookingsCalendarRefreshClickParams>
 */
export function copyOfBookingsCalendarRefreshClick(params) {
    return { evid: 485, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesDealerComponentClick' event (evid: 486)
 *
 * Event description: Click on dealer component on the services list
 *
 * @param {bookingsServicesDealerComponentClickParams} params - The parameters for this event
 * @property {GUID} businessId - _
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - _
 * @property {string} target_url - the banner link url
 * @property {GUID} visitor_id - _
 * @property {string} clickType - {chevron_cta, more_actions}
 * @property {GUID} offer_id - offer guid
 * @property {GUID} contactId - _
 * @property {string} jsonData - json
 * @property {string} bannerLocationOnPage - {Left,Center,Right}
 * @return {LogObject<bookingsServicesDealerComponentClickParams>} LogObject<bookingsServicesDealerComponentClickParams>
 */
export function bookingsServicesDealerComponentClick(params) {
    return { evid: 486, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServicesDealerComponentView' event (evid: 487)
 *
 * Event description: Click on dealer component on the services list
 *
 * @param {bookingsServicesDealerComponentViewParams} params - The parameters for this event
 * @property {GUID} businessId - _
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - _
 * @property {string} target_url - the banner link url
 * @property {GUID} visitor_id - _
 * @property {GUID} offer_id - offer guid
 * @property {GUID} contactId - _
 * @property {string} jsonData - json
 * @property {string} bannerLocationOnPage - {Left,Center,Right}
 * @return {LogObject<bookingsServicesDealerComponentViewParams>} LogObject<bookingsServicesDealerComponentViewParams>
 */
export function bookingsServicesDealerComponentView(params) {
    return { evid: 487, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentsCollectPayment' event (evid: 488)
 *
 * Event description: Click on 'Charge now' in collect payments page. https://zpl.io/2976XLp
 *
 * @param {bookingsPaymentsCollectPaymentParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} serviceType - -
 * @property {string} referralInfo - -
 * @property {GUID} biToken - -
 * @property {string} staffId - staff_id
 * @property {number} price - -
 * @property {string} bookingsPlatform - -
 * @property {GUID} bookingId - -
 * @property {GUID} location_guid - location_id
 * @property {string} scheduleId - schedule_id
 * @property {string} sessionId - session_id
 * @property {GUID} contactId - -
 * @property {string} timeslot - timeslot
 * @property {string} paymentProvider - {paypal,stripe} NULL=paypal
 * @property {GUID} serviceId - -
 * @property {string} action - action
 * @return {LogObject<bookingsPaymentsCollectPaymentParams>} LogObject<bookingsPaymentsCollectPaymentParams>
 */
export function bookingsPaymentsCollectPayment(params) {
    return { evid: 488, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentsCancelPayment' event (evid: 489)
 *
 * Event description: https://zpl.io/2976XLp
 *
 * @param {bookingsPaymentsCancelPaymentParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} serviceType - -
 * @property {string} referralInfo - -
 * @property {GUID} biToken - -
 * @property {string} staffId - staff_id
 * @property {number} price - -
 * @property {string} bookingsPlatform - -
 * @property {GUID} bookingId - -
 * @property {GUID} location_guid - location_id
 * @property {string} scheduleId - schedule_id
 * @property {string} sessionId - session_id
 * @property {GUID} contactId - -
 * @property {string} timeslot - timeslot
 * @property {string} paymentProvider - -
 * @property {GUID} serviceId - -
 * @property {string} action - -
 * @return {LogObject<bookingsPaymentsCancelPaymentParams>} LogObject<bookingsPaymentsCancelPaymentParams>
 */
export function bookingsPaymentsCancelPayment(params) {
    return { evid: 489, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarBoPageLoaded' event (evid: 490)
 *
 * Event description: Sent each time the calendar BO page is rendered (non OAP)
 *
 * @param {bookingsCalendarBoPageLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - businessId
 * @property {number} numberOfStaff - the number of staff members shown in the calendar (=not filtered)
 * @property {string} viewMode - {Week/Day/Agenda/Staff}
 * @property {string} activeFilters - what filters are active {services, staff, location, session_availabilty, other}
 * @property {GUID} biToken - msid
 * @property {boolean} published - true if the site is published when load
 * @property {string} bookingsPlatform - bookings_platform
 * @property {number} numberOfAppointmentSessions - number of sessions shown where service type = appointment
 * @property {boolean} is_owner - _
 * @property {string} colorCode - what color coding is used for: staff/service/null
 * @property {boolean} waitlistEnabled - true if enabled
 * @property {number} numberOfCourseSessions - number of sessions shown where service type = course
 * @property {string} visibleRange - Calendar visible date range
 * @property {number} numberOfBookedSessions - number of booked sessions shown in calendar
 * @property {number} numberOfSessions - number of sessions shown in calendar
 * @property {string} premiumStatus - {business, website, none}
 * @property {number} numberOfClassSessions - number of sessions shown where service type = class
 * @property {GUID} bi_token - msid
 * @return {LogObject<bookingsCalendarBoPageLoadedParams>} LogObject<bookingsCalendarBoPageLoadedParams>
 */
export function bookingsCalendarBoPageLoaded(params) {
    return { evid: 490, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsPaymentLinkPaymentLinkRendering' event (evid: 491)
 *
 * Event description: indicates if payment link should be rendered
 *
 * @param {bookingsPaymentLinkPaymentLinkRenderingParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - ind/class
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} bookingId - booking_id
 * @property {GUID} invoiceId - invoice_id
 * @property {string} pageName - manage_participants, appointment_pop_over, contact_panel, full_contact_view
 * @property {string} contact_id - contact_id
 * @property {string} serviceId - service_id
 * @return {LogObject<bookingsPaymentLinkPaymentLinkRenderingParams>} LogObject<bookingsPaymentLinkPaymentLinkRenderingParams>
 */
export function bookingsPaymentLinkPaymentLinkRendering(params) {
    return { evid: 491, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBoEligibleToConnectPaymentToast' event (evid: 492)
 *
 * Event description: Sent after save service, if the user has business premium, the service is saved with online payment intent, and he currently has no online payment method connected.
 *
 * @param {bookingsBoEligibleToConnectPaymentToastParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - new_bookings_server
 * @return {LogObject<bookingsBoEligibleToConnectPaymentToastParams>} LogObject<bookingsBoEligibleToConnectPaymentToastParams>
 */
export function bookingsBoEligibleToConnectPaymentToast(params) {
    return { evid: 492, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOneAppPerformanceTrackerWidgetSettingsSave' event (evid: 493)
 *
 * Event description: click save setting of performance tracker  widget
 *
 * @param {bookingsOneAppPerformanceTrackerWidgetSettingsSaveParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {boolean} showTotalSessions - true / false
 * @property {number} defaultGoal - default weekly goal
 * @property {boolean} removeSection - true if removed
 * @property {GUID} biToken - []
 * @property {boolean} showHealthActivity - t/f
 * @property {string} bookingsPlatform - []
 * @property {string} showSectionTitleToggle - true/false
 * @property {string} sectionTitle - the title he chose
 * @property {string} saveType - add/edit
 * @property {string} sectionLocationTab - home/other tab
 * @return {LogObject<bookingsOneAppPerformanceTrackerWidgetSettingsSaveParams>} LogObject<bookingsOneAppPerformanceTrackerWidgetSettingsSaveParams>
 */
export function bookingsOneAppPerformanceTrackerWidgetSettingsSave(params) {
    return { evid: 493, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormChange' event (evid: 494)
 *
 * Event description: any change in service form
 *
 * @param {bookingsServiceFormChangeParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - service_list, service_form
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {GUID} policyId - policy_id
 * @property {string} type - {ind, class, course}
 * @property {string} change_action - name of action
 * @property {string} priceSelection - Price Selection
 * @property {string} origin - origin or the action
 * @return {LogObject<bookingsServiceFormChangeParams>} LogObject<bookingsServiceFormChangeParams>
 */
export function bookingsServiceFormChange(params) {
    return { evid: 494, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSendWaiverViaEmailClick' event (evid: 495)
 *
 * Event description: Click on "Send Waiver via Email"
 *
 * @param {bookingsSendWaiverViaEmailClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {number} numberOfParticipants - Amount of participants in session at the time of click
 * @property {GUID} session_id - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {number} numberOfEmailsSent - Amount of contacts that the waiver was sent to
 * @property {string} origin - Click origin
 * @property {string} serviceId - -
 * @return {LogObject<bookingsSendWaiverViaEmailClickParams>} LogObject<bookingsSendWaiverViaEmailClickParams>
 */
export function bookingsSendWaiverViaEmailClick(params) {
    return { evid: 495, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffManagePermissionsClick' event (evid: 496)
 *
 * Event description: go to roles & permissions page
 *
 * @param {bookingsStaffManagePermissionsClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {GUID} staffId - 'staff id' field = resource id (isn't the same guid as 'staff member id')
 * Starting from Feb-2024 there is a new entity = staff member id, can be found in staff_members_ids
 * @property {string} staffMembersIds - staff_members_ids
 * @property {string} bookingsPlatform - -
 * @return {LogObject<bookingsStaffManagePermissionsClickParams>} LogObject<bookingsStaffManagePermissionsClickParams>
 */
export function bookingsStaffManagePermissionsClick(params) {
    return { evid: 496, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMemberAppClickFitBanner' event (evid: 498)
 *
 * Event description: When owner clicks the Fit banner in member app to continue
 *
 * @param {bookingsMemberAppClickFitBannerParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsMemberAppClickFitBannerParams>} LogObject<bookingsMemberAppClickFitBannerParams>
 */
export function bookingsMemberAppClickFitBanner(params) {
    return { evid: 498, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarPopoverOpenDropdownClick' event (evid: 499)
 *
 * Event description: dropdown click
 *
 * @param {bookingsCalendarPopoverOpenDropdownClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {GUID} bookingId - -
 * @property {string} referal_info - {cancel button, edit button}
 * @property {string} sessionId - -
 * @property {string} type - class/course/individual
 * @property {string} serviceId - -
 * @return {LogObject<bookingsCalendarPopoverOpenDropdownClickParams>} LogObject<bookingsCalendarPopoverOpenDropdownClickParams>
 */
export function bookingsCalendarPopoverOpenDropdownClick(params) {
    return { evid: 499, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileAppsOpenPendingApprovalSessionsList' event (evid: 609)
 *
 * Event description: Bookings > Owner Mobile App >  Sessions list > open pending approval.
 *
 * @param {bookingsMobileAppsOpenPendingApprovalSessionsListParams} params - The parameters for this event
 * @property {GUID} businessId - --
 * @property {number} numOfPendingBookings - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @return {LogObject<bookingsMobileAppsOpenPendingApprovalSessionsListParams>} LogObject<bookingsMobileAppsOpenPendingApprovalSessionsListParams>
 */
export function bookingsMobileAppsOpenPendingApprovalSessionsList(params) {
    return { evid: 609, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSyncCalendarModalClick' event (evid: 610)
 *
 * Event description: sent for every click in sync calendar modal
 *
 * @param {bookingsSyncCalendarModalClickParams} params - The parameters for this event
 * @property {GUID} businessId - --
 * @property {GUID} biToken - --
 * @property {GUID} staffId - --
 * @property {string} bookingsPlatform - --
 * @property {string} selectedCalendar - google/iCal/Microsoft/Office
 * @property {string} referral_info - {staff, calendar}
 * @property {string} selection - {sync, sync_selected_resource ,learn_more, resend, unsync, open_resource_drop_down, choose_resource, add_new_staff,exit,try_again,link_and_sync,open_error_resolution_menu}
 * @property {GUID} scheduleId - --
 * @return {LogObject<bookingsSyncCalendarModalClickParams>} LogObject<bookingsSyncCalendarModalClickParams>
 */
export function bookingsSyncCalendarModalClick(params) {
    return { evid: 610, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSyncCalendarSendVerificationFail' event (evid: 611)
 *
 * Event description: sync calendar request failed to sent by email
 *
 * @param {bookingsSyncCalendarSendVerificationFailParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} linkedResourceId - -
 * @property {string} errorMessage - Send Sync Invitation Email Failure - Error Reason: Link Failed with error {e}, Send Sync Invitation Email Failure - Error Reason: getSyncStatusByResourceId Failed with error {e}, Send Sync Invitation Email Failure - Error Reason: {e}.
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {string} calendarType - iCal/Google
 * @return {LogObject<bookingsSyncCalendarSendVerificationFailParams>} LogObject<bookingsSyncCalendarSendVerificationFailParams>
 */
export function bookingsSyncCalendarSendVerificationFail(params) {
    return { evid: 611, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsLinkToResourceSuccessOrFailure' event (evid: 612)
 *
 * Event description: link to a resource can be in 2 sources - the providers list modal from the calendar and invite modal from staff
 *
 * @param {bookingsLinkToResourceSuccessOrFailureParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} source - providers_list_modal, invite_modal
 * @property {string} errorMessage - -
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {GUID} linkedUuid - the user id of the user that is linked to staff. not always equal to the one who send the link request
 * @property {boolean} isSuccess - -
 * @return {LogObject<bookingsLinkToResourceSuccessOrFailureParams>} LogObject<bookingsLinkToResourceSuccessOrFailureParams>
 */
export function bookingsLinkToResourceSuccessOrFailure(params) {
    return { evid: 612, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffSyncInviteModalClick' event (evid: 614)
 *
 * Event description: sync calendar invite modal, sending an invite using inbox.
 *
 * @param {bookingsStaffSyncInviteModalClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id of the resource that the invite is sent to
 * @property {string} bookingsPlatform - -
 * @property {string} clickType - {cancel, exit, send, message focus}
 * @return {LogObject<bookingsStaffSyncInviteModalClickParams>} LogObject<bookingsStaffSyncInviteModalClickParams>
 */
export function bookingsStaffSyncInviteModalClick(params) {
    return { evid: 614, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileAppsAgendaDatePickerClick' event (evid: 615)
 *
 * Event description: user chooses dates using date picker
 *
 * @param {bookingsMobileAppsAgendaDatePickerClickParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {string} selectedDate - --
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} arrowClicked - right/left
 * @property {string} layout - weekly/monthly
 * @return {LogObject<bookingsMobileAppsAgendaDatePickerClickParams>} LogObject<bookingsMobileAppsAgendaDatePickerClickParams>
 */
export function bookingsMobileAppsAgendaDatePickerClick(params) {
    return { evid: 615, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileAppsAgendaCtaClick' event (evid: 616)
 *
 * Event description: user clicks cta
 *
 * @param {bookingsMobileAppsAgendaCtaClickParams} params - The parameters for this event
 * @property {GUID} businessId - []
 * @property {string} selectedView - agenda/ day_view/3_days_view
 * @property {GUID} biToken - []
 * @property {string} bookingsPlatform - []
 * @property {string} selection - {add_session, location, date_picker_drag,course_more_actions,class_more_actions, appointment_more_actions}
 * @return {LogObject<bookingsMobileAppsAgendaCtaClickParams>} LogObject<bookingsMobileAppsAgendaCtaClickParams>
 */
export function bookingsMobileAppsAgendaCtaClick(params) {
    return { evid: 616, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsManageParticipantsPageHoverParticipant' event (evid: 617)
 *
 * Event description: hover in BO manage participants page
 *
 * @param {bookingsManageParticipantsPageHoverParticipantParams} params - The parameters for this event
 * @property {GUID} businessId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} waiverStatus - undefined, signed, not_signed
 * @property {string} bookingsPlatform - bookings_new_platform
 * @property {GUID} sessionId - --
 * @property {string} contactId - {contact_id}
 * @property {string} type - class/course/appointment
 * @property {string} serviceId - {service_id}
 * @return {LogObject<bookingsManageParticipantsPageHoverParticipantParams>} LogObject<bookingsManageParticipantsPageHoverParticipantParams>
 */
export function bookingsManageParticipantsPageHoverParticipant(params) {
    return { evid: 617, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsSyncCalendarLinkToResourceFailure' event (evid: 622)
 *
 * Event description: link to a resource before sync request
 *
 * @param {bookingsSyncCalendarLinkToResourceFailureParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} source - providers_list_modal, invite_modal
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {GUID} linkedUuid - the user id of the user that is linked to staff. not always equal to the one who send the link request
 * @return {LogObject<bookingsSyncCalendarLinkToResourceFailureParams>} LogObject<bookingsSyncCalendarLinkToResourceFailureParams>
 */
export function bookingsSyncCalendarLinkToResourceFailure(params) {
    return { evid: 622, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsUnsyncCalendarRequestSendInviteSuccessFailure' event (evid: 623)
 *
 * Event description: unsync request
 *
 * @param {bookingsUnsyncCalendarRequestSendInviteSuccessFailureParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} linkedResourceId - -
 * @property {boolean} success - T if success F if failure
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {string} calendarType - null=Google
 * @return {LogObject<bookingsUnsyncCalendarRequestSendInviteSuccessFailureParams>} LogObject<bookingsUnsyncCalendarRequestSendInviteSuccessFailureParams>
 */
export function bookingsUnsyncCalendarRequestSendInviteSuccessFailure(params) {
    return { evid: 623, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileAppsSpecificParticipantModalClick' event (evid: 624)
 *
 * Event description: Tap on a participant from the "manage participants" page, and then this modal will open. This event will be sent with every click in the modal.
 *
 * @param {bookingsMobileAppsSpecificParticipantModalClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - Mark as No-Show / View Contact / View Booking Details / View Order /Remove from Session/Mark_as_paid/Mark_as_fully_paid/sell_plan
 * @property {string} sessionId - --
 * @property {string} contactId - contact_id
 * @property {GUID} participant_id - participant member Id
 * @property {string} type - service type (class, course, appointment)
 * @property {GUID} service_id - service_id
 * @return {LogObject<bookingsMobileAppsSpecificParticipantModalClickParams>} LogObject<bookingsMobileAppsSpecificParticipantModalClickParams>
 */
export function bookingsMobileAppsSpecificParticipantModalClick(params) {
    return { evid: 624, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffUnlinkResource' event (evid: 625)
 *
 * Event description: staff card --> Unlink resource
 *
 * @param {bookingsStaffUnlinkResourceParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {GUID} staffId - -
 * @property {string} bookingsPlatform - -
 * @property {boolean} isSuccess - T for Success F for failure
 * @return {LogObject<bookingsStaffUnlinkResourceParams>} LogObject<bookingsStaffUnlinkResourceParams>
 */
export function bookingsStaffUnlinkResource(params) {
    return { evid: 625, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffDisconnectStaffCalendarSuccessFailure' event (evid: 627)
 *
 * Event description: link to a resource before sync request
 *
 * @param {bookingsStaffDisconnectStaffCalendarSuccessFailureParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {boolean} isSuccess - --
 * @property {boolean} isResourceLinkedToUserInSession - is the resource is unsyncing himself
 * @return {LogObject<bookingsStaffDisconnectStaffCalendarSuccessFailureParams>} LogObject<bookingsStaffDisconnectStaffCalendarSuccessFailureParams>
 */
export function bookingsStaffDisconnectStaffCalendarSuccessFailure(params) {
    return { evid: 627, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffUnlinkResourceClick' event (evid: 628)
 *
 * Event description: staff card --> Unlink resource > click to unlink
 *
 * @param {bookingsStaffUnlinkResourceClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} referralInfo - more_actions/staff_card
 * @property {GUID} biToken - -
 * @property {GUID} staffId - -
 * @property {string} bookingsPlatform - -
 * @return {LogObject<bookingsStaffUnlinkResourceClickParams>} LogObject<bookingsStaffUnlinkResourceClickParams>
 */
export function bookingsStaffUnlinkResourceClick(params) {
    return { evid: 628, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormLoadSaveServiceModal' event (evid: 629)
 *
 * Event description: when a user have edited the service details in the service form, and wants to move to a different page / view, a modal pops out that asks for the use to save a service. This event describes load of this modal.
 *
 * @param {bookingsServiceFormLoadSaveServiceModalParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} origin - the action in the service form the triggered the modal
 * @property {string} type - {ind, class, course}
 * @return {LogObject<bookingsServiceFormLoadSaveServiceModalParams>} LogObject<bookingsServiceFormLoadSaveServiceModalParams>
 */
export function bookingsServiceFormLoadSaveServiceModal(params) {
    return { evid: 629, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsServiceFormLoadLocationSettingsModal' event (evid: 630)
 *
 * Event description: this event describes load of location settings modal from the service form. This is the modal that is loaded when the user wants to edit the location settings for a specific service.
 *
 * @param {bookingsServiceFormLoadLocationSettingsModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - -
 * @property {string} type - type
 * @return {LogObject<bookingsServiceFormLoadLocationSettingsModalParams>} LogObject<bookingsServiceFormLoadLocationSettingsModalParams>
 */
export function bookingsServiceFormLoadLocationSettingsModal(params) {
    return { evid: 630, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsConnectExternalCalendarByOauthSuccessFailure' event (evid: 633)
 *
 * Event description: When the user clicks sync by OAuth on the 'external calendar' modal - only Google for now, iCal&Outlook require credentials (16:644).  there is a server event (16:1000) indicates sync is successful
 *
 * @param {bookingsConnectExternalCalendarByOauthSuccessFailureParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {boolean} success - T if success F if failure
 * @property {string} errorMessage - -
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {string} scheduleId - -
 * @property {string} providerAppDefId - -
 * @property {string} calendarType - google
 * @return {LogObject<bookingsConnectExternalCalendarByOauthSuccessFailureParams>} LogObject<bookingsConnectExternalCalendarByOauthSuccessFailureParams>
 */
export function bookingsConnectExternalCalendarByOauthSuccessFailure(params) {
    return { evid: 633, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsZoomV2OpenChooseVcModal' event (evid: 634)
 *
 * Event description: open 'choose VC modal'
 *
 * @param {bookingsZoomV2OpenChooseVcModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - video conference on service fiorm= "service_video" / {staff} / NULL=payments
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - null
 * @return {LogObject<bookingsZoomV2OpenChooseVcModalParams>} LogObject<bookingsZoomV2OpenChooseVcModalParams>
 */
export function bookingsZoomV2OpenChooseVcModal(params) {
    return { evid: 634, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsAddParticipantAddNewContactFailure' event (evid: 637)
 *
 * Event description: When a user wants to add a new participant that don't have a contact. and when adding a contact the it fail to update the contacts mail.
 *
 * @param {bookingsAddParticipantAddNewContactFailureParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} errorReason - error_reason
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<bookingsAddParticipantAddNewContactFailureParams>} LogObject<bookingsAddParticipantAddNewContactFailureParams>
 */
export function bookingsAddParticipantAddNewContactFailure(params) {
    return { evid: 637, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsVideoTutorialsClick' event (evid: 638)
 *
 * Event description: Click on action related to 'How to' videos
 *
 * @param {bookingsVideoTutorialsClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} videoId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} selection - main_play_video/main_watch_now/accordion_1_play/accordion_2_play/accordion_3_play/see_all_extend/see_all_collapse/close_video_modal
 * @property {string} pageName - service_page/video_modal
 * @property {string} serviceId - -
 * @return {LogObject<bookingsVideoTutorialsClickParams>} LogObject<bookingsVideoTutorialsClickParams>
 */
export function bookingsVideoTutorialsClick(params) {
    return { evid: 638, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsFunnelUpgradeModalLoad' event (evid: 639)
 *
 * Event description: when the user gets the upgrade modal opened due to limitations (sync calendar, add staff member [in bookings anywhere], etc.)
 *
 * @param {bookingsFunnelUpgradeModalLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} referralInfo - the page name where the modal is opened
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {string} action - load / close / upgrade / second_close / second_refresh
 * @property {string} trigger - the action that triggered the upgrade modal: sync calendar / save staff member / save service
 * @return {LogObject<bookingsFunnelUpgradeModalLoadParams>} LogObject<bookingsFunnelUpgradeModalLoadParams>
 */
export function bookingsFunnelUpgradeModalLoad(params) {
    return { evid: 639, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileLogEvent' event (evid: 641)
 *
 * Event description: bookings > mobile log event (owner side)
 *
 * @param {bookingsMobileLogEventParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - null
 * @property {string} message - the message
 * @property {string} severity - {error/warning/debug}
 * @return {LogObject<bookingsMobileLogEventParams>} LogObject<bookingsMobileLogEventParams>
 */
export function bookingsMobileLogEvent(params) {
    return { evid: 641, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileAppsNotifyParticipantsModal' event (evid: 643)
 *
 * Event description: Bookings > mobile apps > notify participants modal.
 *
 * @param {bookingsMobileAppsNotifyParticipantsModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} sessionId - -
 * @property {string} actionName - load/notify/dont_notify
 * @property {string} serviceId - -
 * @return {LogObject<bookingsMobileAppsNotifyParticipantsModalParams>} LogObject<bookingsMobileAppsNotifyParticipantsModalParams>
 */
export function bookingsMobileAppsNotifyParticipantsModal(params) {
    return { evid: 643, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsConnectExternalCalendarByCredentialsSuccessFailure' event (evid: 644)
 *
 * Event description: When the user click sync by credentials on the 'external calendar' modal - only iCal&Outlook for now, Google requires OAuth (16:633)
 *
 * @param {bookingsConnectExternalCalendarByCredentialsSuccessFailureParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {boolean} success - success
 * @property {string} errorMessage - error_message
 * @property {GUID} biToken - -
 * @property {GUID} staffId - staff_id
 * @property {string} bookingsPlatform - -
 * @property {string} scheduleId - -
 * @property {string} providerAppDefId - -
 * @property {string} calendarType - iCal, outlook
 * @return {LogObject<bookingsConnectExternalCalendarByCredentialsSuccessFailureParams>} LogObject<bookingsConnectExternalCalendarByCredentialsSuccessFailureParams>
 */
export function bookingsConnectExternalCalendarByCredentialsSuccessFailure(params) {
    return { evid: 644, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsUpdateBookingsAppModalLoad' event (evid: 647)
 *
 * Event description: When the migration modal is loading offering user to update Wix Bookings app
 *
 * @param {bookingsUpdateBookingsAppModalLoadParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} pageName - Which page the user is at when modal is loaded
 * @return {LogObject<bookingsUpdateBookingsAppModalLoadParams>} LogObject<bookingsUpdateBookingsAppModalLoadParams>
 */
export function bookingsUpdateBookingsAppModalLoad(params) {
    return { evid: 647, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsUpdateBookingsAppModalClick' event (evid: 648)
 *
 * Event description: When the user clicks the migration modal that is offering user to update the Wix Bookings app
 *
 * @param {bookingsUpdateBookingsAppModalClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - {update,ask_another_time,help,exit}
 * @return {LogObject<bookingsUpdateBookingsAppModalClickParams>} LogObject<bookingsUpdateBookingsAppModalClickParams>
 */
export function bookingsUpdateBookingsAppModalClick(params) {
    return { evid: 648, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsUpdateBookingsAppSuccessFailure' event (evid: 649)
 *
 * Event description: When a user ask to update with the migration modal success/failure
 *
 * @param {bookingsUpdateBookingsAppSuccessFailureParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {boolean} success - T/F
 * @property {string} errorMessage - in case of failure
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @return {LogObject<bookingsUpdateBookingsAppSuccessFailureParams>} LogObject<bookingsUpdateBookingsAppSuccessFailureParams>
 */
export function bookingsUpdateBookingsAppSuccessFailure(params) {
    return { evid: 649, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffListViewDealerComponent' event (evid: 650)
 *
 * Event description: View the dealer widget in the staff list
 *
 * @param {bookingsStaffListViewDealerComponentParams} params - The parameters for this event
 * @property {GUID} businessId - _
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - _
 * @property {GUID} offer_id - offer guid
 * @return {LogObject<bookingsStaffListViewDealerComponentParams>} LogObject<bookingsStaffListViewDealerComponentParams>
 */
export function bookingsStaffListViewDealerComponent(params) {
    return { evid: 650, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsStaffListClickDealerComponent' event (evid: 651)
 *
 * Event description: Click the dealer widget in the staff list
 *
 * @param {bookingsStaffListClickDealerComponentParams} params - The parameters for this event
 * @property {GUID} businessId - _
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - _
 * @property {GUID} offer_id - offer guid
 * @property {string} ctaUrl - the url to which the cta refers to
 * @return {LogObject<bookingsStaffListClickDealerComponentParams>} LogObject<bookingsStaffListClickDealerComponentParams>
 */
export function bookingsStaffListClickDealerComponent(params) {
    return { evid: 651, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsOpenOrderPageClick' event (evid: 652)
 *
 * Event description: click on open order page from several different entry points (for web and mobile apps)
 *
 * @param {bookingsOpenOrderPageClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} serviceType - {class,course,appointment}
 * @property {string} location - {appointment_popover,contact_panel,contacts_bookings_tab,manage_participants,session_view_owner_app,manage_participants_owner_app}
 * @property {GUID} biToken - msid
 * @property {GUID} orderId - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} sessionId - -
 * @property {string} contactId - the id of the contact that book
 * @property {string} serviceId - -
 * @return {LogObject<bookingsOpenOrderPageClickParams>} LogObject<bookingsOpenOrderPageClickParams>
 */
export function bookingsOpenOrderPageClick(params) {
    return { evid: 652, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileAppsAgenda3DotsModal' event (evid: 653)
 *
 * Event description: Bookings --> mobile apps --> agenda --> 3 dots modal (from schedule view) or tap on the session in the day view.
 * click inside that modal, and clicks inside modals that opened when clicking on these modal elements like "are you share to cancel?" (this modal can be opened per session in order to different actions regarding this session)
 *
 * @param {bookingsMobileAppsAgenda3DotsModalParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {string} selectedView - agenda / day_view/3_days_view
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - platform
 * @property {string} selection - edit, manage_participants, invite, cancel, call
 * @property {string} sessionId - session_id
 * @property {string} type - service_type
 * @property {GUID} service_id - service_id
 * @property {string} refferal_info - agenda_more_actions
 * @return {LogObject<bookingsMobileAppsAgenda3DotsModalParams>} LogObject<bookingsMobileAppsAgenda3DotsModalParams>
 */
export function bookingsMobileAppsAgenda3DotsModal(params) {
    return { evid: 653, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBoCalendarClick' event (evid: 654)
 *
 * Event description: Click on the BO calendar
 *
 * @param {bookingsBoCalendarClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - -
 * @property {string} timezone - -
 * @property {string} bookingsPlatform - -
 * @property {string} element - name of the element inside the component that was clicked
 * @property {string} properties - when session_item click and session_id is empty it's means it's an external session
 * @property {string} filteredValues - all of the values of the filters checked at the time of the click
 * @property {string} layout - weekly/daily/daily_agenda/staff_time_grid. please notice , the layout in this field is the layout that is shown before the click. If we clicked on a different layout it will show the one before and the new one will be shown in properties
 * @property {string} selectedRange - the dates range the calendar shows when clicked
 * @property {string} component - name of the component clicked. for example - sidebar
 * @return {LogObject<bookingsBoCalendarClickParams>} LogObject<bookingsBoCalendarClickParams>
 */
export function bookingsBoCalendarClick(params) {
    return { evid: 654, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsManageConnectionModalUpdateSyncConfigRequestSuccessFailure' event (evid: 656)
 *
 * Event description: When user ask to update his sync configs in sync connection modal. as for H1 2022 not relevant for Google
 *
 * @param {bookingsManageConnectionModalUpdateSyncConfigRequestSuccessFailureParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} exportedCalendarId - exported_calendar_id
 * @property {boolean} success - success
 * @property {string} errorMessage - error_message
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} importedCalendarsList - the calendars ids the user decided to import.
 * @property {boolean} importEnabled - -
 * @property {string} connection - all the connection data.
 * @property {boolean} exportEnabled - -
 * @property {string} calendarType - iCal/Google/Outlook/365
 * @return {LogObject<bookingsManageConnectionModalUpdateSyncConfigRequestSuccessFailureParams>} LogObject<bookingsManageConnectionModalUpdateSyncConfigRequestSuccessFailureParams>
 */
export function bookingsManageConnectionModalUpdateSyncConfigRequestSuccessFailure(params) {
    return { evid: 656, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsMobileAppsOwnerAppCalendarClick' event (evid: 658)
 *
 * Event description: Generic event for Clicks on the calendar in the Owner App
 * you can see the event of click on BO calendar on the web here-
 * event 16:654 -
 * https://bo.wix.com/bi-catalog-webapp/#/sources/16/events/654?artifactId=wix.boost.users.artifact.id
 *
 * @param {bookingsMobileAppsOwnerAppCalendarClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {GUID} biToken - -
 * @property {string} timezone - -
 * @property {string} bookingsPlatform - Owner App
 * @property {string} element - name of the element inside the component that was clicked
 * @property {string} properties - when session_item click and session_id is empty it's means it's an external session.
 * @property {string} filteredValues - all of the values of the filters checked at the time of the click
 * @property {string} layout - weekly/daily/daily_agenda/staff_time_grid. please notice , the layout in this field is the layout that is shown before the click. If we clicked on a different layout it will show the one before and the new one will be shown in properties
 * @property {string} selectedRange - the dates range the calendar shows when clicked
 * @property {string} component - name of the component clicked. for example - top_meue\calnedar\calendar view settings modal
 * @return {LogObject<bookingsMobileAppsOwnerAppCalendarClickParams>} LogObject<bookingsMobileAppsOwnerAppCalendarClickParams>
 */
export function bookingsMobileAppsOwnerAppCalendarClick(params) {
    return { evid: 658, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingManagerClick' event (evid: 660)
 *
 * Event description: Click on the Bookings Manager smart panel
 *
 * @param {bookingsBookingManagerClickParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {string} serviceType - type
 * @property {DateTime} startTime - session start time
 * @property {GUID} biToken - -
 * @property {string} timezone - timezone
 * @property {string} bookingsPlatform - -
 * @property {string} clickType - name of the CTA clicked
 * @property {DateTime} endTime - end_time
 * @property {string} widgetName - widget_name
 * @property {string} itemType - in recent_activity widget - the type of the item that clicked
 * @property {string} sessionId - session_id
 * @property {string} contactId - when click on purchase item in recent_activity widget
 * @property {string} layout - layout
 * @property {string} serviceId - -
 * @return {LogObject<bookingsBookingManagerClickParams>} LogObject<bookingsBookingManagerClickParams>
 */
export function bookingsBookingManagerClick(params) {
    return { evid: 660, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsManagerSuggestionsDealerComponentLoad' event (evid: 661)
 *
 * Event description: dealer component on the suggestions widget loaded
 *
 * @param {bookingsBookingsManagerSuggestionsDealerComponentLoadParams} params - The parameters for this event
 * @property {GUID} businessId - _
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} target_url - the banner link url
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} offer_id - offer guid
 * @property {GUID} contactId - contact_id
 * @property {string} jsonData - json
 * @property {string} bannerLocationOnPage - 1-5
 * @return {LogObject<bookingsBookingsManagerSuggestionsDealerComponentLoadParams>} LogObject<bookingsBookingsManagerSuggestionsDealerComponentLoadParams>
 */
export function bookingsBookingsManagerSuggestionsDealerComponentLoad(params) {
    return { evid: 661, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsManagerSuggestionsDealerComponentClick' event (evid: 662)
 *
 * Event description: dealer component on the suggestions widget clicked
 *
 * @param {bookingsBookingsManagerSuggestionsDealerComponentClickParams} params - The parameters for this event
 * @property {GUID} businessId - _
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - _
 * @property {string} target_url - the banner link url
 * @property {GUID} visitor_id - _
 * @property {string} clickType - {main_cta, more_actions, show_me_later, dismiss, right_arrow, left_arrow}
 * @property {GUID} offer_id - offer guid
 * @property {GUID} contactId - _
 * @property {string} jsonData - json
 * @property {string} bannerLocationOnPage - 1-5
 * @return {LogObject<bookingsBookingsManagerSuggestionsDealerComponentClickParams>} LogObject<bookingsBookingsManagerSuggestionsDealerComponentClickParams>
 */
export function bookingsBookingsManagerSuggestionsDealerComponentClick(params) {
    return { evid: 662, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsBookingsManagerWidgetLoaded' event (evid: 663)
 *
 * Event description: widget loaded in the bookings manager (right panel)
 *
 * @param {bookingsBookingsManagerWidgetLoadedParams} params - The parameters for this event
 * @property {GUID} businessId - -
 * @property {boolean} success - boolean, TRUE if loaded, FALSE if error
 * @property {GUID} biToken - -
 * @property {string} bookingsPlatform - -
 * @property {number} visibleItems - number of items shown to the user
 * @property {string} recentActivityTypes - recent_activity_types
 * @property {string} widgetName - {pending_approval, waitlist, recent_activity, upcoming_sessions, suggestions}
 * @property {number} loadingTime - time from widget render to loading
 * @property {number} numOfItems - number of items in this widget backlog (including visible)
 * @return {LogObject<bookingsBookingsManagerWidgetLoadedParams>} LogObject<bookingsBookingsManagerWidgetLoadedParams>
 */
export function bookingsBookingsManagerWidgetLoaded(params) {
    return { evid: 663, src: 16, endpoint: 'wixboost-users', params: params };
}
/**
 * A function to create a log object for the 'bookingsCalendarColorSettingsClick' event (evid: 664)
 *
 * Event description: Bookings > Calendar > Color Settings > Click.
 *
 * @param {bookingsCalendarColorSettingsClickParams} params - The parameters for this event
 * @property {GUID} businessId - business_id
 * @property {GUID} biToken - msid
 * @property {string} bookingsPlatform - bookings_platform
 * @property {string} selection - color_by_services / color_by_staff / save / exit / cancel
 * @return {LogObject<bookingsCalendarColorSettingsClickParams>} LogObject<bookingsCalendarColorSettingsClickParams>
 */
export function bookingsCalendarColorSettingsClick(params) {
    return { evid: 664, src: 16, endpoint: 'wixboost-users', params: params };
}
//# sourceMappingURL=index.js.map